// @ts-nocheck
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any };
  /** The built-in `Decimal` scalar type. */
  Decimal: { input: any; output: any };
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: any; output: any };
};

export type AccessLevels =
  | 'ACCOUNT'
  | 'BILLING_GROUP'
  | 'SECURE_CONNECT'
  | 'VENDOR'
  | 'VENDOR_FINANCIAL';

export type AccessLevelsOperationFilterInput = {
  eq?: InputMaybe<AccessLevels>;
  in?: InputMaybe<Array<AccessLevels>>;
  neq?: InputMaybe<AccessLevels>;
  nin?: InputMaybe<Array<AccessLevels>>;
};

export type Account = {
  __typename?: 'Account';
  accountNumber: Scalars['String']['output'];
  addressCity?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressState?: Maybe<Scalars['String']['output']>;
  addressZipcode?: Maybe<Scalars['String']['output']>;
  claimStatusDate?: Maybe<Scalars['DateTime']['output']>;
  claimStatusStatus?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactFax?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  creditCardExport?: Maybe<Scalars['String']['output']>;
  creditCardNo?: Maybe<Scalars['String']['output']>;
  dateLastDbUpdated?: Maybe<Scalars['DateTime']['output']>;
  dateSetup?: Maybe<Scalars['DateTime']['output']>;
  dateTerminated?: Maybe<Scalars['DateTime']['output']>;
  ecsDate?: Maybe<Scalars['DateTime']['output']>;
  ecsStatus?: Maybe<Scalars['String']['output']>;
  eligibilityDate?: Maybe<Scalars['DateTime']['output']>;
  eligibilityStatus?: Maybe<Scalars['String']['output']>;
  eraDate?: Maybe<Scalars['DateTime']['output']>;
  eraStatus?: Maybe<Scalars['String']['output']>;
  expirationMonth?: Maybe<Scalars['String']['output']>;
  expirationYear?: Maybe<Scalars['String']['output']>;
  gemsSetupDate?: Maybe<Scalars['DateTime']['output']>;
  gemsSetupFlag?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  lastDbUpdatedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  pms: Scalars['String']['output'];
  /** This is the list of provider groups associated to this user. */
  providerGroups?: Maybe<Array<Maybe<ProviderGroup>>>;
  /** This is the list of providers associated to this user. */
  providers?: Maybe<Array<Maybe<Provider>>>;
  statementDate?: Maybe<Scalars['DateTime']['output']>;
  statementStatus?: Maybe<Scalars['String']['output']>;
  taxExempt?: Maybe<Scalars['String']['output']>;
  terminateReason?: Maybe<Scalars['String']['output']>;
  usersClientsAccts?: Maybe<Array<Maybe<UsersClientsAccts>>>;
};

export type AccountCode = {
  __typename?: 'AccountCode';
  account?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AccountFilterInput = {
  accountNumber?: InputMaybe<StringOperationFilterInput>;
  addressCity?: InputMaybe<StringOperationFilterInput>;
  addressLine1?: InputMaybe<StringOperationFilterInput>;
  addressLine2?: InputMaybe<StringOperationFilterInput>;
  addressState?: InputMaybe<StringOperationFilterInput>;
  addressZipcode?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AccountFilterInput>>;
  claimStatusDate?: InputMaybe<DateTimeOperationFilterInput>;
  claimStatusStatus?: InputMaybe<StringOperationFilterInput>;
  contactEmail?: InputMaybe<StringOperationFilterInput>;
  contactFax?: InputMaybe<StringOperationFilterInput>;
  contactName?: InputMaybe<StringOperationFilterInput>;
  contactPhone?: InputMaybe<StringOperationFilterInput>;
  creditCardExport?: InputMaybe<StringOperationFilterInput>;
  creditCardNo?: InputMaybe<StringOperationFilterInput>;
  dateLastDbUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  dateSetup?: InputMaybe<DateTimeOperationFilterInput>;
  dateTerminated?: InputMaybe<DateTimeOperationFilterInput>;
  ecsDate?: InputMaybe<DateTimeOperationFilterInput>;
  ecsStatus?: InputMaybe<StringOperationFilterInput>;
  eligibilityDate?: InputMaybe<DateTimeOperationFilterInput>;
  eligibilityStatus?: InputMaybe<StringOperationFilterInput>;
  eraDate?: InputMaybe<DateTimeOperationFilterInput>;
  eraStatus?: InputMaybe<StringOperationFilterInput>;
  expirationMonth?: InputMaybe<StringOperationFilterInput>;
  expirationYear?: InputMaybe<StringOperationFilterInput>;
  gemsSetupDate?: InputMaybe<DateTimeOperationFilterInput>;
  gemsSetupFlag?: InputMaybe<StringOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  lastDbUpdatedBy?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AccountFilterInput>>;
  pms?: InputMaybe<StringOperationFilterInput>;
  providerGroups?: InputMaybe<ListFilterInputTypeOfProviderGroupFilterInput>;
  providers?: InputMaybe<ListFilterInputTypeOfProviderFilterInput>;
  statementDate?: InputMaybe<DateTimeOperationFilterInput>;
  statementStatus?: InputMaybe<StringOperationFilterInput>;
  taxExempt?: InputMaybe<StringOperationFilterInput>;
  terminateReason?: InputMaybe<StringOperationFilterInput>;
  usersClientsAccts?: InputMaybe<ListFilterInputTypeOfUsersClientsAcctsFilterInput>;
};

export type AccountSortInput = {
  accountNumber?: InputMaybe<SortEnumType>;
  addressCity?: InputMaybe<SortEnumType>;
  addressLine1?: InputMaybe<SortEnumType>;
  addressLine2?: InputMaybe<SortEnumType>;
  addressState?: InputMaybe<SortEnumType>;
  addressZipcode?: InputMaybe<SortEnumType>;
  claimStatusDate?: InputMaybe<SortEnumType>;
  claimStatusStatus?: InputMaybe<SortEnumType>;
  contactEmail?: InputMaybe<SortEnumType>;
  contactFax?: InputMaybe<SortEnumType>;
  contactName?: InputMaybe<SortEnumType>;
  contactPhone?: InputMaybe<SortEnumType>;
  creditCardExport?: InputMaybe<SortEnumType>;
  creditCardNo?: InputMaybe<SortEnumType>;
  dateLastDbUpdated?: InputMaybe<SortEnumType>;
  dateSetup?: InputMaybe<SortEnumType>;
  dateTerminated?: InputMaybe<SortEnumType>;
  ecsDate?: InputMaybe<SortEnumType>;
  ecsStatus?: InputMaybe<SortEnumType>;
  eligibilityDate?: InputMaybe<SortEnumType>;
  eligibilityStatus?: InputMaybe<SortEnumType>;
  eraDate?: InputMaybe<SortEnumType>;
  eraStatus?: InputMaybe<SortEnumType>;
  expirationMonth?: InputMaybe<SortEnumType>;
  expirationYear?: InputMaybe<SortEnumType>;
  gemsSetupDate?: InputMaybe<SortEnumType>;
  gemsSetupFlag?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  lastDbUpdatedBy?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  pms?: InputMaybe<SortEnumType>;
  statementDate?: InputMaybe<SortEnumType>;
  statementStatus?: InputMaybe<SortEnumType>;
  taxExempt?: InputMaybe<SortEnumType>;
  terminateReason?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AccountsConnection = {
  __typename?: 'AccountsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AccountsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Account>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AccountsEdge = {
  __typename?: 'AccountsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Account>;
};

/** A connection to a list of items. */
export type ActiveClaimsConnection = {
  __typename?: 'ActiveClaimsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ActiveClaimsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ClaimsResponse>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ActiveClaimsEdge = {
  __typename?: 'ActiveClaimsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClaimsResponse>;
};

export type AmountResponse = {
  __typename?: 'AmountResponse';
  amount_authorized?: Maybe<Scalars['String']['output']>;
  amount_other?: Maybe<Scalars['String']['output']>;
};

export type Application = {
  __typename?: 'Application';
  alphaII?: Maybe<Scalars['String']['output']>;
  batch277ca?: Maybe<Scalars['String']['output']>;
  batch277u?: Maybe<Scalars['String']['output']>;
  batchCsv?: Maybe<Scalars['String']['output']>;
  batchHumanReadable?: Maybe<Scalars['String']['output']>;
  batchMachineReadable?: Maybe<Scalars['String']['output']>;
  batchxml?: Maybe<Scalars['String']['output']>;
  careTracker?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  ftpKey?: Maybe<Scalars['String']['output']>;
  genericProvider?: Maybe<Scalars['String']['output']>;
  humanReadable271?: Maybe<Scalars['String']['output']>;
  inputGenerates999?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  newStatements?: Maybe<Scalars['String']['output']>;
  /** This is the list of providers associated to this user. */
  providers?: Maybe<Array<Maybe<Provider>>>;
  rcm?: Maybe<Scalars['String']['output']>;
  rejectPrintClaims?: Maybe<Scalars['String']['output']>;
  remit277ca?: Maybe<Scalars['String']['output']>;
  remit277u?: Maybe<Scalars['String']['output']>;
  remitCsv?: Maybe<Scalars['String']['output']>;
  remitCsvDaily?: Maybe<Scalars['String']['output']>;
  remitEraSummary?: Maybe<Scalars['String']['output']>;
  remitHumanReadable?: Maybe<Scalars['String']['output']>;
  remitMachineReadable?: Maybe<Scalars['String']['output']>;
  remitXml?: Maybe<Scalars['String']['output']>;
  usersClientsApps?: Maybe<Array<Maybe<UsersClientsApps>>>;
};

export type ApplicationCode = {
  __typename?: 'ApplicationCode';
  applicationId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ApplicationFilterInput = {
  alphaII?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ApplicationFilterInput>>;
  batch277ca?: InputMaybe<StringOperationFilterInput>;
  batch277u?: InputMaybe<StringOperationFilterInput>;
  batchCsv?: InputMaybe<StringOperationFilterInput>;
  batchHumanReadable?: InputMaybe<StringOperationFilterInput>;
  batchMachineReadable?: InputMaybe<StringOperationFilterInput>;
  batchxml?: InputMaybe<StringOperationFilterInput>;
  careTracker?: InputMaybe<StringOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  ftpKey?: InputMaybe<StringOperationFilterInput>;
  genericProvider?: InputMaybe<StringOperationFilterInput>;
  humanReadable271?: InputMaybe<StringOperationFilterInput>;
  inputGenerates999?: InputMaybe<StringOperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  newStatements?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationFilterInput>>;
  providers?: InputMaybe<ListFilterInputTypeOfProviderFilterInput>;
  rcm?: InputMaybe<StringOperationFilterInput>;
  rejectPrintClaims?: InputMaybe<StringOperationFilterInput>;
  remit277ca?: InputMaybe<StringOperationFilterInput>;
  remit277u?: InputMaybe<StringOperationFilterInput>;
  remitCsv?: InputMaybe<StringOperationFilterInput>;
  remitCsvDaily?: InputMaybe<StringOperationFilterInput>;
  remitEraSummary?: InputMaybe<StringOperationFilterInput>;
  remitHumanReadable?: InputMaybe<StringOperationFilterInput>;
  remitMachineReadable?: InputMaybe<StringOperationFilterInput>;
  remitXml?: InputMaybe<StringOperationFilterInput>;
  usersClientsApps?: InputMaybe<ListFilterInputTypeOfUsersClientsAppsFilterInput>;
};

export type ApplicationSortInput = {
  alphaII?: InputMaybe<SortEnumType>;
  batch277ca?: InputMaybe<SortEnumType>;
  batch277u?: InputMaybe<SortEnumType>;
  batchCsv?: InputMaybe<SortEnumType>;
  batchHumanReadable?: InputMaybe<SortEnumType>;
  batchMachineReadable?: InputMaybe<SortEnumType>;
  batchxml?: InputMaybe<SortEnumType>;
  careTracker?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  ftpKey?: InputMaybe<SortEnumType>;
  genericProvider?: InputMaybe<SortEnumType>;
  humanReadable271?: InputMaybe<SortEnumType>;
  inputGenerates999?: InputMaybe<SortEnumType>;
  message?: InputMaybe<SortEnumType>;
  newStatements?: InputMaybe<SortEnumType>;
  rcm?: InputMaybe<SortEnumType>;
  rejectPrintClaims?: InputMaybe<SortEnumType>;
  remit277ca?: InputMaybe<SortEnumType>;
  remit277u?: InputMaybe<SortEnumType>;
  remitCsv?: InputMaybe<SortEnumType>;
  remitCsvDaily?: InputMaybe<SortEnumType>;
  remitEraSummary?: InputMaybe<SortEnumType>;
  remitHumanReadable?: InputMaybe<SortEnumType>;
  remitMachineReadable?: InputMaybe<SortEnumType>;
  remitXml?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ApplicationsConnection = {
  __typename?: 'ApplicationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ApplicationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Application>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ApplicationsEdge = {
  __typename?: 'ApplicationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Application>;
};

export type ApplyPolicy = 'AFTER_RESOLVER' | 'BEFORE_RESOLVER' | 'VALIDATION';

export type BillingIdType = {
  __typename?: 'BillingIdType';
  billingIds?: Maybe<Array<Maybe<BillingIds>>>;
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type BillingIdTypeFilterInput = {
  and?: InputMaybe<Array<BillingIdTypeFilterInput>>;
  billingIds?: InputMaybe<ListFilterInputTypeOfBillingIdsFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BillingIdTypeFilterInput>>;
};

export type BillingIdTypeSortInput = {
  code?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
};

export type BillingIds = {
  __typename?: 'BillingIds';
  billingId: Scalars['String']['output'];
  /** BillingIdType for the associated BillingIdTypeCode. */
  billingIdType?: Maybe<BillingIdType>;
  billingIdTypeCode: Scalars['String']['output'];
  dateLastDbUpdate?: Maybe<Scalars['DateTime']['output']>;
  dateSetup?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** ProviderGroup associated BillingIds ProviderGroupId. */
  providerGroup?: Maybe<ProviderGroup>;
  providerGroupId: Scalars['String']['output'];
  providerId?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type BillingIdsConnection = {
  __typename?: 'BillingIdsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BillingIdsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<BillingIds>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BillingIdsEdge = {
  __typename?: 'BillingIdsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BillingIds>;
};

export type BillingIdsFilterInput = {
  and?: InputMaybe<Array<BillingIdsFilterInput>>;
  billingId?: InputMaybe<StringOperationFilterInput>;
  billingIdType?: InputMaybe<BillingIdTypeFilterInput>;
  billingIdTypeCode?: InputMaybe<StringOperationFilterInput>;
  dateLastDbUpdate?: InputMaybe<DateTimeOperationFilterInput>;
  dateSetup?: InputMaybe<DateTimeOperationFilterInput>;
  lastUpdatedBy?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BillingIdsFilterInput>>;
  providerGroup?: InputMaybe<ProviderGroupFilterInput>;
  providerGroupId?: InputMaybe<StringOperationFilterInput>;
  providerId?: InputMaybe<StringOperationFilterInput>;
  rowId?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
};

export type BillingIdsSortInput = {
  billingId?: InputMaybe<SortEnumType>;
  billingIdType?: InputMaybe<BillingIdTypeSortInput>;
  billingIdTypeCode?: InputMaybe<SortEnumType>;
  dateLastDbUpdate?: InputMaybe<SortEnumType>;
  dateSetup?: InputMaybe<SortEnumType>;
  lastUpdatedBy?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  providerGroup?: InputMaybe<ProviderGroupSortInput>;
  providerGroupId?: InputMaybe<SortEnumType>;
  providerId?: InputMaybe<SortEnumType>;
  rowId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Ct_BalanceLineItem = {
  __typename?: 'CT_BalanceLineItem';
  accountNumber?: Maybe<Scalars['String']['output']>;
  amountDue?: Maybe<Scalars['String']['output']>;
  amountPaid?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gatewayRoutingCode?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  placeOfServiceLocation?: Maybe<Scalars['String']['output']>;
  providerType?: Maybe<Scalars['String']['output']>;
  serviceDate?: Maybe<Scalars['String']['output']>;
  serviceEndDate?: Maybe<Scalars['String']['output']>;
  serviceProvider?: Maybe<Scalars['String']['output']>;
  serviceStartDate?: Maybe<Scalars['String']['output']>;
};

export type Ct_BalanceLineItemInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  amountDue?: InputMaybe<Scalars['String']['input']>;
  amountPaid?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gatewayRoutingCode?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  placeOfServiceLocation?: InputMaybe<Scalars['String']['input']>;
  providerType?: InputMaybe<Scalars['String']['input']>;
  serviceDate?: InputMaybe<Scalars['String']['input']>;
  serviceEndDate?: InputMaybe<Scalars['String']['input']>;
  serviceProvider?: InputMaybe<Scalars['String']['input']>;
  serviceStartDate?: InputMaybe<Scalars['String']['input']>;
};

export type Ct_BalanceResponse = {
  __typename?: 'CT_BalanceResponse';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  amountDue?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  consumerNumber?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lineItem?: Maybe<Array<Maybe<Ct_BalanceLineItem>>>;
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type Ct_BalanceResponseInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  amountDue?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  consumerNumber?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lineItem?: InputMaybe<Array<InputMaybe<Ct_BalanceLineItemInput>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CardOnFileAttributesResponse = {
  __typename?: 'CardOnFileAttributesResponse';
  tokenization_error_code?: Maybe<Scalars['String']['output']>;
  tokenization_error_message?: Maybe<Scalars['String']['output']>;
};

export type CardResponse = {
  __typename?: 'CardResponse';
  balance?: Maybe<Scalars['String']['output']>;
  card_on_file_attributes?: Maybe<CardOnFileAttributesResponse>;
  cardholder_name?: Maybe<Scalars['String']['output']>;
  expiry_month?: Maybe<Scalars['String']['output']>;
  expiry_year?: Maybe<Scalars['String']['output']>;
  masked_card_number?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  rfmiq?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CardResponseDebit = {
  __typename?: 'CardResponseDebit';
  balance?: Maybe<Scalars['String']['output']>;
  card_on_file_attributes?: Maybe<CardOnFileAttributesResponse>;
  cardholder_name?: Maybe<Scalars['String']['output']>;
  expiry_month?: Maybe<Scalars['String']['output']>;
  expiry_year?: Maybe<Scalars['String']['output']>;
  masked_card_number?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  rfmiq?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CareTrackerBalanceResponse = {
  __typename?: 'CareTrackerBalanceResponse';
  response?: Maybe<Ct_BalanceResponse>;
  tranId?: Maybe<Scalars['String']['output']>;
  transaction_id?: Maybe<Scalars['String']['output']>;
};

export type CareTrackerBalanceResponseInput = {
  response?: InputMaybe<Ct_BalanceResponseInput>;
  tranId?: InputMaybe<Scalars['String']['input']>;
  transaction_id?: InputMaybe<Scalars['String']['input']>;
};

export type CareTrackerConsumer = {
  __typename?: 'CareTrackerConsumer';
  payload?: Maybe<Payload>;
};

export type CareTrackerConsumerInput = {
  payload?: InputMaybe<PayloadInput>;
};

export type CheckSaleCheckCanadaResponse = {
  __typename?: 'CheckSaleCheckCanadaResponse';
  branchTransitNumber?: Maybe<Scalars['String']['output']>;
  checkNumber?: Maybe<Scalars['String']['output']>;
  financialInstitutionNumber?: Maybe<Scalars['String']['output']>;
  maskedAccountNumber?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type CheckSaleCheckResponse = {
  __typename?: 'CheckSaleCheckResponse';
  checkNumber?: Maybe<Scalars['String']['output']>;
  maskedAccountNumber?: Maybe<Scalars['String']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type CheckSaleLinksCheckSale = {
  __typename?: 'CheckSaleLinksCheckSale';
  description?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  relation?: Maybe<Scalars['String']['output']>;
};

export type CheckSaleLinksReference = {
  __typename?: 'CheckSaleLinksReference';
  description?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  relation?: Maybe<Scalars['String']['output']>;
};

export type CheckSaleLinksResponse = {
  __typename?: 'CheckSaleLinksResponse';
  checkSaleId?: Maybe<Array<Maybe<CheckSaleLinksCheckSale>>>;
  referenceId?: Maybe<Array<Maybe<CheckSaleLinksReference>>>;
};

export type CheckSalePaymentResponse = {
  __typename?: 'CheckSalePaymentResponse';
  amount?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CheckSaleRefundCanadaResponse = {
  __typename?: 'CheckSaleRefundCanadaResponse';
  check?: Maybe<CheckSaleCheckCanadaResponse>;
  checkRefundId?: Maybe<Scalars['String']['output']>;
  links?: Maybe<CheckSaleRefundLinksResponse>;
  payment?: Maybe<CheckSalePaymentResponse>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transaction?: Maybe<CheckSaleTransactionCanadaResponse>;
};

export type CheckSaleRefundLinksResponse = {
  __typename?: 'CheckSaleRefundLinksResponse';
  checkRefundId?: Maybe<CheckSaleLinksCheckSale>;
  referenceId?: Maybe<CheckSaleLinksReference>;
};

export type CheckSaleRefundResponse = {
  __typename?: 'CheckSaleRefundResponse';
  check?: Maybe<CheckSaleCheckResponse>;
  checkRefundId?: Maybe<Scalars['String']['output']>;
  links?: Maybe<CheckSaleRefundLinksResponse>;
  payment?: Maybe<CheckSalePaymentResponse>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transaction?: Maybe<CheckSaleTransactionResponse>;
};

export type CheckSaleRefundWithoutPreviousTransactionCanadaResponse = {
  __typename?: 'CheckSaleRefundWithoutPreviousTransactionCanadaResponse';
  check?: Maybe<CheckSaleCheckCanadaResponse>;
  checkRefundId?: Maybe<Scalars['String']['output']>;
  links?: Maybe<CheckSaleRefundLinksResponse>;
  payment?: Maybe<CheckSalePaymentResponse>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transaction?: Maybe<CheckSaleTransactionCanadaResponse>;
};

export type CheckSaleRefundWithoutPreviousTransactionResponse = {
  __typename?: 'CheckSaleRefundWithoutPreviousTransactionResponse';
  check?: Maybe<CheckSaleCheckResponse>;
  checkRefundId?: Maybe<Scalars['String']['output']>;
  links?: Maybe<CheckSaleRefundLinksResponse>;
  payment?: Maybe<CheckSalePaymentResponse>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transaction?: Maybe<CheckSaleTransactionResponse>;
};

export type CheckSaleTransactionCanadaResponse = {
  __typename?: 'CheckSaleTransactionCanadaResponse';
  language?: Maybe<Scalars['String']['output']>;
  paymentPurposeCode?: Maybe<Scalars['String']['output']>;
};

export type CheckSaleTransactionResponse = {
  __typename?: 'CheckSaleTransactionResponse';
  entryClass?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
};

export type CheckSaleViewDetailsResponse = {
  __typename?: 'CheckSaleViewDetailsResponse';
  check?: Maybe<CheckSaleCheckResponse>;
  checkSaleId?: Maybe<Scalars['String']['output']>;
  links?: Maybe<CheckSaleLinksResponse>;
  payment?: Maybe<CheckSalePaymentResponse>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transaction?: Maybe<CheckSaleTransactionResponse>;
};

export type ClaimDetailResponse = {
  __typename?: 'ClaimDetailResponse';
  dataError?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  messageDate?: Maybe<Scalars['DateTime']['output']>;
  messageFrom?: Maybe<Scalars['String']['output']>;
  serviceInfo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusBucket?: Maybe<Scalars['String']['output']>;
};

export type ClaimDownloadResponse = {
  __typename?: 'ClaimDownloadResponse';
  data?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type ClaimErrorResponse = {
  __typename?: 'ClaimErrorResponse';
  claimId?: Maybe<Scalars['String']['output']>;
  errorDate?: Maybe<Scalars['DateTime']['output']>;
  errorId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lxCounter?: Maybe<Scalars['String']['output']>;
  messageInfo?: Maybe<Scalars['String']['output']>;
  messageText?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
};

export type ClaimErrorResponseFilterInput = {
  and?: InputMaybe<Array<ClaimErrorResponseFilterInput>>;
  claimId?: InputMaybe<StringOperationFilterInput>;
  errorDate?: InputMaybe<DateTimeOperationFilterInput>;
  errorId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lxCounter?: InputMaybe<StringOperationFilterInput>;
  messageInfo?: InputMaybe<StringOperationFilterInput>;
  messageText?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ClaimErrorResponseFilterInput>>;
  providerId?: InputMaybe<StringOperationFilterInput>;
};

export type ClaimErrorResponseSortInput = {
  claimId?: InputMaybe<SortEnumType>;
  errorDate?: InputMaybe<SortEnumType>;
  errorId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lxCounter?: InputMaybe<SortEnumType>;
  messageInfo?: InputMaybe<SortEnumType>;
  messageText?: InputMaybe<SortEnumType>;
  providerId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ClaimErrorsConnection = {
  __typename?: 'ClaimErrorsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ClaimErrorsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ClaimErrorResponse>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ClaimErrorsEdge = {
  __typename?: 'ClaimErrorsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClaimErrorResponse>;
};

export type ClaimFileResponse = {
  __typename?: 'ClaimFileResponse';
  claimDownloadResponse?: Maybe<ClaimDownloadResponse>;
  claimId?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
};

export type ClaimFileText = {
  __typename?: 'ClaimFileText';
  claimId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ClaimFilingIndicator = {
  __typename?: 'ClaimFilingIndicator';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type ClaimFilingIndicatorFilterInput = {
  and?: InputMaybe<Array<ClaimFilingIndicatorFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ClaimFilingIndicatorFilterInput>>;
};

export type ClaimFilingIndicatorSortInput = {
  code?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ClaimFilingIndicatorsConnection = {
  __typename?: 'ClaimFilingIndicatorsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ClaimFilingIndicatorsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ClaimFilingIndicator>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ClaimFilingIndicatorsEdge = {
  __typename?: 'ClaimFilingIndicatorsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClaimFilingIndicator>;
};

/** A connection to a list of items. */
export type ClaimRemitConnection = {
  __typename?: 'ClaimRemitConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ClaimRemitEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ClaimRemittanceResponse>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ClaimRemitEdge = {
  __typename?: 'ClaimRemitEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClaimRemittanceResponse>;
};

export type ClaimRemittanceResponse = {
  __typename?: 'ClaimRemittanceResponse';
  actualFilename?: Maybe<Scalars['String']['output']>;
  apicategory?: Maybe<Scalars['String']['output']>;
  carrier?: Maybe<Scalars['String']['output']>;
  carrierProcessDate?: Maybe<Scalars['String']['output']>;
  carrierProcessTime?: Maybe<Scalars['String']['output']>;
  carrierTraceNumber?: Maybe<Scalars['String']['output']>;
  checkNumber?: Maybe<Scalars['String']['output']>;
  claimCharges?: Maybe<Scalars['Decimal']['output']>;
  claimId?: Maybe<Scalars['String']['output']>;
  claimPaidAmount?: Maybe<Scalars['Decimal']['output']>;
  claimStatus?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  csvFilename?: Maybe<Scalars['String']['output']>;
  dateOfService?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exportDate?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  filename277ca?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  inputData?: Maybe<Scalars['String']['output']>;
  npiOrTaxId?: Maybe<Scalars['String']['output']>;
  outputFilename?: Maybe<Scalars['String']['output']>;
  patientAccountNumber?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  payerId?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
  payerTraceNumber?: Maybe<Scalars['String']['output']>;
  processFlag?: Maybe<Scalars['String']['output']>;
  providerGroupId?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  reportName?: Maybe<Scalars['String']['output']>;
  serviceProviderNPI?: Maybe<Scalars['String']['output']>;
  xmlFilename?: Maybe<Scalars['String']['output']>;
};

export type ClaimRemittanceResponseFilterInput = {
  actualFilename?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ClaimRemittanceResponseFilterInput>>;
  apicategory?: InputMaybe<StringOperationFilterInput>;
  carrier?: InputMaybe<StringOperationFilterInput>;
  carrierProcessDate?: InputMaybe<StringOperationFilterInput>;
  carrierProcessTime?: InputMaybe<StringOperationFilterInput>;
  carrierTraceNumber?: InputMaybe<StringOperationFilterInput>;
  checkNumber?: InputMaybe<StringOperationFilterInput>;
  claimCharges?: InputMaybe<DecimalOperationFilterInput>;
  claimId?: InputMaybe<StringOperationFilterInput>;
  claimPaidAmount?: InputMaybe<DecimalOperationFilterInput>;
  claimStatus?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  csvFilename?: InputMaybe<StringOperationFilterInput>;
  dateOfService?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  exportDate?: InputMaybe<DateTimeOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  filename277ca?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  inputData?: InputMaybe<StringOperationFilterInput>;
  npiOrTaxId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ClaimRemittanceResponseFilterInput>>;
  outputFilename?: InputMaybe<StringOperationFilterInput>;
  patientAccountNumber?: InputMaybe<StringOperationFilterInput>;
  patientName?: InputMaybe<StringOperationFilterInput>;
  payerId?: InputMaybe<StringOperationFilterInput>;
  payerName?: InputMaybe<StringOperationFilterInput>;
  payerTraceNumber?: InputMaybe<StringOperationFilterInput>;
  processFlag?: InputMaybe<StringOperationFilterInput>;
  providerGroupId?: InputMaybe<StringOperationFilterInput>;
  providerId?: InputMaybe<StringOperationFilterInput>;
  reportName?: InputMaybe<StringOperationFilterInput>;
  serviceProviderNPI?: InputMaybe<StringOperationFilterInput>;
  xmlFilename?: InputMaybe<StringOperationFilterInput>;
};

export type ClaimRemittanceResponseSortInput = {
  actualFilename?: InputMaybe<SortEnumType>;
  apicategory?: InputMaybe<SortEnumType>;
  carrier?: InputMaybe<SortEnumType>;
  carrierProcessDate?: InputMaybe<SortEnumType>;
  carrierProcessTime?: InputMaybe<SortEnumType>;
  carrierTraceNumber?: InputMaybe<SortEnumType>;
  checkNumber?: InputMaybe<SortEnumType>;
  claimCharges?: InputMaybe<SortEnumType>;
  claimId?: InputMaybe<SortEnumType>;
  claimPaidAmount?: InputMaybe<SortEnumType>;
  claimStatus?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  csvFilename?: InputMaybe<SortEnumType>;
  dateOfService?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  exportDate?: InputMaybe<SortEnumType>;
  fileName?: InputMaybe<SortEnumType>;
  filename277ca?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inputData?: InputMaybe<SortEnumType>;
  npiOrTaxId?: InputMaybe<SortEnumType>;
  outputFilename?: InputMaybe<SortEnumType>;
  patientAccountNumber?: InputMaybe<SortEnumType>;
  patientName?: InputMaybe<SortEnumType>;
  payerId?: InputMaybe<SortEnumType>;
  payerName?: InputMaybe<SortEnumType>;
  payerTraceNumber?: InputMaybe<SortEnumType>;
  processFlag?: InputMaybe<SortEnumType>;
  providerGroupId?: InputMaybe<SortEnumType>;
  providerId?: InputMaybe<SortEnumType>;
  reportName?: InputMaybe<SortEnumType>;
  serviceProviderNPI?: InputMaybe<SortEnumType>;
  xmlFilename?: InputMaybe<SortEnumType>;
};

export type ClaimResponse = {
  __typename?: 'ClaimResponse';
  claimId?: Maybe<Scalars['String']['output']>;
  statusDetails?: Maybe<Array<Maybe<ClaimDetailResponse>>>;
};

/** A connection to a list of items. */
export type ClaimStatisticsConnection = {
  __typename?: 'ClaimStatisticsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ClaimStatisticsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ClaimStatisticsResponse>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ClaimStatisticsEdge = {
  __typename?: 'ClaimStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClaimStatisticsResponse>;
};

export type ClaimStatisticsResponse = {
  __typename?: 'ClaimStatisticsResponse';
  category?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  totalCharges: Scalars['Decimal']['output'];
};

export type ClaimStatisticsResponseFilterInput = {
  and?: InputMaybe<Array<ClaimStatisticsResponseFilterInput>>;
  category?: InputMaybe<StringOperationFilterInput>;
  count?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ClaimStatisticsResponseFilterInput>>;
  totalCharges?: InputMaybe<DecimalOperationFilterInput>;
};

export type ClaimStatisticsResponseSortInput = {
  category?: InputMaybe<SortEnumType>;
  count?: InputMaybe<SortEnumType>;
  totalCharges?: InputMaybe<SortEnumType>;
};

export type ClaimStatisticsSearchFilterInput = {
  account?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  pms?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClaimStatusRouting = {
  __typename?: 'ClaimStatusRouting';
  ediId: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  nm1Upper?: Maybe<Scalars['String']['output']>;
  onlineBatch: Scalars['String']['output'];
  payerName?: Maybe<Scalars['String']['output']>;
  processorId: Scalars['String']['output'];
  recordStatus?: Maybe<Scalars['String']['output']>;
  scId: Scalars['String']['output'];
};

export type ClaimStatusRoutingFilterInput = {
  and?: InputMaybe<Array<ClaimStatusRoutingFilterInput>>;
  ediId?: InputMaybe<StringOperationFilterInput>;
  groupId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  nm1Upper?: InputMaybe<StringOperationFilterInput>;
  onlineBatch?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ClaimStatusRoutingFilterInput>>;
  payerName?: InputMaybe<StringOperationFilterInput>;
  processorId?: InputMaybe<StringOperationFilterInput>;
  recordStatus?: InputMaybe<StringOperationFilterInput>;
  scId?: InputMaybe<StringOperationFilterInput>;
};

export type ClaimStatusRoutingSortInput = {
  ediId?: InputMaybe<SortEnumType>;
  groupId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  nm1Upper?: InputMaybe<SortEnumType>;
  onlineBatch?: InputMaybe<SortEnumType>;
  payerName?: InputMaybe<SortEnumType>;
  processorId?: InputMaybe<SortEnumType>;
  recordStatus?: InputMaybe<SortEnumType>;
  scId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ClaimStatusRoutingsConnection = {
  __typename?: 'ClaimStatusRoutingsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ClaimStatusRoutingsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ClaimStatusRouting>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ClaimStatusRoutingsEdge = {
  __typename?: 'ClaimStatusRoutingsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClaimStatusRouting>;
};

/** A connection to a list of items. */
export type ClaimsArchiveConnection = {
  __typename?: 'ClaimsArchiveConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ClaimsArchiveEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ClaimsResponse>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ClaimsArchiveEdge = {
  __typename?: 'ClaimsArchiveEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClaimsResponse>;
};

/** A connection to a list of items. */
export type ClaimsConnection = {
  __typename?: 'ClaimsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ClaimsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ClaimsResponse>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ClaimsEdge = {
  __typename?: 'ClaimsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClaimsResponse>;
};

export type ClaimsResponse = {
  __typename?: 'ClaimsResponse';
  batchNumber: Scalars['Int']['output'];
  batchStatus?: Maybe<Scalars['String']['output']>;
  billingNpi?: Maybe<Scalars['String']['output']>;
  billingProviderFirstname?: Maybe<Scalars['String']['output']>;
  billingProviderLastname?: Maybe<Scalars['String']['output']>;
  billingProviderMi?: Maybe<Scalars['String']['output']>;
  billingTaxId?: Maybe<Scalars['String']['output']>;
  carrierProcessDate?: Maybe<Scalars['String']['output']>;
  carrierProcessTime?: Maybe<Scalars['String']['output']>;
  claimId?: Maybe<Scalars['String']['output']>;
  claimStatus?: Maybe<Scalars['String']['output']>;
  claimStatusCode?: Maybe<Scalars['String']['output']>;
  csvFilename?: Maybe<Scalars['String']['output']>;
  customerInputFilename?: Maybe<Scalars['String']['output']>;
  dateOfSubmission: Scalars['DateTime']['output'];
  filename277ca?: Maybe<Scalars['String']['output']>;
  firstServiceDate?: Maybe<Scalars['DateTime']['output']>;
  formatType?: Maybe<Scalars['String']['output']>;
  inputFilename?: Maybe<Scalars['String']['output']>;
  inputFormat?: Maybe<Scalars['String']['output']>;
  inputSeqNumber: Scalars['Int']['output'];
  insurancePlanName?: Maybe<Scalars['String']['output']>;
  insuredName?: Maybe<Scalars['String']['output']>;
  neicId?: Maybe<Scalars['String']['output']>;
  outputBatchNumber?: Maybe<Scalars['Int']['output']>;
  outputFormat?: Maybe<Scalars['String']['output']>;
  patientAccountNumber?: Maybe<Scalars['String']['output']>;
  patientFirstname?: Maybe<Scalars['String']['output']>;
  patientLastname?: Maybe<Scalars['String']['output']>;
  patientMi?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  payerId?: Maybe<Scalars['String']['output']>;
  payerResponibility?: Maybe<Scalars['String']['output']>;
  processorId?: Maybe<Scalars['String']['output']>;
  providerFirstname?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerLastname?: Maybe<Scalars['String']['output']>;
  providerMi?: Maybe<Scalars['String']['output']>;
  renderingNpi?: Maybe<Scalars['String']['output']>;
  reportFilename?: Maybe<Scalars['String']['output']>;
  reportId?: Maybe<Scalars['String']['output']>;
  statusFlag: SecureConnectClaimStatusTypes;
  totalCharges: Scalars['Decimal']['output'];
  transmitFilename?: Maybe<Scalars['String']['output']>;
  xmlFilename?: Maybe<Scalars['String']['output']>;
};

export type ClaimsResponseFilterInput = {
  and?: InputMaybe<Array<ClaimsResponseFilterInput>>;
  batchNumber?: InputMaybe<IntOperationFilterInput>;
  batchStatus?: InputMaybe<StringOperationFilterInput>;
  billingNpi?: InputMaybe<StringOperationFilterInput>;
  billingProviderFirstname?: InputMaybe<StringOperationFilterInput>;
  billingProviderLastname?: InputMaybe<StringOperationFilterInput>;
  billingProviderMi?: InputMaybe<StringOperationFilterInput>;
  billingTaxId?: InputMaybe<StringOperationFilterInput>;
  carrierProcessDate?: InputMaybe<StringOperationFilterInput>;
  carrierProcessTime?: InputMaybe<StringOperationFilterInput>;
  claimId?: InputMaybe<StringOperationFilterInput>;
  claimStatus?: InputMaybe<StringOperationFilterInput>;
  claimStatusCode?: InputMaybe<StringOperationFilterInput>;
  csvFilename?: InputMaybe<StringOperationFilterInput>;
  customerInputFilename?: InputMaybe<StringOperationFilterInput>;
  dateOfSubmission?: InputMaybe<DateTimeOperationFilterInput>;
  filename277ca?: InputMaybe<StringOperationFilterInput>;
  firstServiceDate?: InputMaybe<DateTimeOperationFilterInput>;
  formatType?: InputMaybe<StringOperationFilterInput>;
  inputFilename?: InputMaybe<StringOperationFilterInput>;
  inputFormat?: InputMaybe<StringOperationFilterInput>;
  inputSeqNumber?: InputMaybe<IntOperationFilterInput>;
  insurancePlanName?: InputMaybe<StringOperationFilterInput>;
  insuredName?: InputMaybe<StringOperationFilterInput>;
  neicId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ClaimsResponseFilterInput>>;
  outputBatchNumber?: InputMaybe<IntOperationFilterInput>;
  outputFormat?: InputMaybe<StringOperationFilterInput>;
  patientAccountNumber?: InputMaybe<StringOperationFilterInput>;
  patientFirstname?: InputMaybe<StringOperationFilterInput>;
  patientLastname?: InputMaybe<StringOperationFilterInput>;
  patientMi?: InputMaybe<StringOperationFilterInput>;
  patientName?: InputMaybe<StringOperationFilterInput>;
  payerId?: InputMaybe<StringOperationFilterInput>;
  payerResponibility?: InputMaybe<StringOperationFilterInput>;
  processorId?: InputMaybe<StringOperationFilterInput>;
  providerFirstname?: InputMaybe<StringOperationFilterInput>;
  providerId?: InputMaybe<StringOperationFilterInput>;
  providerLastname?: InputMaybe<StringOperationFilterInput>;
  providerMi?: InputMaybe<StringOperationFilterInput>;
  renderingNpi?: InputMaybe<StringOperationFilterInput>;
  reportFilename?: InputMaybe<StringOperationFilterInput>;
  reportId?: InputMaybe<StringOperationFilterInput>;
  statusFlag?: InputMaybe<SecureConnectClaimStatusTypesOperationFilterInput>;
  totalCharges?: InputMaybe<DecimalOperationFilterInput>;
  transmitFilename?: InputMaybe<StringOperationFilterInput>;
  xmlFilename?: InputMaybe<StringOperationFilterInput>;
};

export type ClaimsResponseSortInput = {
  batchNumber?: InputMaybe<SortEnumType>;
  batchStatus?: InputMaybe<SortEnumType>;
  billingNpi?: InputMaybe<SortEnumType>;
  billingProviderFirstname?: InputMaybe<SortEnumType>;
  billingProviderLastname?: InputMaybe<SortEnumType>;
  billingProviderMi?: InputMaybe<SortEnumType>;
  billingTaxId?: InputMaybe<SortEnumType>;
  carrierProcessDate?: InputMaybe<SortEnumType>;
  carrierProcessTime?: InputMaybe<SortEnumType>;
  claimId?: InputMaybe<SortEnumType>;
  claimStatus?: InputMaybe<SortEnumType>;
  claimStatusCode?: InputMaybe<SortEnumType>;
  csvFilename?: InputMaybe<SortEnumType>;
  customerInputFilename?: InputMaybe<SortEnumType>;
  dateOfSubmission?: InputMaybe<SortEnumType>;
  filename277ca?: InputMaybe<SortEnumType>;
  firstServiceDate?: InputMaybe<SortEnumType>;
  formatType?: InputMaybe<SortEnumType>;
  inputFilename?: InputMaybe<SortEnumType>;
  inputFormat?: InputMaybe<SortEnumType>;
  inputSeqNumber?: InputMaybe<SortEnumType>;
  insurancePlanName?: InputMaybe<SortEnumType>;
  insuredName?: InputMaybe<SortEnumType>;
  neicId?: InputMaybe<SortEnumType>;
  outputBatchNumber?: InputMaybe<SortEnumType>;
  outputFormat?: InputMaybe<SortEnumType>;
  patientAccountNumber?: InputMaybe<SortEnumType>;
  patientFirstname?: InputMaybe<SortEnumType>;
  patientLastname?: InputMaybe<SortEnumType>;
  patientMi?: InputMaybe<SortEnumType>;
  patientName?: InputMaybe<SortEnumType>;
  payerId?: InputMaybe<SortEnumType>;
  payerResponibility?: InputMaybe<SortEnumType>;
  processorId?: InputMaybe<SortEnumType>;
  providerFirstname?: InputMaybe<SortEnumType>;
  providerId?: InputMaybe<SortEnumType>;
  providerLastname?: InputMaybe<SortEnumType>;
  providerMi?: InputMaybe<SortEnumType>;
  renderingNpi?: InputMaybe<SortEnumType>;
  reportFilename?: InputMaybe<SortEnumType>;
  reportId?: InputMaybe<SortEnumType>;
  statusFlag?: InputMaybe<SortEnumType>;
  totalCharges?: InputMaybe<SortEnumType>;
  transmitFilename?: InputMaybe<SortEnumType>;
  xmlFilename?: InputMaybe<SortEnumType>;
};

export type ClaimsSibling = {
  __typename?: 'ClaimsSibling';
  claimId: Scalars['String']['output'];
  inputData?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type ClaimsV1_1Connection = {
  __typename?: 'ClaimsV1_1Connection';
  /** A list of edges. */
  edges?: Maybe<Array<ClaimsV1_1Edge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ClaimsResponse>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ClaimsV1_1Edge = {
  __typename?: 'ClaimsV1_1Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClaimsResponse>;
};

export type CommunicationType = {
  __typename?: 'CommunicationType';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type CommunicationTypeFilterInput = {
  and?: InputMaybe<Array<CommunicationTypeFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CommunicationTypeFilterInput>>;
};

export type CommunicationTypeSortInput = {
  code?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CommunicationTypesConnection = {
  __typename?: 'CommunicationTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CommunicationTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<CommunicationType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CommunicationTypesEdge = {
  __typename?: 'CommunicationTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CommunicationType>;
};

export type ConfigurationResponse = {
  __typename?: 'ConfigurationResponse';
  addressCity?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressState?: Maybe<Scalars['String']['output']>;
  addressZipcode?: Maybe<Scalars['String']['output']>;
  batchPort?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  dateLastDbUpdate?: Maybe<Scalars['DateTime']['output']>;
  emdeonIp?: Maybe<Scalars['String']['output']>;
  faxCoverpage?: Maybe<Scalars['String']['output']>;
  faxDirectory?: Maybe<Scalars['String']['output']>;
  gemsDivisionId?: Maybe<Scalars['String']['output']>;
  homeDirectory?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  inputDirectory?: Maybe<Scalars['String']['output']>;
  insuranceFileDirectory?: Maybe<Scalars['String']['output']>;
  logDirectory?: Maybe<Scalars['String']['output']>;
  mapDirectory?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parseDll?: Maybe<Scalars['String']['output']>;
  passPhrase?: Maybe<Scalars['String']['output']>;
  pgpExe?: Maybe<Scalars['String']['output']>;
  pgpPrivateKey?: Maybe<Scalars['String']['output']>;
  pgpPublicKey?: Maybe<Scalars['String']['output']>;
  pgpUserId?: Maybe<Scalars['String']['output']>;
  primaryPager?: Maybe<Scalars['String']['output']>;
  printDirectory?: Maybe<Scalars['String']['output']>;
  realTimePort?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  remittanceDirectory?: Maybe<Scalars['String']['output']>;
  reportDirectory?: Maybe<Scalars['String']['output']>;
  secondaryInputDirectory?: Maybe<Scalars['String']['output']>;
  secondaryPager?: Maybe<Scalars['String']['output']>;
  secondaryReportDirectory?: Maybe<Scalars['String']['output']>;
  transmitDirectory?: Maybe<Scalars['String']['output']>;
  welcomeMessage?: Maybe<Scalars['String']['output']>;
};

export type ConnectionResponse = {
  __typename?: 'ConnectionResponse';
  armor?: Maybe<Scalars['String']['output']>;
  certificateFile?: Maybe<Scalars['String']['output']>;
  certificatePassword?: Maybe<Scalars['String']['output']>;
  changePassword?: Maybe<Scalars['String']['output']>;
  combineFiles?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  decryptFile?: Maybe<Scalars['String']['output']>;
  deleteScript?: Maybe<Scalars['String']['output']>;
  download?: Maybe<Scalars['String']['output']>;
  downloadCheck?: Maybe<Scalars['String']['output']>;
  encryptFile?: Maybe<Scalars['String']['output']>;
  entryName?: Maybe<Scalars['String']['output']>;
  fileDir?: Maybe<Scalars['String']['output']>;
  fileSql?: Maybe<Scalars['String']['output']>;
  ftpHost?: Maybe<Scalars['String']['output']>;
  ftpKey?: Maybe<Scalars['String']['output']>;
  ftpPassword?: Maybe<Scalars['String']['output']>;
  ftpPort: Scalars['Int']['output'];
  ftpType?: Maybe<Scalars['String']['output']>;
  ftpUserId?: Maybe<Scalars['String']['output']>;
  integrityCheck?: Maybe<Scalars['String']['output']>;
  lastGoodPassword?: Maybe<Scalars['String']['output']>;
  moveFiles?: Maybe<Scalars['String']['output']>;
  passwordChangeDays: Scalars['Int']['output'];
  passwordChangeTimestamp?: Maybe<Scalars['DateTime']['output']>;
  passwordWebsite?: Maybe<Scalars['String']['output']>;
  pgpKeyFile?: Maybe<Scalars['String']['output']>;
  pgpKeyId?: Maybe<Scalars['String']['output']>;
  putAdditionalCmd?: Maybe<Scalars['String']['output']>;
  queue?: Maybe<Scalars['String']['output']>;
  receiveAscii?: Maybe<Scalars['String']['output']>;
  removeFile?: Maybe<Scalars['String']['output']>;
  renameDownloadPgp?: Maybe<Scalars['String']['output']>;
  renameFilePattern?: Maybe<Scalars['String']['output']>;
  renameFilePatternDownload?: Maybe<Scalars['String']['output']>;
  renameZipPattern?: Maybe<Scalars['String']['output']>;
  secureCrt?: Maybe<Scalars['String']['output']>;
  sendAscii?: Maybe<Scalars['String']['output']>;
  sendDir?: Maybe<Scalars['String']['output']>;
  sendId?: Maybe<Scalars['String']['output']>;
  sendZip?: Maybe<Scalars['String']['output']>;
  sshHostKeyFingerPrint?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  uniqueSql?: Maybe<Scalars['String']['output']>;
  upload?: Maybe<Scalars['String']['output']>;
  zipPassword?: Maybe<Scalars['String']['output']>;
};

export type ConnectionSearchResponse = {
  __typename?: 'ConnectionSearchResponse';
  ftpHost?: Maybe<Scalars['String']['output']>;
  ftpKey?: Maybe<Scalars['String']['output']>;
  ftpType?: Maybe<Scalars['String']['output']>;
  ftpUserId?: Maybe<Scalars['String']['output']>;
  queue?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ConnectionSearchResponseFilterInput = {
  and?: InputMaybe<Array<ConnectionSearchResponseFilterInput>>;
  ftpHost?: InputMaybe<StringOperationFilterInput>;
  ftpKey?: InputMaybe<StringOperationFilterInput>;
  ftpType?: InputMaybe<StringOperationFilterInput>;
  ftpUserId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConnectionSearchResponseFilterInput>>;
  queue?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
};

export type ConnectionSearchResponseSortInput = {
  ftpHost?: InputMaybe<SortEnumType>;
  ftpKey?: InputMaybe<SortEnumType>;
  ftpType?: InputMaybe<SortEnumType>;
  ftpUserId?: InputMaybe<SortEnumType>;
  queue?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ConnectionsConnection = {
  __typename?: 'ConnectionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ConnectionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ConnectionSearchResponse>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ConnectionsEdge = {
  __typename?: 'ConnectionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ConnectionSearchResponse>;
};

export type Consumer = {
  __typename?: 'Consumer';
  address1?: Maybe<Scalars['String']['output']>;
  amountDue?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ConsumerInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  amountDue?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreditAttributesResponse = {
  __typename?: 'CreditAttributesResponse';
  approval_code?: Maybe<Scalars['String']['output']>;
  avs_response?: Maybe<Scalars['String']['output']>;
  avs_response_description?: Maybe<Scalars['String']['output']>;
  card?: Maybe<CardResponse>;
  cardsecurity_response?: Maybe<Scalars['String']['output']>;
  emv?: Maybe<EmvResponse>;
  payment?: Maybe<PaymentResponse>;
};

/** A connection to a list of items. */
export type CurrentStatementConnection = {
  __typename?: 'CurrentStatementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CurrentStatementEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<PatientStatementsResponse>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CurrentStatementEdge = {
  __typename?: 'CurrentStatementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PatientStatementsResponse>;
};

/** A connection to a list of items. */
export type CurrentStatementLinesConnection = {
  __typename?: 'CurrentStatementLinesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CurrentStatementLinesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<PatientStatementsResponse>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CurrentStatementLinesEdge = {
  __typename?: 'CurrentStatementLinesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PatientStatementsResponse>;
};

export type DataContext = {
  __typename?: 'DataContext';
  consumer?: Maybe<Consumer>;
  lineItem?: Maybe<Array<Maybe<LineItem>>>;
};

export type DataContextInput = {
  consumer?: InputMaybe<ConsumerInput>;
  lineItem?: InputMaybe<Array<InputMaybe<LineItemInput>>>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DbAddressInfo = {
  __typename?: 'DbAddressInfo';
  addressInfoId: Scalars['Long']['output'];
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type DbAddressInfoFilterInput = {
  addressInfoId?: InputMaybe<LongOperationFilterInput>;
  addressLine1?: InputMaybe<StringOperationFilterInput>;
  addressLine2?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<DbAddressInfoFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DbAddressInfoFilterInput>>;
  state?: InputMaybe<StringOperationFilterInput>;
  zipcode?: InputMaybe<StringOperationFilterInput>;
};

export type DbAddressInfoSortInput = {
  addressInfoId?: InputMaybe<SortEnumType>;
  addressLine1?: InputMaybe<SortEnumType>;
  addressLine2?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  zipcode?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DbAddressInfosConnection = {
  __typename?: 'DbAddressInfosConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DbAddressInfosEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<DbAddressInfo>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DbAddressInfosEdge = {
  __typename?: 'DbAddressInfosEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DbAddressInfo>;
};

export type DbContactInfo = {
  __typename?: 'DbContactInfo';
  contactInfoId: Scalars['Long']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  primaryPhone?: Maybe<Scalars['String']['output']>;
  primarySupportsSms?: Maybe<Scalars['String']['output']>;
  secondaryPhone?: Maybe<Scalars['String']['output']>;
  secondarySupportsSms?: Maybe<Scalars['String']['output']>;
};

export type DbContactInfoFilterInput = {
  and?: InputMaybe<Array<DbContactInfoFilterInput>>;
  contactInfoId?: InputMaybe<LongOperationFilterInput>;
  emailAddress?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DbContactInfoFilterInput>>;
  primaryPhone?: InputMaybe<StringOperationFilterInput>;
  primarySupportsSms?: InputMaybe<StringOperationFilterInput>;
  secondaryPhone?: InputMaybe<StringOperationFilterInput>;
  secondarySupportsSms?: InputMaybe<StringOperationFilterInput>;
};

export type DbContactInfoSortInput = {
  contactInfoId?: InputMaybe<SortEnumType>;
  emailAddress?: InputMaybe<SortEnumType>;
  primaryPhone?: InputMaybe<SortEnumType>;
  primarySupportsSms?: InputMaybe<SortEnumType>;
  secondaryPhone?: InputMaybe<SortEnumType>;
  secondarySupportsSms?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DbContactInfosConnection = {
  __typename?: 'DbContactInfosConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DbContactInfosEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<DbContactInfo>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DbContactInfosEdge = {
  __typename?: 'DbContactInfosEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DbContactInfo>;
};

export type DebitAttributesResponse = {
  __typename?: 'DebitAttributesResponse';
  approval_code?: Maybe<Scalars['String']['output']>;
  avs_response?: Maybe<Scalars['String']['output']>;
  avs_response_description?: Maybe<Scalars['String']['output']>;
  card?: Maybe<CardResponseDebit>;
  cardsecurity_response?: Maybe<Scalars['String']['output']>;
  emv?: Maybe<EmvResponse>;
  payment?: Maybe<PaymentResponse>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type EligibilityRouting = {
  __typename?: 'EligibilityRouting';
  changeReceiverNonPersonEntity?: Maybe<Scalars['String']['output']>;
  ediId?: Maybe<Scalars['String']['output']>;
  ediidQualifier?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['String']['output'];
  nm1Upper?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
  processorId?: Maybe<Scalars['String']['output']>;
  recordStatus?: Maybe<Scalars['String']['output']>;
  removePrv?: Maybe<Scalars['String']['output']>;
  removeReceiverRef0b?: Maybe<Scalars['String']['output']>;
  removeReceiverRefTj?: Maybe<Scalars['String']['output']>;
  removeRefSy?: Maybe<Scalars['String']['output']>;
  removeSubscriberAddress?: Maybe<Scalars['String']['output']>;
  removeSubscriberDtp102?: Maybe<Scalars['String']['output']>;
  removeSubscriberDtp291?: Maybe<Scalars['String']['output']>;
  removeSubscriberGender?: Maybe<Scalars['String']['output']>;
  removeSubscriberNm1Mi?: Maybe<Scalars['String']['output']>;
  scId: Scalars['String']['output'];
};

export type EligibilityRoutingFilterInput = {
  and?: InputMaybe<Array<EligibilityRoutingFilterInput>>;
  changeReceiverNonPersonEntity?: InputMaybe<StringOperationFilterInput>;
  ediId?: InputMaybe<StringOperationFilterInput>;
  ediidQualifier?: InputMaybe<StringOperationFilterInput>;
  groupId?: InputMaybe<StringOperationFilterInput>;
  nm1Upper?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EligibilityRoutingFilterInput>>;
  payerName?: InputMaybe<StringOperationFilterInput>;
  processorId?: InputMaybe<StringOperationFilterInput>;
  recordStatus?: InputMaybe<StringOperationFilterInput>;
  removePrv?: InputMaybe<StringOperationFilterInput>;
  removeReceiverRef0b?: InputMaybe<StringOperationFilterInput>;
  removeReceiverRefTj?: InputMaybe<StringOperationFilterInput>;
  removeRefSy?: InputMaybe<StringOperationFilterInput>;
  removeSubscriberAddress?: InputMaybe<StringOperationFilterInput>;
  removeSubscriberDtp102?: InputMaybe<StringOperationFilterInput>;
  removeSubscriberDtp291?: InputMaybe<StringOperationFilterInput>;
  removeSubscriberGender?: InputMaybe<StringOperationFilterInput>;
  removeSubscriberNm1Mi?: InputMaybe<StringOperationFilterInput>;
  scId?: InputMaybe<StringOperationFilterInput>;
};

export type EligibilityRoutingSortInput = {
  changeReceiverNonPersonEntity?: InputMaybe<SortEnumType>;
  ediId?: InputMaybe<SortEnumType>;
  ediidQualifier?: InputMaybe<SortEnumType>;
  groupId?: InputMaybe<SortEnumType>;
  nm1Upper?: InputMaybe<SortEnumType>;
  payerName?: InputMaybe<SortEnumType>;
  processorId?: InputMaybe<SortEnumType>;
  recordStatus?: InputMaybe<SortEnumType>;
  removePrv?: InputMaybe<SortEnumType>;
  removeReceiverRef0b?: InputMaybe<SortEnumType>;
  removeReceiverRefTj?: InputMaybe<SortEnumType>;
  removeRefSy?: InputMaybe<SortEnumType>;
  removeSubscriberAddress?: InputMaybe<SortEnumType>;
  removeSubscriberDtp102?: InputMaybe<SortEnumType>;
  removeSubscriberDtp291?: InputMaybe<SortEnumType>;
  removeSubscriberGender?: InputMaybe<SortEnumType>;
  removeSubscriberNm1Mi?: InputMaybe<SortEnumType>;
  scId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type EligibilityRoutingsConnection = {
  __typename?: 'EligibilityRoutingsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EligibilityRoutingsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<EligibilityRouting>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EligibilityRoutingsEdge = {
  __typename?: 'EligibilityRoutingsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EligibilityRouting>;
};

export type EmailVendor = {
  __typename?: 'EmailVendor';
  active: Scalars['Boolean']['output'];
  authType?: Maybe<Scalars['String']['output']>;
  authValue?: Maybe<Scalars['String']['output']>;
  baseUrl: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  sendEmailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Scalars['Int']['output'];
};

export type EmailVendorFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<EmailVendorFilterInput>>;
  authType?: InputMaybe<StringOperationFilterInput>;
  authValue?: InputMaybe<StringOperationFilterInput>;
  baseUrl?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EmailVendorFilterInput>>;
  sendEmailUrl?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
};

export type EmailVendorSortInput = {
  active?: InputMaybe<SortEnumType>;
  authType?: InputMaybe<SortEnumType>;
  authValue?: InputMaybe<SortEnumType>;
  baseUrl?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  sendEmailUrl?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type EmailVendorsConnection = {
  __typename?: 'EmailVendorsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EmailVendorsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<EmailVendor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EmailVendorsEdge = {
  __typename?: 'EmailVendorsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EmailVendor>;
};

export type EmvResponse = {
  __typename?: 'EmvResponse';
  amount?: Maybe<AmountResponse>;
  icc?: Maybe<IccResponse>;
};

export type EnrollmentLog = {
  __typename?: 'EnrollmentLog';
  id: Scalars['Int']['output'];
  seqNo: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type EnrollmentLogFilterInput = {
  and?: InputMaybe<Array<EnrollmentLogFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<EnrollmentLogFilterInput>>;
  seqNo?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
};

export type EnrollmentLogSortInput = {
  id?: InputMaybe<SortEnumType>;
  seqNo?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type EnrollmentLogsConnection = {
  __typename?: 'EnrollmentLogsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EnrollmentLogsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<EnrollmentLog>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EnrollmentLogsEdge = {
  __typename?: 'EnrollmentLogsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EnrollmentLog>;
};

export type EnrollmentStatus = {
  __typename?: 'EnrollmentStatus';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type EnrollmentStatusFilterInput = {
  and?: InputMaybe<Array<EnrollmentStatusFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EnrollmentStatusFilterInput>>;
};

export type EnrollmentStatusSortInput = {
  code?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
};

export type EraFilePaymentResponse = {
  __typename?: 'EraFilePaymentResponse';
  /** Billing NPI */
  billingNpi?: Maybe<Scalars['String']['output']>;
  /** Billing Tax Id */
  billingTaxId?: Maybe<Scalars['String']['output']>;
  /** Claim Count */
  claimCount: Scalars['Int']['output'];
  /** Date Received */
  dateReceived?: Maybe<Scalars['DateTime']['output']>;
  /** Effective Date */
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  /** File Id */
  fileId: Scalars['Long']['output'];
  /** Group Id. Client's G#. */
  groupId?: Maybe<Scalars['String']['output']>;
  /** Input Filename. Client's uploaded filename. */
  inputFilename?: Maybe<Scalars['String']['output']>;
  /** Output Filename */
  outputFilename?: Maybe<Scalars['String']['output']>;
  /** Payer Id */
  payerId?: Maybe<Scalars['String']['output']>;
  /** Payer Name */
  payerName?: Maybe<Scalars['String']['output']>;
  /** Payer Tax Id */
  payerTaxId?: Maybe<Scalars['String']['output']>;
  /** Payment Amount */
  paymentAmount: Scalars['Decimal']['output'];
  /** File Status. FileStatus */
  status: FileStatus;
  /** Submitter Id */
  submitterId?: Maybe<Scalars['String']['output']>;
  /** Submitter Name */
  submitterName?: Maybe<Scalars['String']['output']>;
  /** Trace Number */
  traceNumber?: Maybe<Scalars['String']['output']>;
  /** Transmission Date */
  transmissionDate?: Maybe<Scalars['DateTime']['output']>;
};

export type EraFilePaymentResponseFilterInput = {
  and?: InputMaybe<Array<EraFilePaymentResponseFilterInput>>;
  /** Billing NPI */
  billingNpi?: InputMaybe<StringOperationFilterInput>;
  /** Billing Tax Id */
  billingTaxId?: InputMaybe<StringOperationFilterInput>;
  /** Claim Count */
  claimCount?: InputMaybe<IntOperationFilterInput>;
  /** Date Received */
  dateReceived?: InputMaybe<DateTimeOperationFilterInput>;
  /** Effective Date */
  effectiveDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** File Id */
  fileId?: InputMaybe<LongOperationFilterInput>;
  /** Group Id. Client's G#. */
  groupId?: InputMaybe<StringOperationFilterInput>;
  /** Input Filename. Client's uploaded filename. */
  inputFilename?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EraFilePaymentResponseFilterInput>>;
  /** Output Filename */
  outputFilename?: InputMaybe<StringOperationFilterInput>;
  /** Payer Id */
  payerId?: InputMaybe<StringOperationFilterInput>;
  /** Payer Name */
  payerName?: InputMaybe<StringOperationFilterInput>;
  /** Payer Tax Id */
  payerTaxId?: InputMaybe<StringOperationFilterInput>;
  /** Payment Amount */
  paymentAmount?: InputMaybe<DecimalOperationFilterInput>;
  /** File Status. FileStatus */
  status?: InputMaybe<FileStatusOperationFilterInput>;
  /** Submitter Id */
  submitterId?: InputMaybe<StringOperationFilterInput>;
  /** Submitter Name */
  submitterName?: InputMaybe<StringOperationFilterInput>;
  /** Trace Number */
  traceNumber?: InputMaybe<StringOperationFilterInput>;
  /** Transmission Date */
  transmissionDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type EraFilePaymentResponseSortInput = {
  /** Billing NPI */
  billingNpi?: InputMaybe<SortEnumType>;
  /** Billing Tax Id */
  billingTaxId?: InputMaybe<SortEnumType>;
  /** Claim Count */
  claimCount?: InputMaybe<SortEnumType>;
  /** Date Received */
  dateReceived?: InputMaybe<SortEnumType>;
  /** Effective Date */
  effectiveDate?: InputMaybe<SortEnumType>;
  /** File Id */
  fileId?: InputMaybe<SortEnumType>;
  /** Group Id. Client's G#. */
  groupId?: InputMaybe<SortEnumType>;
  /** Input Filename. Client's uploaded filename. */
  inputFilename?: InputMaybe<SortEnumType>;
  /** Output Filename */
  outputFilename?: InputMaybe<SortEnumType>;
  /** Payer Id */
  payerId?: InputMaybe<SortEnumType>;
  /** Payer Name */
  payerName?: InputMaybe<SortEnumType>;
  /** Payer Tax Id */
  payerTaxId?: InputMaybe<SortEnumType>;
  /** Payment Amount */
  paymentAmount?: InputMaybe<SortEnumType>;
  /** File Status. FileStatus */
  status?: InputMaybe<SortEnumType>;
  /** Submitter Id */
  submitterId?: InputMaybe<SortEnumType>;
  /** Submitter Name */
  submitterName?: InputMaybe<SortEnumType>;
  /** Trace Number */
  traceNumber?: InputMaybe<SortEnumType>;
  /** Transmission Date */
  transmissionDate?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type EraPaymentsConnection = {
  __typename?: 'EraPaymentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EraPaymentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<EraFilePaymentResponse>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EraPaymentsEdge = {
  __typename?: 'EraPaymentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EraFilePaymentResponse>;
};

export type Fee = {
  __typename?: 'Fee';
  claimStatusNonPar?: Maybe<Scalars['Decimal']['output']>;
  claimStatusPar?: Maybe<Scalars['Decimal']['output']>;
  dateLastDbUpdate?: Maybe<Scalars['DateTime']['output']>;
  dateSetup?: Maybe<Scalars['DateTime']['output']>;
  dateTerminate?: Maybe<Scalars['DateTime']['output']>;
  ecsFeeNonPar?: Maybe<Scalars['Decimal']['output']>;
  ecsFeePar?: Maybe<Scalars['Decimal']['output']>;
  ediFee?: Maybe<Scalars['Decimal']['output']>;
  eligibilityFeeNonPar?: Maybe<Scalars['Decimal']['output']>;
  eligibilityFeePar?: Maybe<Scalars['Decimal']['output']>;
  eraFeeNonPar?: Maybe<Scalars['Decimal']['output']>;
  eraFeePar?: Maybe<Scalars['Decimal']['output']>;
  freeDays?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  installFee?: Maybe<Scalars['Decimal']['output']>;
  name: Scalars['String']['output'];
  paperClaims?: Maybe<Scalars['Decimal']['output']>;
  providerGroups?: Maybe<Array<Maybe<ProviderGroup>>>;
  recordStatus: Scalars['String']['output'];
  serviceFee?: Maybe<Scalars['Decimal']['output']>;
  statementsAdditionalPages?: Maybe<Scalars['Decimal']['output']>;
  statementsFirstPage?: Maybe<Scalars['Decimal']['output']>;
  taxRate?: Maybe<Scalars['Decimal']['output']>;
};

export type FeeFilterInput = {
  and?: InputMaybe<Array<FeeFilterInput>>;
  claimStatusNonPar?: InputMaybe<DecimalOperationFilterInput>;
  claimStatusPar?: InputMaybe<DecimalOperationFilterInput>;
  dateLastDbUpdate?: InputMaybe<DateTimeOperationFilterInput>;
  dateSetup?: InputMaybe<DateTimeOperationFilterInput>;
  dateTerminate?: InputMaybe<DateTimeOperationFilterInput>;
  ecsFeeNonPar?: InputMaybe<DecimalOperationFilterInput>;
  ecsFeePar?: InputMaybe<DecimalOperationFilterInput>;
  ediFee?: InputMaybe<DecimalOperationFilterInput>;
  eligibilityFeeNonPar?: InputMaybe<DecimalOperationFilterInput>;
  eligibilityFeePar?: InputMaybe<DecimalOperationFilterInput>;
  eraFeeNonPar?: InputMaybe<DecimalOperationFilterInput>;
  eraFeePar?: InputMaybe<DecimalOperationFilterInput>;
  freeDays?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  installFee?: InputMaybe<DecimalOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FeeFilterInput>>;
  paperClaims?: InputMaybe<DecimalOperationFilterInput>;
  providerGroups?: InputMaybe<ListFilterInputTypeOfProviderGroupFilterInput>;
  recordStatus?: InputMaybe<StringOperationFilterInput>;
  serviceFee?: InputMaybe<DecimalOperationFilterInput>;
  statementsAdditionalPages?: InputMaybe<DecimalOperationFilterInput>;
  statementsFirstPage?: InputMaybe<DecimalOperationFilterInput>;
  taxRate?: InputMaybe<DecimalOperationFilterInput>;
};

export type FeeSortInput = {
  claimStatusNonPar?: InputMaybe<SortEnumType>;
  claimStatusPar?: InputMaybe<SortEnumType>;
  dateLastDbUpdate?: InputMaybe<SortEnumType>;
  dateSetup?: InputMaybe<SortEnumType>;
  dateTerminate?: InputMaybe<SortEnumType>;
  ecsFeeNonPar?: InputMaybe<SortEnumType>;
  ecsFeePar?: InputMaybe<SortEnumType>;
  ediFee?: InputMaybe<SortEnumType>;
  eligibilityFeeNonPar?: InputMaybe<SortEnumType>;
  eligibilityFeePar?: InputMaybe<SortEnumType>;
  eraFeeNonPar?: InputMaybe<SortEnumType>;
  eraFeePar?: InputMaybe<SortEnumType>;
  freeDays?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  installFee?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  paperClaims?: InputMaybe<SortEnumType>;
  recordStatus?: InputMaybe<SortEnumType>;
  serviceFee?: InputMaybe<SortEnumType>;
  statementsAdditionalPages?: InputMaybe<SortEnumType>;
  statementsFirstPage?: InputMaybe<SortEnumType>;
  taxRate?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type FeesConnection = {
  __typename?: 'FeesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FeesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Fee>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FeesEdge = {
  __typename?: 'FeesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Fee>;
};

export type FileStatus =
  | 'COMPLETE'
  | 'DUPLICATE'
  | 'HELD'
  | 'IN_PROCESS'
  | 'MISSING'
  | 'RETRY'
  | 'TEST'
  | 'WAITING';

export type FileStatusOperationFilterInput = {
  eq?: InputMaybe<FileStatus>;
  in?: InputMaybe<Array<FileStatus>>;
  neq?: InputMaybe<FileStatus>;
  nin?: InputMaybe<Array<FileStatus>>;
};

export type FormatType = {
  __typename?: 'FormatType';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type FormatTypeFilterInput = {
  and?: InputMaybe<Array<FormatTypeFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormatTypeFilterInput>>;
};

export type FormatTypeSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type FormatTypesConnection = {
  __typename?: 'FormatTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FormatTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<FormatType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FormatTypesEdge = {
  __typename?: 'FormatTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FormatType>;
};

export type GraphQlClaimSearchFiltersInput = {
  billingNPI?: InputMaybe<Scalars['String']['input']>;
  /** claimid */
  claimId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Claim status.
   * Valid value: SC_REJECTED, NON_SC_REJECTED, FINALIZED_DENIED, ALL_REJECTED, ACCEPTED_PENDING, FINALIZED_PAID, ALL_ACCEPTED, ALL_FINALIZED, TEST, NULL
   * Default: All
   */
  claimStatus?: InputMaybe<Scalars['String']['input']>;
  claimsDateType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Claim format type.
   * Default: None
   */
  formatType?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  patientAccountNumber?: InputMaybe<Scalars['String']['input']>;
  patientName?: InputMaybe<Scalars['String']['input']>;
  payer?: InputMaybe<Scalars['String']['input']>;
  receiver?: InputMaybe<Scalars['String']['input']>;
  renderNPI?: InputMaybe<Scalars['String']['input']>;
  showLast?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  taxID?: InputMaybe<Scalars['String']['input']>;
};

export type GroupCode = {
  __typename?: 'GroupCode';
  accountNumber?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GroupEnrollment = {
  __typename?: 'GroupEnrollment';
  actionNotes?: Maybe<Scalars['String']['output']>;
  agreementApprovedDate?: Maybe<Scalars['DateTime']['output']>;
  agreementDeniedDate?: Maybe<Scalars['DateTime']['output']>;
  agreementSentDate?: Maybe<Scalars['DateTime']['output']>;
  agreementSubmittedDate?: Maybe<Scalars['DateTime']['output']>;
  caseNumber?: Maybe<Scalars['String']['output']>;
  dateLastDbUpdate?: Maybe<Scalars['DateTime']['output']>;
  dateSetup?: Maybe<Scalars['DateTime']['output']>;
  ediId?: Maybe<Scalars['String']['output']>;
  enrollmentId?: Maybe<Scalars['String']['output']>;
  enrollmentOwner?: Maybe<Scalars['String']['output']>;
  enrollmentStatus: Scalars['String']['output'];
  enrollmentType: Scalars['String']['output'];
  followUpDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  npi: Scalars['String']['output'];
  /** This is the payer associated to this groupenrollment. */
  payer?: Maybe<Payer>;
  payerId: Scalars['String']['output'];
  pms?: Maybe<Scalars['String']['output']>;
  processorId: Scalars['String']['output'];
  /** This is the provider associated to this groupenrollment. */
  provider?: Maybe<Provider>;
  /** This is the provider group associated to this groupenrollment. */
  providerGroup?: Maybe<ProviderGroup>;
  seqNo: Scalars['Int']['output'];
  taxId: Scalars['String']['output'];
  useApi?: Maybe<Scalars['String']['output']>;
};

export type GroupEnrollmentFilterInput = {
  actionNotes?: InputMaybe<StringOperationFilterInput>;
  agreementApprovedDate?: InputMaybe<DateTimeOperationFilterInput>;
  agreementDeniedDate?: InputMaybe<DateTimeOperationFilterInput>;
  agreementSentDate?: InputMaybe<DateTimeOperationFilterInput>;
  agreementSubmittedDate?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<GroupEnrollmentFilterInput>>;
  caseNumber?: InputMaybe<StringOperationFilterInput>;
  dateLastDbUpdate?: InputMaybe<DateTimeOperationFilterInput>;
  dateSetup?: InputMaybe<DateTimeOperationFilterInput>;
  ediId?: InputMaybe<StringOperationFilterInput>;
  enrollmentId?: InputMaybe<StringOperationFilterInput>;
  enrollmentOwner?: InputMaybe<StringOperationFilterInput>;
  enrollmentStatus?: InputMaybe<StringOperationFilterInput>;
  enrollmentType?: InputMaybe<StringOperationFilterInput>;
  followUpDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastUpdatedBy?: InputMaybe<StringOperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  npi?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<GroupEnrollmentFilterInput>>;
  payer?: InputMaybe<PayerFilterInput>;
  payerId?: InputMaybe<StringOperationFilterInput>;
  pms?: InputMaybe<StringOperationFilterInput>;
  processorId?: InputMaybe<StringOperationFilterInput>;
  provider?: InputMaybe<ProviderFilterInput>;
  providerGroup?: InputMaybe<ProviderGroupFilterInput>;
  seqNo?: InputMaybe<IntOperationFilterInput>;
  taxId?: InputMaybe<StringOperationFilterInput>;
  useApi?: InputMaybe<StringOperationFilterInput>;
};

export type GroupEnrollmentSortInput = {
  actionNotes?: InputMaybe<SortEnumType>;
  agreementApprovedDate?: InputMaybe<SortEnumType>;
  agreementDeniedDate?: InputMaybe<SortEnumType>;
  agreementSentDate?: InputMaybe<SortEnumType>;
  agreementSubmittedDate?: InputMaybe<SortEnumType>;
  caseNumber?: InputMaybe<SortEnumType>;
  dateLastDbUpdate?: InputMaybe<SortEnumType>;
  dateSetup?: InputMaybe<SortEnumType>;
  ediId?: InputMaybe<SortEnumType>;
  enrollmentId?: InputMaybe<SortEnumType>;
  enrollmentOwner?: InputMaybe<SortEnumType>;
  enrollmentStatus?: InputMaybe<SortEnumType>;
  enrollmentType?: InputMaybe<SortEnumType>;
  followUpDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdatedBy?: InputMaybe<SortEnumType>;
  message?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  npi?: InputMaybe<SortEnumType>;
  payer?: InputMaybe<PayerSortInput>;
  payerId?: InputMaybe<SortEnumType>;
  pms?: InputMaybe<SortEnumType>;
  processorId?: InputMaybe<SortEnumType>;
  provider?: InputMaybe<ProviderSortInput>;
  providerGroup?: InputMaybe<ProviderGroupSortInput>;
  seqNo?: InputMaybe<SortEnumType>;
  taxId?: InputMaybe<SortEnumType>;
  useApi?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type GroupEnrollmentsConnection = {
  __typename?: 'GroupEnrollmentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<GroupEnrollmentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<GroupEnrollment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GroupEnrollmentsEdge = {
  __typename?: 'GroupEnrollmentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GroupEnrollment>;
};

export type ICheckCanadaInput = {
  /** The payer account number used for a check transaction. Maximum  length is 17 for the US and 12 for Canada. */
  account_number: Scalars['String']['input'];
  /** The type of payer account used for a check transaction: checking, savings */
  account_type?: InputMaybe<Scalars['String']['input']>;
  /** Identifies the specific bank branch of a Canadian financial  institution used for the check transaction. The five-digit code is the first series of numbers listed along the bottom of a check.  */
  branch_transit_number: Scalars['String']['input'];
  /** Three digit number that identifies the financial institution used for the check  transaction. */
  financial_institution_number: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export type ICheckInput = {
  /** The payer account number used for a check transaction. Maximum  length is 17 for the US and 12 for Canada. */
  account_number: Scalars['String']['input'];
  /** The type of payer account used for a check transaction: checking, savings */
  account_type?: InputMaybe<Scalars['String']['input']>;
  /** Routing number for a check transaction. */
  routing_number: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export type ICheckSaleCanadaInputAchInput = {
  balance_response?: InputMaybe<ThirdPartyBalanceResponseInput>;
  check: ICheckCanadaInput;
  consumer?: InputMaybe<ThirdPartyConsumerObjectInput>;
  customer: ICustomerAchInput;
  patientId?: InputMaybe<Scalars['String']['input']>;
  payment: IPaymentAchInput;
  /** Unique identifier for the sale. This is an alphanumeric value that the merchant creates, for example, XAZR863990. If not supplied, a unique value is generated. */
  reference_id?: InputMaybe<Scalars['String']['input']>;
  transaction: ITransactionAchCanadaInput;
};

export type ICheckSaleInputAchInput = {
  balance_response?: InputMaybe<ThirdPartyBalanceResponseInput>;
  check: ICheckInput;
  consumer?: InputMaybe<ThirdPartyConsumerObjectInput>;
  customer: ICustomerAchInput;
  patientId?: InputMaybe<Scalars['String']['input']>;
  payment: IPaymentAchInput;
  /** Unique identifier for the sale. This is an alphanumeric value that the merchant creates, for example, XAZR863990. If not supplied, a unique value is generated. */
  reference_id?: InputMaybe<Scalars['String']['input']>;
  transaction: ITransactionAchInput;
};

export type ICheckSaleRefundInput = {
  /** The type of payer account used for a check transaction: checking, savings */
  account_type?: InputMaybe<Scalars['String']['input']>;
};

export type ICheckSaleRefundInputAchInput = {
  check: ICheckSaleRefundInput;
  payment: IPaymentRefundAchInput;
  referenceId: Scalars['String']['input'];
  transaction: ITransactionRefundAchInput;
};

export type ICheckSaleRefundWithoutPreviousTransactionCanadaInput = {
  /** The payer account number used for a check transaction. Maximum  length is 17 for the US and 12 for Canada. */
  account_number: Scalars['String']['input'];
  /** The type of payer account used for a check transaction: Checking, Savings */
  account_type: Scalars['String']['input'];
  /** Identifies the specific bank branch of a Canadian financial  institution used for the check transaction. The five-digit code is the first series of numbers listed along the bottom of a check.  */
  branch_transit_number: Scalars['String']['input'];
  /** Three digit number that identifies the financial institution used for the check  transaction. */
  financial_institution_number: Scalars['String']['input'];
};

export type ICheckSaleRefundWithoutPreviousTransactionInput = {
  /** The payer account number used for a check transaction. Maximum  length is 17 for the US and 12 for Canada. */
  account_number: Scalars['String']['input'];
  /** The type of payer account used for a check transaction: checking, savings */
  account_type: Scalars['String']['input'];
  /** Routing number for a check transaction. */
  routing_number: Scalars['String']['input'];
};

export type ICheckSaleViewDetailsInputAchInput = {
  checksale_id?: InputMaybe<Scalars['String']['input']>;
  reference_id?: InputMaybe<Scalars['String']['input']>;
};

export type ICountryLookupInput = {
  countryAlphaCode?: InputMaybe<Scalars['String']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
};

export type ICustomerAchInput = {
  /** Business name. Note: If the customer is not a business, send a value for each of the following parameters: first_name and last_name. */
  business_name?: InputMaybe<Scalars['String']['input']>;
  /** Customer’s first name. Note: If the customer is a business, do not send this parameter. Send the business_name parameter. */
  first_name?: InputMaybe<Scalars['String']['input']>;
  /** Customer’s last name. Note: If the customer is a business, do not send this parameter. Send the business_name parameter. */
  last_name?: InputMaybe<Scalars['String']['input']>;
  /** Customer’s middle name. Note: If the customer is a business, do not send this parameter. Send the business_name parameter. */
  middle_name?: InputMaybe<Scalars['String']['input']>;
};

export type IHealthcareAmountInput = {
  /** Total dollar amount for clinical expenses. */
  clinical_amount: Scalars['String']['input'];
  /** Total dollar amount for healthcare copayments. */
  copay_amount: Scalars['String']['input'];
  /** Total dollar amount for dental expenses. */
  dental_amount: Scalars['String']['input'];
  /** Total dollar amount of all healthcare services. */
  healthcare_total_amount: Scalars['String']['input'];
  /** Total dollar amount for prescription expenses. */
  prescription_amount: Scalars['String']['input'];
  /** Total dollar amount for vision expenses. */
  vision_amount: Scalars['String']['input'];
};

export type ILanguageLookupInput = {
  countryAlphaCode?: InputMaybe<Scalars['String']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type IPaymentAchInput = {
  amount: Scalars['String']['input'];
  currency_code: Scalars['String']['input'];
};

export type IPaymentInput = {
  /** The amount of the payment. */
  amount: Scalars['String']['input'];
  /** Currency code for the payment. If unsupplied, a lookup is performed based on the country name/ISO code (required if this is not supplied). */
  currency_code?: InputMaybe<Scalars['String']['input']>;
  gratuity_eligible_amount?: InputMaybe<Scalars['String']['input']>;
  healthcare_amounts?: InputMaybe<IHealthcareAmountInput>;
  /** Alphanumeric invoice number or order number that the merchant creates and assigns to the sale. If not supplied, a unique value is generated. */
  invoice_number?: InputMaybe<Scalars['String']['input']>;
  purchase_order?: InputMaybe<IPurchaseOrderInput>;
};

export type IPaymentRefundAchInput = {
  amount: Scalars['String']['input'];
};

export type IProcessingIndicatorInput = {
  /** If set to true, you can send duplicate requests. The default time frame to block duplicate transactions is 15 minutes. */
  allow_duplicate?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, we save the card details to our vault. Our gateway creates a token and returns it in the response. */
  create_token?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, we allow you to accept partial approvals. */
  partial_approval?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IPurchaseOrderInput = {
  /** Postal code of the destination where the merchant ships the goods to. */
  destination_postal_code: Scalars['String']['input'];
  /** Purchase order number for the transaction when the customer uses a corporate purchase card. */
  po_number: Scalars['String']['input'];
  /** Total tax amount for the transaction. */
  tax_amount: Scalars['String']['input'];
};

export type IReceiptInput = {
  /** Clerk ID that the merchant wants to display on the receipt. This is an alphanumeric value that the merchant assigns to a clerk, for example, Al090-John Doe. */
  clerk_id: Scalars['String']['input'];
};

export type ISaleExtraInput = {
  payment?: InputMaybe<ICountryLookupInput>;
  transaction?: InputMaybe<ISaleExtraTransactionInput>;
};

export type ISaleExtraTransactionInput = {
  country?: InputMaybe<ICountryLookupInput>;
  language?: InputMaybe<ILanguageLookupInput>;
};

export type ISaleInput = {
  balanceResponse?: InputMaybe<CareTrackerBalanceResponseInput>;
  careTrackerConsumer?: InputMaybe<CareTrackerConsumerInput>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  extra?: InputMaybe<ISaleExtraInput>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  payment: IPaymentInput;
  receipt: IReceiptInput;
  /** Unique identifier for the sale. This is an alphanumeric value that the merchant creates, for example, XAZR863990. If not supplied, a unique value is generated. */
  reference_id?: InputMaybe<Scalars['String']['input']>;
  transaction: ITransactionInput;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type ITerminalInput = {
  /** Unique numeric value that we assign to the terminal, for example, 90030234. */
  terminal_id: Scalars['String']['input'];
};

export type ITransactionAchCanadaInput = {
  country_code: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  /** Three digit code used by a payment originator to identify a Canada check  payment and enables the identification of payment types to customers. */
  payment_purpose_code: Scalars['String']['input'];
  processing_indicators?: InputMaybe<IProcessingIndicatorInput>;
};

export type ITransactionAchInput = {
  country_code: Scalars['String']['input'];
  entry_class?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  processing_indicators?: InputMaybe<IProcessingIndicatorInput>;
};

export type ITransactionInput = {
  /** Country code for the payment. If unsupplied, a lookup is performed based on the country name/ISO code (required if this is not supplied). */
  country_code?: InputMaybe<Scalars['String']['input']>;
  create_token_reason?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the device allows the user to enter the card details using the keypad */
  keyed_entry_mode?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  processing_indicators?: InputMaybe<IProcessingIndicatorInput>;
  terminal?: InputMaybe<ITerminalInput>;
};

export type ITransactionRefundAchInput = {
  entry_class?: InputMaybe<Scalars['String']['input']>;
};

export type IccResponse = {
  __typename?: 'IccResponse';
  application_cryptogram?: Maybe<Scalars['String']['output']>;
  application_cryptogram_type?: Maybe<Scalars['String']['output']>;
  application_display_name?: Maybe<Scalars['String']['output']>;
  application_interchange_profile?: Maybe<Scalars['String']['output']>;
  application_label?: Maybe<Scalars['String']['output']>;
  application_preferred_name?: Maybe<Scalars['String']['output']>;
  application_transaction_counter?: Maybe<Scalars['String']['output']>;
  application_usage_control?: Maybe<Scalars['String']['output']>;
  application_version_number?: Maybe<Scalars['String']['output']>;
  authorization_response_code?: Maybe<Scalars['String']['output']>;
  cardholder_verification_method_results?: Maybe<Scalars['String']['output']>;
  cryptogram_information_data?: Maybe<Scalars['String']['output']>;
  cvm_method?: Maybe<Scalars['String']['output']>;
  dedicated_file_name?: Maybe<Scalars['String']['output']>;
  iac_default?: Maybe<Scalars['String']['output']>;
  iac_denial?: Maybe<Scalars['String']['output']>;
  iac_online?: Maybe<Scalars['String']['output']>;
  issuer_application_data?: Maybe<Scalars['String']['output']>;
  pos_entry_mode?: Maybe<Scalars['String']['output']>;
  tac_default?: Maybe<Scalars['String']['output']>;
  tac_denial?: Maybe<Scalars['String']['output']>;
  tac_online?: Maybe<Scalars['String']['output']>;
  terminal_country_code?: Maybe<Scalars['String']['output']>;
  terminal_type?: Maybe<Scalars['String']['output']>;
  terminal_verification_results?: Maybe<Scalars['String']['output']>;
  transaction_currency_code?: Maybe<Scalars['String']['output']>;
  transaction_status_information?: Maybe<Scalars['String']['output']>;
  transaction_type?: Maybe<Scalars['String']['output']>;
  unpredictable_number?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type InsuranceCompaniesConnection = {
  __typename?: 'InsuranceCompaniesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InsuranceCompaniesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<InsuranceCompanySearchResponse>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InsuranceCompaniesEdge = {
  __typename?: 'InsuranceCompaniesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InsuranceCompanySearchResponse>;
};

export type InsuranceCompanyResponse = {
  __typename?: 'InsuranceCompanyResponse';
  attachmentEnrollment?: Maybe<Scalars['String']['output']>;
  attachmentType?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Scalars['String']['output']>;
  claimFilingIndicator?: Maybe<Scalars['String']['output']>;
  claimStatus?: Maybe<Scalars['String']['output']>;
  claimStatusEnrollment?: Maybe<Scalars['String']['output']>;
  claimStatusId?: Maybe<Scalars['String']['output']>;
  claimStatusType?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactFax?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  dateLastDbUpdate?: Maybe<Scalars['DateTime']['output']>;
  doesEligibility?: Maybe<Scalars['String']['output']>;
  eligibilityEnrollment?: Maybe<Scalars['String']['output']>;
  eligibilityType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insuranceCompanyCode?: Maybe<Scalars['String']['output']>;
  lastNexiaOutputDate?: Maybe<Scalars['DateTime']['output']>;
  legacy?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neicId?: Maybe<Scalars['String']['output']>;
  nexia?: Maybe<Scalars['String']['output']>;
  nexiaPayerMasterId?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  payerState?: Maybe<Scalars['String']['output']>;
  publishEra?: Maybe<Scalars['String']['output']>;
  publishInstitutional?: Maybe<Scalars['String']['output']>;
  publishProfessional?: Maybe<Scalars['String']['output']>;
  realtimeId?: Maybe<Scalars['String']['output']>;
  recId: Scalars['Int']['output'];
  recordStatus?: Maybe<Scalars['String']['output']>;
  webUrl?: Maybe<Scalars['String']['output']>;
};

export type InsuranceCompanySearchResponse = {
  __typename?: 'InsuranceCompanySearchResponse';
  ediId?: Maybe<Scalars['String']['output']>;
  formatType?: Maybe<Scalars['String']['output']>;
  insuranceCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  processorId?: Maybe<Scalars['String']['output']>;
  recId: Scalars['Int']['output'];
  recordStatus?: Maybe<Scalars['String']['output']>;
  requiresEnrollment?: Maybe<Scalars['String']['output']>;
};

export type InsuranceCompanySearchResponseFilterInput = {
  and?: InputMaybe<Array<InsuranceCompanySearchResponseFilterInput>>;
  ediId?: InputMaybe<StringOperationFilterInput>;
  formatType?: InputMaybe<StringOperationFilterInput>;
  insuranceCode?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InsuranceCompanySearchResponseFilterInput>>;
  processorId?: InputMaybe<StringOperationFilterInput>;
  recId?: InputMaybe<IntOperationFilterInput>;
  recordStatus?: InputMaybe<StringOperationFilterInput>;
  requiresEnrollment?: InputMaybe<StringOperationFilterInput>;
};

export type InsuranceCompanySearchResponseSortInput = {
  ediId?: InputMaybe<SortEnumType>;
  formatType?: InputMaybe<SortEnumType>;
  insuranceCode?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  processorId?: InputMaybe<SortEnumType>;
  recId?: InputMaybe<SortEnumType>;
  recordStatus?: InputMaybe<SortEnumType>;
  requiresEnrollment?: InputMaybe<SortEnumType>;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type LineItem = {
  __typename?: 'LineItem';
  accountNumber?: Maybe<Scalars['String']['output']>;
  amountDue?: Maybe<Scalars['String']['output']>;
  amountPaid?: Maybe<Scalars['String']['output']>;
  consumerNumber?: Maybe<Scalars['String']['output']>;
  ctccTransID?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gatewayRoutingCode?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  serviceDate?: Maybe<Scalars['String']['output']>;
};

export type LineItemInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  amountDue?: InputMaybe<Scalars['String']['input']>;
  amountPaid?: InputMaybe<Scalars['String']['input']>;
  consumerNumber?: InputMaybe<Scalars['String']['input']>;
  ctccTransID?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gatewayRoutingCode?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  serviceDate?: InputMaybe<Scalars['String']['input']>;
};

export type ListFilterInputTypeOfBillingIdsFilterInput = {
  all?: InputMaybe<BillingIdsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BillingIdsFilterInput>;
  some?: InputMaybe<BillingIdsFilterInput>;
};

export type ListFilterInputTypeOfGroupEnrollmentFilterInput = {
  all?: InputMaybe<GroupEnrollmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<GroupEnrollmentFilterInput>;
  some?: InputMaybe<GroupEnrollmentFilterInput>;
};

export type ListFilterInputTypeOfPayerRoutingFilterInput = {
  all?: InputMaybe<PayerRoutingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PayerRoutingFilterInput>;
  some?: InputMaybe<PayerRoutingFilterInput>;
};

export type ListFilterInputTypeOfPreferredRoutingFilterInput = {
  all?: InputMaybe<PreferredRoutingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PreferredRoutingFilterInput>;
  some?: InputMaybe<PreferredRoutingFilterInput>;
};

export type ListFilterInputTypeOfProviderFilterInput = {
  all?: InputMaybe<ProviderFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProviderFilterInput>;
  some?: InputMaybe<ProviderFilterInput>;
};

export type ListFilterInputTypeOfProviderGroupFilterInput = {
  all?: InputMaybe<ProviderGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProviderGroupFilterInput>;
  some?: InputMaybe<ProviderGroupFilterInput>;
};

export type ListFilterInputTypeOfUsersClientsAcctsFilterInput = {
  all?: InputMaybe<UsersClientsAcctsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UsersClientsAcctsFilterInput>;
  some?: InputMaybe<UsersClientsAcctsFilterInput>;
};

export type ListFilterInputTypeOfUsersClientsAppsFilterInput = {
  all?: InputMaybe<UsersClientsAppsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UsersClientsAppsFilterInput>;
  some?: InputMaybe<UsersClientsAppsFilterInput>;
};

export type ListFilterInputTypeOfUsersClientsGrpsFilterInput = {
  all?: InputMaybe<UsersClientsGrpsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UsersClientsGrpsFilterInput>;
  some?: InputMaybe<UsersClientsGrpsFilterInput>;
};

export type ListFilterInputTypeOfUsersClientsPermissionsFilterInput = {
  all?: InputMaybe<UsersClientsPermissionsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UsersClientsPermissionsFilterInput>;
  some?: InputMaybe<UsersClientsPermissionsFilterInput>;
};

export type LoginInput = {
  /** Whether or not the token is a session token */
  isSession?: InputMaybe<Scalars['Boolean']['input']>;
  /** The password for the user */
  password: Scalars['String']['input'];
  /** The username */
  username: Scalars['String']['input'];
};

export type LoginResult = {
  __typename?: 'LoginResult';
  cookie?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  neq?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addTwoFactorAuthentication: Scalars['Boolean']['output'];
  createThirdPartyCookie?: Maybe<Scalars['String']['output']>;
  /**
   * Create a new PaymentsRecurringPayment.
   *
   *
   * **Returns:**
   * Whether or not the insert was successful or not.
   */
  insertRecurringPayment: Scalars['Boolean']['output'];
  /**
   * Returns whether or not Two Factor Authentication is enabled for the user.
   *
   *
   * **Returns:**
   * The secret
   */
  isTwoFactorAuthenticationEnabled: Scalars['Boolean']['output'];
  login?: Maybe<LoginResult>;
  logout: Scalars['Boolean']['output'];
  refundCheckSaleACH?: Maybe<CheckSaleRefundResponse>;
  refundCheckSaleCanadaACH?: Maybe<CheckSaleRefundCanadaResponse>;
  refundCheckSaleWithoutPreviousTransactionACH?: Maybe<CheckSaleRefundWithoutPreviousTransactionResponse>;
  refundCheckSaleWithoutPreviousTransactionCanadaACH?: Maybe<CheckSaleRefundWithoutPreviousTransactionCanadaResponse>;
  /**
   * Removes Two Factor Authentication for the user.
   *
   *
   * **Returns:**
   * The secret
   */
  removeTwoFactorAuthentication: Scalars['Boolean']['output'];
  runCheckSaleACH?: Maybe<RunCheckSaleAchResponse>;
  runCheckSaleCanadaACH?: Maybe<RunCheckSaleCanadaAchResponse>;
  /**
   * Create a new ISaleInput.
   *
   *
   * **Returns:**
   * The created SaleResponse.
   */
  sale?: Maybe<SaleResponse>;
  /**
   * Returns a secret (to be used for two factor authentication).
   *
   *
   * **Returns:**
   * The secret
   */
  twoFactorAuthenticationSecret?: Maybe<TwoFactorAuthenticationSecretResult>;
  /**
   * Returns whether or not the code is valid.
   *
   *
   * **Returns:**
   * Success or failure based on the code provided
   */
  verifyTwoFactorAuthenticationCode: Scalars['Boolean']['output'];
  viewDetailsCheckSale?: Maybe<CheckSaleViewDetailsResponse>;
};

export type MutationAddTwoFactorAuthenticationArgs = {
  input: TwoFactorAuthenticationInput;
};

export type MutationCreateThirdPartyCookieArgs = {
  input: ThirdPartyCookiesInput;
};

export type MutationInsertRecurringPaymentArgs = {
  input: RecurringPaymentInput;
};

export type MutationLoginArgs = {
  input: LoginInput;
};

export type MutationRefundCheckSaleAchArgs = {
  input: ICheckSaleRefundInputAchInput;
  providerId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRefundCheckSaleCanadaAchArgs = {
  input: ICheckSaleRefundInputAchInput;
  providerId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRefundCheckSaleWithoutPreviousTransactionAchArgs = {
  input: ICheckSaleRefundWithoutPreviousTransactionInput;
  providerId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRefundCheckSaleWithoutPreviousTransactionCanadaAchArgs = {
  input: ICheckSaleRefundWithoutPreviousTransactionCanadaInput;
  providerId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRunCheckSaleAchArgs = {
  input: ICheckSaleInputAchInput;
  providerId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRunCheckSaleCanadaAchArgs = {
  input: ICheckSaleCanadaInputAchInput;
  providerId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSaleArgs = {
  input: ISaleInput;
};

export type MutationVerifyTwoFactorAuthenticationCodeArgs = {
  input: TwoFactorAuthenticationCodeInput;
};

export type MutationViewDetailsCheckSaleArgs = {
  input: ICheckSaleViewDetailsInputAchInput;
  providerId?: InputMaybe<Scalars['String']['input']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PasswordConfigRegex = {
  __typename?: 'PasswordConfigRegex';
  regex?: Maybe<Scalars['String']['output']>;
};

export type PasswordConfigResponse = {
  __typename?: 'PasswordConfigResponse';
  id: Scalars['Int']['output'];
  maximumLength: Scalars['Int']['output'];
  minimumLength: Scalars['Int']['output'];
  numberIdenticalCharsInRow: Scalars['Int']['output'];
  requireLowercase: Scalars['Boolean']['output'];
  requireNumeric: Scalars['Boolean']['output'];
  requireUppercase: Scalars['Boolean']['output'];
  specialCharacters?: Maybe<Scalars['String']['output']>;
};

export type Patient = {
  __typename?: 'Patient';
  accountNumber?: Maybe<Scalars['String']['output']>;
  addressInfoId?: Maybe<Scalars['Long']['output']>;
  contactInfoId?: Maybe<Scalars['Long']['output']>;
  createOn: Scalars['DateTime']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  parentPatientId?: Maybe<Scalars['Long']['output']>;
  patientId: Scalars['Long']['output'];
  paymentCustomerId?: Maybe<Scalars['String']['output']>;
  providerGroupId?: Maybe<Scalars['String']['output']>;
  recurringPayments?: Maybe<Array<Maybe<PaymentsRecurringPayment>>>;
  vendorPatientId?: Maybe<Scalars['String']['output']>;
};

export type PatientFilterInput = {
  accountNumber?: InputMaybe<StringOperationFilterInput>;
  addressInfoId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<PatientFilterInput>>;
  contactInfoId?: InputMaybe<LongOperationFilterInput>;
  createOn?: InputMaybe<DateTimeOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PatientFilterInput>>;
  parentPatientId?: InputMaybe<LongOperationFilterInput>;
  patientId?: InputMaybe<LongOperationFilterInput>;
  paymentCustomerId?: InputMaybe<StringOperationFilterInput>;
  providerGroupId?: InputMaybe<StringOperationFilterInput>;
  vendorPatientId?: InputMaybe<StringOperationFilterInput>;
};

export type PatientSortInput = {
  accountNumber?: InputMaybe<SortEnumType>;
  addressInfoId?: InputMaybe<SortEnumType>;
  contactInfoId?: InputMaybe<SortEnumType>;
  createOn?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  parentPatientId?: InputMaybe<SortEnumType>;
  patientId?: InputMaybe<SortEnumType>;
  paymentCustomerId?: InputMaybe<SortEnumType>;
  providerGroupId?: InputMaybe<SortEnumType>;
  vendorPatientId?: InputMaybe<SortEnumType>;
};

export type PatientStatements = {
  __typename?: 'PatientStatements';
  createOn?: Maybe<Scalars['DateTime']['output']>;
  patientId: Scalars['Long']['output'];
  patientStatementId: Scalars['Long']['output'];
  responsiblePartyId: Scalars['Long']['output'];
  statementId: Scalars['Long']['output'];
};

export type PatientStatementsFilterInput = {
  and?: InputMaybe<Array<PatientStatementsFilterInput>>;
  createOn?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PatientStatementsFilterInput>>;
  patientId?: InputMaybe<LongOperationFilterInput>;
  patientStatementId?: InputMaybe<LongOperationFilterInput>;
  responsiblePartyId?: InputMaybe<LongOperationFilterInput>;
  statementId?: InputMaybe<LongOperationFilterInput>;
};

export type PatientStatementsResponse = {
  __typename?: 'PatientStatementsResponse';
  patientId: Scalars['Long']['output'];
  patientStatementId: Scalars['Long']['output'];
  responsiblePartyId: Scalars['Long']['output'];
  statementId: Scalars['Long']['output'];
};

export type PatientStatementsResponseFilterInput = {
  and?: InputMaybe<Array<PatientStatementsResponseFilterInput>>;
  or?: InputMaybe<Array<PatientStatementsResponseFilterInput>>;
  patientId?: InputMaybe<LongOperationFilterInput>;
  patientStatementId?: InputMaybe<LongOperationFilterInput>;
  responsiblePartyId?: InputMaybe<LongOperationFilterInput>;
  statementId?: InputMaybe<LongOperationFilterInput>;
};

export type PatientStatementsResponseSortInput = {
  patientId?: InputMaybe<SortEnumType>;
  patientStatementId?: InputMaybe<SortEnumType>;
  responsiblePartyId?: InputMaybe<SortEnumType>;
  statementId?: InputMaybe<SortEnumType>;
};

export type PatientStatementsSearchFilterInput = {
  patientId: Scalars['Long']['input'];
  patientStatementId: Scalars['Long']['input'];
  responsiblePartyId: Scalars['Long']['input'];
  statementId: Scalars['Long']['input'];
};

export type PatientStatementsSortInput = {
  createOn?: InputMaybe<SortEnumType>;
  patientId?: InputMaybe<SortEnumType>;
  patientStatementId?: InputMaybe<SortEnumType>;
  responsiblePartyId?: InputMaybe<SortEnumType>;
  statementId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type PatientStatementssConnection = {
  __typename?: 'PatientStatementssConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PatientStatementssEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<PatientStatements>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PatientStatementssEdge = {
  __typename?: 'PatientStatementssEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PatientStatements>;
};

/** A connection to a list of items. */
export type PatientsConnection = {
  __typename?: 'PatientsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PatientsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Patient>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PatientsEdge = {
  __typename?: 'PatientsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Patient>;
};

export type Payer = {
  __typename?: 'Payer';
  apg?: Maybe<Scalars['String']['output']>;
  attachmentEnrollment?: Maybe<Scalars['String']['output']>;
  attachmentSplit?: Maybe<Scalars['String']['output']>;
  attachmentType?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Scalars['String']['output']>;
  attachmentsProcessorId?: Maybe<Scalars['String']['output']>;
  batchClaimStatus?: Maybe<Scalars['String']['output']>;
  billingIndicator?: Maybe<Scalars['String']['output']>;
  cardId?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  claimFilingIndicator?: Maybe<Scalars['String']['output']>;
  claimStatus: Scalars['String']['output'];
  claimStatusEnrollment?: Maybe<Scalars['String']['output']>;
  claimStatusId?: Maybe<Scalars['String']['output']>;
  claimStatusType?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactFax?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  dateLastDbUpdate?: Maybe<Scalars['DateTime']['output']>;
  dateLastFile?: Maybe<Scalars['DateTime']['output']>;
  dateLastStatement?: Maybe<Scalars['DateTime']['output']>;
  dateSetup?: Maybe<Scalars['DateTime']['output']>;
  dateTerminate?: Maybe<Scalars['DateTime']['output']>;
  dentalProcessorId?: Maybe<Scalars['String']['output']>;
  doesEligibility?: Maybe<Scalars['String']['output']>;
  eligibilityEnrollment?: Maybe<Scalars['String']['output']>;
  eligibilityType?: Maybe<Scalars['String']['output']>;
  eraEnrollment?: Maybe<Scalars['String']['output']>;
  eraType?: Maybe<Scalars['String']['output']>;
  followUpNumberOfDays?: Maybe<Scalars['Int']['output']>;
  groupEnrolled?: Maybe<Scalars['String']['output']>;
  groupEnrollments?: Maybe<Array<Maybe<GroupEnrollment>>>;
  icd10?: Maybe<Scalars['String']['output']>;
  icd10EffectiveDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  institutionalEnrollment?: Maybe<Scalars['String']['output']>;
  institutionalType?: Maybe<Scalars['String']['output']>;
  legacy?: Maybe<Scalars['String']['output']>;
  legacyDbUpdate?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neicId: Scalars['String']['output'];
  neicOffice?: Maybe<Scalars['String']['output']>;
  neicPayerType?: Maybe<Scalars['String']['output']>;
  nexia?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  npiIndicator?: Maybe<Scalars['String']['output']>;
  payorState?: Maybe<Scalars['String']['output']>;
  payorType?: Maybe<Scalars['String']['output']>;
  preferredRoutings?: Maybe<Array<Maybe<PreferredRouting>>>;
  processorId?: Maybe<Scalars['String']['output']>;
  publishEra?: Maybe<Scalars['String']['output']>;
  publishInstitutional?: Maybe<Scalars['String']['output']>;
  publishProfessional?: Maybe<Scalars['String']['output']>;
  realTimeId?: Maybe<Scalars['String']['output']>;
  recordStatus?: Maybe<Scalars['String']['output']>;
  requiresEnrollment?: Maybe<Scalars['String']['output']>;
  secondaryClaims: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  ubProcessorId?: Maybe<Scalars['String']['output']>;
  webUrl?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type PayerFilterInput = {
  and?: InputMaybe<Array<PayerFilterInput>>;
  apg?: InputMaybe<StringOperationFilterInput>;
  attachmentEnrollment?: InputMaybe<StringOperationFilterInput>;
  attachmentSplit?: InputMaybe<StringOperationFilterInput>;
  attachmentType?: InputMaybe<StringOperationFilterInput>;
  attachments?: InputMaybe<StringOperationFilterInput>;
  attachmentsProcessorId?: InputMaybe<StringOperationFilterInput>;
  batchClaimStatus?: InputMaybe<StringOperationFilterInput>;
  billingIndicator?: InputMaybe<StringOperationFilterInput>;
  cardId?: InputMaybe<StringOperationFilterInput>;
  city?: InputMaybe<StringOperationFilterInput>;
  claimFilingIndicator?: InputMaybe<StringOperationFilterInput>;
  claimStatus?: InputMaybe<StringOperationFilterInput>;
  claimStatusEnrollment?: InputMaybe<StringOperationFilterInput>;
  claimStatusId?: InputMaybe<StringOperationFilterInput>;
  claimStatusType?: InputMaybe<StringOperationFilterInput>;
  contactEmail?: InputMaybe<StringOperationFilterInput>;
  contactFax?: InputMaybe<StringOperationFilterInput>;
  contactName?: InputMaybe<StringOperationFilterInput>;
  contactPhone?: InputMaybe<StringOperationFilterInput>;
  dateLastDbUpdate?: InputMaybe<DateTimeOperationFilterInput>;
  dateLastFile?: InputMaybe<DateTimeOperationFilterInput>;
  dateLastStatement?: InputMaybe<DateTimeOperationFilterInput>;
  dateSetup?: InputMaybe<DateTimeOperationFilterInput>;
  dateTerminate?: InputMaybe<DateTimeOperationFilterInput>;
  dentalProcessorId?: InputMaybe<StringOperationFilterInput>;
  doesEligibility?: InputMaybe<StringOperationFilterInput>;
  eligibilityEnrollment?: InputMaybe<StringOperationFilterInput>;
  eligibilityType?: InputMaybe<StringOperationFilterInput>;
  eraEnrollment?: InputMaybe<StringOperationFilterInput>;
  eraType?: InputMaybe<StringOperationFilterInput>;
  followUpNumberOfDays?: InputMaybe<IntOperationFilterInput>;
  groupEnrolled?: InputMaybe<StringOperationFilterInput>;
  groupEnrollments?: InputMaybe<ListFilterInputTypeOfGroupEnrollmentFilterInput>;
  icd10?: InputMaybe<StringOperationFilterInput>;
  icd10EffectiveDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  institutionalEnrollment?: InputMaybe<StringOperationFilterInput>;
  institutionalType?: InputMaybe<StringOperationFilterInput>;
  legacy?: InputMaybe<StringOperationFilterInput>;
  legacyDbUpdate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  neicId?: InputMaybe<StringOperationFilterInput>;
  neicOffice?: InputMaybe<StringOperationFilterInput>;
  neicPayerType?: InputMaybe<StringOperationFilterInput>;
  nexia?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  npiIndicator?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PayerFilterInput>>;
  payorState?: InputMaybe<StringOperationFilterInput>;
  payorType?: InputMaybe<StringOperationFilterInput>;
  preferredRoutings?: InputMaybe<ListFilterInputTypeOfPreferredRoutingFilterInput>;
  processorId?: InputMaybe<StringOperationFilterInput>;
  publishEra?: InputMaybe<StringOperationFilterInput>;
  publishInstitutional?: InputMaybe<StringOperationFilterInput>;
  publishProfessional?: InputMaybe<StringOperationFilterInput>;
  realTimeId?: InputMaybe<StringOperationFilterInput>;
  recordStatus?: InputMaybe<StringOperationFilterInput>;
  requiresEnrollment?: InputMaybe<StringOperationFilterInput>;
  secondaryClaims?: InputMaybe<StringOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  ubProcessorId?: InputMaybe<StringOperationFilterInput>;
  webUrl?: InputMaybe<StringOperationFilterInput>;
  zipCode?: InputMaybe<StringOperationFilterInput>;
};

export type PayerRouting = {
  __typename?: 'PayerRouting';
  ediId: Scalars['String']['output'];
  /** This is the processor associated to this payer routing. */
  processor?: Maybe<Processor>;
  processorId: Scalars['String']['output'];
  scId: Scalars['String']['output'];
};

export type PayerRoutingFilterInput = {
  and?: InputMaybe<Array<PayerRoutingFilterInput>>;
  ediId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PayerRoutingFilterInput>>;
  processor?: InputMaybe<ProcessorFilterInput>;
  processorId?: InputMaybe<StringOperationFilterInput>;
  scId?: InputMaybe<StringOperationFilterInput>;
};

export type PayerRoutingSortInput = {
  ediId?: InputMaybe<SortEnumType>;
  processor?: InputMaybe<ProcessorSortInput>;
  processorId?: InputMaybe<SortEnumType>;
  scId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type PayerRoutingsConnection = {
  __typename?: 'PayerRoutingsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PayerRoutingsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<PayerRouting>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PayerRoutingsEdge = {
  __typename?: 'PayerRoutingsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PayerRouting>;
};

export type PayerSortInput = {
  apg?: InputMaybe<SortEnumType>;
  attachmentEnrollment?: InputMaybe<SortEnumType>;
  attachmentSplit?: InputMaybe<SortEnumType>;
  attachmentType?: InputMaybe<SortEnumType>;
  attachments?: InputMaybe<SortEnumType>;
  attachmentsProcessorId?: InputMaybe<SortEnumType>;
  batchClaimStatus?: InputMaybe<SortEnumType>;
  billingIndicator?: InputMaybe<SortEnumType>;
  cardId?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  claimFilingIndicator?: InputMaybe<SortEnumType>;
  claimStatus?: InputMaybe<SortEnumType>;
  claimStatusEnrollment?: InputMaybe<SortEnumType>;
  claimStatusId?: InputMaybe<SortEnumType>;
  claimStatusType?: InputMaybe<SortEnumType>;
  contactEmail?: InputMaybe<SortEnumType>;
  contactFax?: InputMaybe<SortEnumType>;
  contactName?: InputMaybe<SortEnumType>;
  contactPhone?: InputMaybe<SortEnumType>;
  dateLastDbUpdate?: InputMaybe<SortEnumType>;
  dateLastFile?: InputMaybe<SortEnumType>;
  dateLastStatement?: InputMaybe<SortEnumType>;
  dateSetup?: InputMaybe<SortEnumType>;
  dateTerminate?: InputMaybe<SortEnumType>;
  dentalProcessorId?: InputMaybe<SortEnumType>;
  doesEligibility?: InputMaybe<SortEnumType>;
  eligibilityEnrollment?: InputMaybe<SortEnumType>;
  eligibilityType?: InputMaybe<SortEnumType>;
  eraEnrollment?: InputMaybe<SortEnumType>;
  eraType?: InputMaybe<SortEnumType>;
  followUpNumberOfDays?: InputMaybe<SortEnumType>;
  groupEnrolled?: InputMaybe<SortEnumType>;
  icd10?: InputMaybe<SortEnumType>;
  icd10EffectiveDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  institutionalEnrollment?: InputMaybe<SortEnumType>;
  institutionalType?: InputMaybe<SortEnumType>;
  legacy?: InputMaybe<SortEnumType>;
  legacyDbUpdate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  neicId?: InputMaybe<SortEnumType>;
  neicOffice?: InputMaybe<SortEnumType>;
  neicPayerType?: InputMaybe<SortEnumType>;
  nexia?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  npiIndicator?: InputMaybe<SortEnumType>;
  payorState?: InputMaybe<SortEnumType>;
  payorType?: InputMaybe<SortEnumType>;
  processorId?: InputMaybe<SortEnumType>;
  publishEra?: InputMaybe<SortEnumType>;
  publishInstitutional?: InputMaybe<SortEnumType>;
  publishProfessional?: InputMaybe<SortEnumType>;
  realTimeId?: InputMaybe<SortEnumType>;
  recordStatus?: InputMaybe<SortEnumType>;
  requiresEnrollment?: InputMaybe<SortEnumType>;
  secondaryClaims?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  ubProcessorId?: InputMaybe<SortEnumType>;
  webUrl?: InputMaybe<SortEnumType>;
  zipCode?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type PayersConnection = {
  __typename?: 'PayersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PayersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Payer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PayersEdge = {
  __typename?: 'PayersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Payer>;
};

export type Payload = {
  __typename?: 'Payload';
  consumerNumber?: Maybe<Scalars['String']['output']>;
  dataContext?: Maybe<DataContext>;
  deepLink?: Maybe<Scalars['String']['output']>;
  externalUsername?: Maybe<Scalars['String']['output']>;
  groupSiteName?: Maybe<Scalars['String']['output']>;
  orgSiteName?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  roleName?: Maybe<Scalars['String']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userFirstName?: Maybe<Scalars['String']['output']>;
  userLastName?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type PayloadInput = {
  consumerNumber?: InputMaybe<Scalars['String']['input']>;
  dataContext?: InputMaybe<DataContextInput>;
  deepLink?: InputMaybe<Scalars['String']['input']>;
  externalUsername?: InputMaybe<Scalars['String']['input']>;
  groupSiteName?: InputMaybe<Scalars['String']['input']>;
  orgSiteName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  roleName?: InputMaybe<Scalars['String']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userFirstName?: InputMaybe<Scalars['String']['input']>;
  userLastName?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentResponse = {
  __typename?: 'PaymentResponse';
  amount?: Maybe<Scalars['String']['output']>;
  cashback_amount?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PaymentsRecurringPayment = {
  __typename?: 'PaymentsRecurringPayment';
  amount: Scalars['Decimal']['output'];
  isActive: Scalars['Boolean']['output'];
  patientId: Scalars['Long']['output'];
  paymentPlan: PaymentsRecurringPaymentPlan;
  recurringPaymentId: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type PaymentsRecurringPaymentFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<PaymentsRecurringPaymentFilterInput>>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<PaymentsRecurringPaymentFilterInput>>;
  patientId?: InputMaybe<LongOperationFilterInput>;
  paymentPlan?: InputMaybe<PaymentsRecurringPaymentPlanOperationFilterInput>;
  recurringPaymentId?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type PaymentsRecurringPaymentPlan =
  | 'BI_WEEKLY'
  | 'FORTY_EIGHT_WEEKS'
  | 'MONTHLY';

export type PaymentsRecurringPaymentPlanOperationFilterInput = {
  eq?: InputMaybe<PaymentsRecurringPaymentPlan>;
  in?: InputMaybe<Array<PaymentsRecurringPaymentPlan>>;
  neq?: InputMaybe<PaymentsRecurringPaymentPlan>;
  nin?: InputMaybe<Array<PaymentsRecurringPaymentPlan>>;
};

export type PaymentsRecurringPaymentSortInput = {
  amount?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  patientId?: InputMaybe<SortEnumType>;
  paymentPlan?: InputMaybe<SortEnumType>;
  recurringPaymentId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
};

export type PermissionCode = {
  __typename?: 'PermissionCode';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Permissions = {
  __typename?: 'Permissions';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  usersClientsPermissions?: Maybe<Array<Maybe<UsersClientsPermissions>>>;
};

/** A connection to a list of items. */
export type PermissionsConnection = {
  __typename?: 'PermissionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PermissionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Permissions>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PermissionsEdge = {
  __typename?: 'PermissionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Permissions>;
};

export type PermissionsFilterInput = {
  and?: InputMaybe<Array<PermissionsFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PermissionsFilterInput>>;
  usersClientsPermissions?: InputMaybe<ListFilterInputTypeOfUsersClientsPermissionsFilterInput>;
};

export type PermissionsSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type PreferredRouting = {
  __typename?: 'PreferredRouting';
  dateLastDbUpdate?: Maybe<Scalars['DateTime']['output']>;
  dateSetup?: Maybe<Scalars['DateTime']['output']>;
  doc1?: Maybe<Scalars['String']['output']>;
  doc2?: Maybe<Scalars['String']['output']>;
  doc3?: Maybe<Scalars['String']['output']>;
  doc4?: Maybe<Scalars['String']['output']>;
  doc5?: Maybe<Scalars['String']['output']>;
  enrollmentType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** Payer associated to PreferredRouting ScId. */
  payer?: Maybe<Payer>;
  processorId: Scalars['String']['output'];
  scId: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type PreferredRoutingFilterInput = {
  and?: InputMaybe<Array<PreferredRoutingFilterInput>>;
  dateLastDbUpdate?: InputMaybe<DateTimeOperationFilterInput>;
  dateSetup?: InputMaybe<DateTimeOperationFilterInput>;
  doc1?: InputMaybe<StringOperationFilterInput>;
  doc2?: InputMaybe<StringOperationFilterInput>;
  doc3?: InputMaybe<StringOperationFilterInput>;
  doc4?: InputMaybe<StringOperationFilterInput>;
  doc5?: InputMaybe<StringOperationFilterInput>;
  enrollmentType?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lastUpdatedBy?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PreferredRoutingFilterInput>>;
  payer?: InputMaybe<PayerFilterInput>;
  processorId?: InputMaybe<StringOperationFilterInput>;
  scId?: InputMaybe<StringOperationFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
};

export type PreferredRoutingSortInput = {
  dateLastDbUpdate?: InputMaybe<SortEnumType>;
  dateSetup?: InputMaybe<SortEnumType>;
  doc1?: InputMaybe<SortEnumType>;
  doc2?: InputMaybe<SortEnumType>;
  doc3?: InputMaybe<SortEnumType>;
  doc4?: InputMaybe<SortEnumType>;
  doc5?: InputMaybe<SortEnumType>;
  enrollmentType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastUpdatedBy?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  payer?: InputMaybe<PayerSortInput>;
  processorId?: InputMaybe<SortEnumType>;
  scId?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type PreferredRoutingsConnection = {
  __typename?: 'PreferredRoutingsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PreferredRoutingsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<PreferredRouting>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PreferredRoutingsEdge = {
  __typename?: 'PreferredRoutingsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PreferredRouting>;
};

export type Processor = {
  __typename?: 'Processor';
  acknowledgementFormat?: Maybe<Scalars['String']['output']>;
  acknowledgmentRequested?: Maybe<Scalars['String']['output']>;
  addressCity?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressState?: Maybe<Scalars['String']['output']>;
  addressZipcode?: Maybe<Scalars['String']['output']>;
  billingMethod?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactFax?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  dateLastDbUpdate?: Maybe<Scalars['DateTime']['output']>;
  dateLastFile?: Maybe<Scalars['DateTime']['output']>;
  dateLastStatement?: Maybe<Scalars['DateTime']['output']>;
  dateLastTransmit?: Maybe<Scalars['DateTime']['output']>;
  dateSetup?: Maybe<Scalars['DateTime']['output']>;
  dateTerminate?: Maybe<Scalars['DateTime']['output']>;
  ediFormat: Scalars['String']['output'];
  ediReceiverId?: Maybe<Scalars['String']['output']>;
  ediSubmitterId?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  ftpKey?: Maybe<Scalars['String']['output']>;
  generateRemit?: Maybe<Scalars['String']['output']>;
  gs02AppSenderCode?: Maybe<Scalars['String']['output']>;
  gs03AppReceiverCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isa05IdQual?: Maybe<Scalars['String']['output']>;
  isa07IdQual?: Maybe<Scalars['String']['output']>;
  isa11identifier?: Maybe<Scalars['String']['output']>;
  isaAuthInfo?: Maybe<Scalars['String']['output']>;
  isaAuthInfoQual?: Maybe<Scalars['String']['output']>;
  isasecInfo?: Maybe<Scalars['String']['output']>;
  isasecInfoQual?: Maybe<Scalars['String']['output']>;
  mappingFilePath4010?: Maybe<Scalars['String']['output']>;
  mappingFilePath5010?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nm103Orgname?: Maybe<Scalars['String']['output']>;
  nm109IdCode?: Maybe<Scalars['String']['output']>;
  nm1091000bCode?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  nsfFileNumber?: Maybe<Scalars['Int']['output']>;
  nsfStatus?: Maybe<Scalars['String']['output']>;
  oneStSePerClaim?: Maybe<Scalars['String']['output']>;
  payerRoutings?: Maybe<Array<Maybe<PayerRouting>>>;
  per02Name?: Maybe<Scalars['String']['output']>;
  per03CommQual1?: Maybe<Scalars['String']['output']>;
  per04CommNum1?: Maybe<Scalars['String']['output']>;
  per05CommQual2?: Maybe<Scalars['String']['output']>;
  per06CommNum2?: Maybe<Scalars['String']['output']>;
  recordStatus?: Maybe<Scalars['String']['output']>;
  requiresSubmitter?: Maybe<Scalars['String']['output']>;
  singleSubmitter?: Maybe<Scalars['String']['output']>;
  statementMethod?: Maybe<Scalars['String']['output']>;
  technicalContact?: Maybe<Scalars['String']['output']>;
  technicalPhone?: Maybe<Scalars['String']['output']>;
};

export type ProcessorFilterInput = {
  acknowledgementFormat?: InputMaybe<StringOperationFilterInput>;
  acknowledgmentRequested?: InputMaybe<StringOperationFilterInput>;
  addressCity?: InputMaybe<StringOperationFilterInput>;
  addressLine1?: InputMaybe<StringOperationFilterInput>;
  addressLine2?: InputMaybe<StringOperationFilterInput>;
  addressState?: InputMaybe<StringOperationFilterInput>;
  addressZipcode?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ProcessorFilterInput>>;
  billingMethod?: InputMaybe<StringOperationFilterInput>;
  contactEmail?: InputMaybe<StringOperationFilterInput>;
  contactFax?: InputMaybe<StringOperationFilterInput>;
  contactName?: InputMaybe<StringOperationFilterInput>;
  contactPhone?: InputMaybe<StringOperationFilterInput>;
  dateLastDbUpdate?: InputMaybe<DateTimeOperationFilterInput>;
  dateLastFile?: InputMaybe<DateTimeOperationFilterInput>;
  dateLastStatement?: InputMaybe<DateTimeOperationFilterInput>;
  dateLastTransmit?: InputMaybe<DateTimeOperationFilterInput>;
  dateSetup?: InputMaybe<DateTimeOperationFilterInput>;
  dateTerminate?: InputMaybe<DateTimeOperationFilterInput>;
  ediFormat?: InputMaybe<StringOperationFilterInput>;
  ediReceiverId?: InputMaybe<StringOperationFilterInput>;
  ediSubmitterId?: InputMaybe<StringOperationFilterInput>;
  format?: InputMaybe<StringOperationFilterInput>;
  ftpKey?: InputMaybe<StringOperationFilterInput>;
  generateRemit?: InputMaybe<StringOperationFilterInput>;
  gs02AppSenderCode?: InputMaybe<StringOperationFilterInput>;
  gs03AppReceiverCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isa05IdQual?: InputMaybe<StringOperationFilterInput>;
  isa07IdQual?: InputMaybe<StringOperationFilterInput>;
  isa11identifier?: InputMaybe<StringOperationFilterInput>;
  isaAuthInfo?: InputMaybe<StringOperationFilterInput>;
  isaAuthInfoQual?: InputMaybe<StringOperationFilterInput>;
  isasecInfo?: InputMaybe<StringOperationFilterInput>;
  isasecInfoQual?: InputMaybe<StringOperationFilterInput>;
  mappingFilePath4010?: InputMaybe<StringOperationFilterInput>;
  mappingFilePath5010?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  nm103Orgname?: InputMaybe<StringOperationFilterInput>;
  nm109IdCode?: InputMaybe<StringOperationFilterInput>;
  nm1091000bCode?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  nsfFileNumber?: InputMaybe<IntOperationFilterInput>;
  nsfStatus?: InputMaybe<StringOperationFilterInput>;
  oneStSePerClaim?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProcessorFilterInput>>;
  payerRoutings?: InputMaybe<ListFilterInputTypeOfPayerRoutingFilterInput>;
  per02Name?: InputMaybe<StringOperationFilterInput>;
  per03CommQual1?: InputMaybe<StringOperationFilterInput>;
  per04CommNum1?: InputMaybe<StringOperationFilterInput>;
  per05CommQual2?: InputMaybe<StringOperationFilterInput>;
  per06CommNum2?: InputMaybe<StringOperationFilterInput>;
  recordStatus?: InputMaybe<StringOperationFilterInput>;
  requiresSubmitter?: InputMaybe<StringOperationFilterInput>;
  singleSubmitter?: InputMaybe<StringOperationFilterInput>;
  statementMethod?: InputMaybe<StringOperationFilterInput>;
  technicalContact?: InputMaybe<StringOperationFilterInput>;
  technicalPhone?: InputMaybe<StringOperationFilterInput>;
};

export type ProcessorSortInput = {
  acknowledgementFormat?: InputMaybe<SortEnumType>;
  acknowledgmentRequested?: InputMaybe<SortEnumType>;
  addressCity?: InputMaybe<SortEnumType>;
  addressLine1?: InputMaybe<SortEnumType>;
  addressLine2?: InputMaybe<SortEnumType>;
  addressState?: InputMaybe<SortEnumType>;
  addressZipcode?: InputMaybe<SortEnumType>;
  billingMethod?: InputMaybe<SortEnumType>;
  contactEmail?: InputMaybe<SortEnumType>;
  contactFax?: InputMaybe<SortEnumType>;
  contactName?: InputMaybe<SortEnumType>;
  contactPhone?: InputMaybe<SortEnumType>;
  dateLastDbUpdate?: InputMaybe<SortEnumType>;
  dateLastFile?: InputMaybe<SortEnumType>;
  dateLastStatement?: InputMaybe<SortEnumType>;
  dateLastTransmit?: InputMaybe<SortEnumType>;
  dateSetup?: InputMaybe<SortEnumType>;
  dateTerminate?: InputMaybe<SortEnumType>;
  ediFormat?: InputMaybe<SortEnumType>;
  ediReceiverId?: InputMaybe<SortEnumType>;
  ediSubmitterId?: InputMaybe<SortEnumType>;
  format?: InputMaybe<SortEnumType>;
  ftpKey?: InputMaybe<SortEnumType>;
  generateRemit?: InputMaybe<SortEnumType>;
  gs02AppSenderCode?: InputMaybe<SortEnumType>;
  gs03AppReceiverCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isa05IdQual?: InputMaybe<SortEnumType>;
  isa07IdQual?: InputMaybe<SortEnumType>;
  isa11identifier?: InputMaybe<SortEnumType>;
  isaAuthInfo?: InputMaybe<SortEnumType>;
  isaAuthInfoQual?: InputMaybe<SortEnumType>;
  isasecInfo?: InputMaybe<SortEnumType>;
  isasecInfoQual?: InputMaybe<SortEnumType>;
  mappingFilePath4010?: InputMaybe<SortEnumType>;
  mappingFilePath5010?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  nm103Orgname?: InputMaybe<SortEnumType>;
  nm109IdCode?: InputMaybe<SortEnumType>;
  nm1091000bCode?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  nsfFileNumber?: InputMaybe<SortEnumType>;
  nsfStatus?: InputMaybe<SortEnumType>;
  oneStSePerClaim?: InputMaybe<SortEnumType>;
  per02Name?: InputMaybe<SortEnumType>;
  per03CommQual1?: InputMaybe<SortEnumType>;
  per04CommNum1?: InputMaybe<SortEnumType>;
  per05CommQual2?: InputMaybe<SortEnumType>;
  per06CommNum2?: InputMaybe<SortEnumType>;
  recordStatus?: InputMaybe<SortEnumType>;
  requiresSubmitter?: InputMaybe<SortEnumType>;
  singleSubmitter?: InputMaybe<SortEnumType>;
  statementMethod?: InputMaybe<SortEnumType>;
  technicalContact?: InputMaybe<SortEnumType>;
  technicalPhone?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProcessorsConnection = {
  __typename?: 'ProcessorsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProcessorsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Processor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProcessorsEdge = {
  __typename?: 'ProcessorsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Processor>;
};

export type Provider = {
  __typename?: 'Provider';
  /** This is the account associated to this provider. */
  account?: Maybe<Account>;
  accountNumber: Scalars['String']['output'];
  addressCity?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressState?: Maybe<Scalars['String']['output']>;
  addressZipcode?: Maybe<Scalars['String']['output']>;
  /** This is the application associated to this provider. */
  application?: Maybe<Application>;
  billingMethod?: Maybe<Scalars['String']['output']>;
  certified?: Maybe<Scalars['String']['output']>;
  claimRoutingMethod?: Maybe<Scalars['String']['output']>;
  claimStatusDate?: Maybe<Scalars['DateTime']['output']>;
  claimStatusStatus?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactFax?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  contactTitle?: Maybe<Scalars['String']['output']>;
  dateLastCertified?: Maybe<Scalars['DateTime']['output']>;
  dateLastClaim?: Maybe<Scalars['DateTime']['output']>;
  dateLastDbUpdate?: Maybe<Scalars['DateTime']['output']>;
  dateLastStatement?: Maybe<Scalars['DateTime']['output']>;
  dateSetup?: Maybe<Scalars['DateTime']['output']>;
  dateTerminate?: Maybe<Scalars['DateTime']['output']>;
  degree?: Maybe<Scalars['String']['output']>;
  ecsDate?: Maybe<Scalars['DateTime']['output']>;
  ecsStatus?: Maybe<Scalars['String']['output']>;
  eligibilityDate?: Maybe<Scalars['DateTime']['output']>;
  eligibilityStatus?: Maybe<Scalars['String']['output']>;
  eraDate?: Maybe<Scalars['DateTime']['output']>;
  eraStatus?: Maybe<Scalars['String']['output']>;
  feeSchedule?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groupEnrollments?: Maybe<Array<Maybe<GroupEnrollment>>>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  mailboxId?: Maybe<Scalars['String']['output']>;
  mi?: Maybe<Scalars['String']['output']>;
  neicId?: Maybe<Scalars['String']['output']>;
  neicSiteId?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  nsfBatchNumber?: Maybe<Scalars['Int']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  pcMemory?: Maybe<Scalars['String']['output']>;
  pms?: Maybe<Scalars['String']['output']>;
  pmsSoftware?: Maybe<Scalars['String']['output']>;
  /** This is the provider group associated to this provider. */
  providerGroup?: Maybe<ProviderGroup>;
  providerGroupId: Scalars['String']['output'];
  recordStatus?: Maybe<Scalars['String']['output']>;
  statementDate?: Maybe<Scalars['DateTime']['output']>;
  statementMethod?: Maybe<Scalars['String']['output']>;
  statementStatus?: Maybe<Scalars['String']['output']>;
  submitterNumber?: Maybe<Scalars['String']['output']>;
};

export type ProviderFilterInput = {
  account?: InputMaybe<AccountFilterInput>;
  accountNumber?: InputMaybe<StringOperationFilterInput>;
  addressCity?: InputMaybe<StringOperationFilterInput>;
  addressLine1?: InputMaybe<StringOperationFilterInput>;
  addressLine2?: InputMaybe<StringOperationFilterInput>;
  addressState?: InputMaybe<StringOperationFilterInput>;
  addressZipcode?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ProviderFilterInput>>;
  application?: InputMaybe<ApplicationFilterInput>;
  billingMethod?: InputMaybe<StringOperationFilterInput>;
  certified?: InputMaybe<StringOperationFilterInput>;
  claimRoutingMethod?: InputMaybe<StringOperationFilterInput>;
  claimStatusDate?: InputMaybe<DateTimeOperationFilterInput>;
  claimStatusStatus?: InputMaybe<StringOperationFilterInput>;
  contactEmail?: InputMaybe<StringOperationFilterInput>;
  contactFax?: InputMaybe<StringOperationFilterInput>;
  contactName?: InputMaybe<StringOperationFilterInput>;
  contactPhone?: InputMaybe<StringOperationFilterInput>;
  contactTitle?: InputMaybe<StringOperationFilterInput>;
  dateLastCertified?: InputMaybe<DateTimeOperationFilterInput>;
  dateLastClaim?: InputMaybe<DateTimeOperationFilterInput>;
  dateLastDbUpdate?: InputMaybe<DateTimeOperationFilterInput>;
  dateLastStatement?: InputMaybe<DateTimeOperationFilterInput>;
  dateSetup?: InputMaybe<DateTimeOperationFilterInput>;
  dateTerminate?: InputMaybe<DateTimeOperationFilterInput>;
  degree?: InputMaybe<StringOperationFilterInput>;
  ecsDate?: InputMaybe<DateTimeOperationFilterInput>;
  ecsStatus?: InputMaybe<StringOperationFilterInput>;
  eligibilityDate?: InputMaybe<DateTimeOperationFilterInput>;
  eligibilityStatus?: InputMaybe<StringOperationFilterInput>;
  eraDate?: InputMaybe<DateTimeOperationFilterInput>;
  eraStatus?: InputMaybe<StringOperationFilterInput>;
  feeSchedule?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  groupEnrollments?: InputMaybe<ListFilterInputTypeOfGroupEnrollmentFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  lastUpdatedBy?: InputMaybe<StringOperationFilterInput>;
  mailboxId?: InputMaybe<StringOperationFilterInput>;
  mi?: InputMaybe<StringOperationFilterInput>;
  neicId?: InputMaybe<StringOperationFilterInput>;
  neicSiteId?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  nsfBatchNumber?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProviderFilterInput>>;
  organizationName?: InputMaybe<StringOperationFilterInput>;
  organizationType?: InputMaybe<StringOperationFilterInput>;
  pcMemory?: InputMaybe<StringOperationFilterInput>;
  pms?: InputMaybe<StringOperationFilterInput>;
  pmsSoftware?: InputMaybe<StringOperationFilterInput>;
  providerGroup?: InputMaybe<ProviderGroupFilterInput>;
  providerGroupId?: InputMaybe<StringOperationFilterInput>;
  recordStatus?: InputMaybe<StringOperationFilterInput>;
  statementDate?: InputMaybe<DateTimeOperationFilterInput>;
  statementMethod?: InputMaybe<StringOperationFilterInput>;
  statementStatus?: InputMaybe<StringOperationFilterInput>;
  submitterNumber?: InputMaybe<StringOperationFilterInput>;
};

export type ProviderGroup = {
  __typename?: 'ProviderGroup';
  /** This is the account associated with this provider group. */
  account?: Maybe<Account>;
  accountCredentialKey?: Maybe<Scalars['String']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  achCredentialKey?: Maybe<Scalars['String']['output']>;
  addressCity?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressState?: Maybe<Scalars['String']['output']>;
  addressZipcode?: Maybe<Scalars['String']['output']>;
  allowACH?: Maybe<Scalars['String']['output']>;
  alphaII?: Maybe<Scalars['String']['output']>;
  appSenderCode?: Maybe<Scalars['String']['output']>;
  backLink?: Maybe<Scalars['String']['output']>;
  batch277ca?: Maybe<Scalars['String']['output']>;
  batch277u?: Maybe<Scalars['String']['output']>;
  batchCSV?: Maybe<Scalars['String']['output']>;
  batchHumanReadable?: Maybe<Scalars['String']['output']>;
  batchMachineReadable?: Maybe<Scalars['String']['output']>;
  batchXml?: Maybe<Scalars['String']['output']>;
  billingIds?: Maybe<Array<Maybe<BillingIds>>>;
  billingMethod?: Maybe<Scalars['String']['output']>;
  certified?: Maybe<Scalars['String']['output']>;
  claimStatusDate?: Maybe<Scalars['DateTime']['output']>;
  claimStatusStatus?: Maybe<Scalars['String']['output']>;
  clientVersion?: Maybe<Scalars['String']['output']>;
  combineERA?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactFax?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  contactTitle?: Maybe<Scalars['String']['output']>;
  dateLastCertified?: Maybe<Scalars['DateTime']['output']>;
  dateLastClaim?: Maybe<Scalars['DateTime']['output']>;
  dateLastDbUpdate?: Maybe<Scalars['DateTime']['output']>;
  dateSetup?: Maybe<Scalars['DateTime']['output']>;
  dateTerminated?: Maybe<Scalars['DateTime']['output']>;
  ecsDate?: Maybe<Scalars['DateTime']['output']>;
  ecsStatus?: Maybe<Scalars['String']['output']>;
  eligibilityDate?: Maybe<Scalars['DateTime']['output']>;
  eligibilityStatus?: Maybe<Scalars['String']['output']>;
  eraDate?: Maybe<Scalars['DateTime']['output']>;
  eraFileSeqNum: Scalars['Int']['output'];
  eraStatus?: Maybe<Scalars['String']['output']>;
  feeSchedule?: Maybe<Scalars['String']['output']>;
  fees?: Maybe<Fee>;
  ftpKey?: Maybe<Scalars['String']['output']>;
  genericProvider?: Maybe<Scalars['String']['output']>;
  glueEM?: Maybe<Scalars['String']['output']>;
  groupEnrollments?: Maybe<Array<Maybe<GroupEnrollment>>>;
  groupId: Scalars['String']['output'];
  humanReadable271?: Maybe<Scalars['String']['output']>;
  inputGenerates999?: Maybe<Scalars['String']['output']>;
  instAppSenderCode?: Maybe<Scalars['String']['output']>;
  instNM109IdCode?: Maybe<Scalars['String']['output']>;
  instProcessorId?: Maybe<Scalars['String']['output']>;
  instSubmitterId?: Maybe<Scalars['String']['output']>;
  interchangeNum: Scalars['Int']['output'];
  isDev: Scalars['Boolean']['output'];
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  lockBox?: Maybe<Scalars['String']['output']>;
  lockboxProcessorId?: Maybe<Scalars['String']['output']>;
  mailboxId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  newStatements?: Maybe<Scalars['String']['output']>;
  nm109IdCode?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  partialRedirectInstitutional?: Maybe<Scalars['String']['output']>;
  partialRedirectProfessional?: Maybe<Scalars['String']['output']>;
  pmIdentifier?: Maybe<Scalars['String']['output']>;
  pms?: Maybe<Scalars['String']['output']>;
  pmsSoftware?: Maybe<Scalars['String']['output']>;
  processorId?: Maybe<Scalars['String']['output']>;
  /** This is the list of providers associated to this group. */
  providers?: Maybe<Array<Maybe<Provider>>>;
  rcm?: Maybe<Scalars['String']['output']>;
  recordStatus?: Maybe<Scalars['String']['output']>;
  rejectPrintClaims?: Maybe<Scalars['String']['output']>;
  remit277ca?: Maybe<Scalars['String']['output']>;
  remit277u?: Maybe<Scalars['String']['output']>;
  remitCSVDaily?: Maybe<Scalars['String']['output']>;
  remitCsv?: Maybe<Scalars['String']['output']>;
  remitEraSummary?: Maybe<Scalars['String']['output']>;
  remitHumanReadable?: Maybe<Scalars['String']['output']>;
  remitMachineReadable?: Maybe<Scalars['String']['output']>;
  remitXml?: Maybe<Scalars['String']['output']>;
  reportNumber?: Maybe<Scalars['Int']['output']>;
  statementDate?: Maybe<Scalars['DateTime']['output']>;
  statementMethod?: Maybe<Scalars['String']['output']>;
  statementStatus?: Maybe<Scalars['String']['output']>;
  submitterId?: Maybe<Scalars['String']['output']>;
  universalReport?: Maybe<Scalars['String']['output']>;
  usersClientsGrps?: Maybe<Array<Maybe<UsersClientsGrps>>>;
};

export type ProviderGroupFilterInput = {
  account?: InputMaybe<AccountFilterInput>;
  accountCredentialKey?: InputMaybe<StringOperationFilterInput>;
  accountNumber?: InputMaybe<StringOperationFilterInput>;
  achCredentialKey?: InputMaybe<StringOperationFilterInput>;
  addressCity?: InputMaybe<StringOperationFilterInput>;
  addressLine1?: InputMaybe<StringOperationFilterInput>;
  addressLine2?: InputMaybe<StringOperationFilterInput>;
  addressState?: InputMaybe<StringOperationFilterInput>;
  addressZipcode?: InputMaybe<StringOperationFilterInput>;
  allowACH?: InputMaybe<StringOperationFilterInput>;
  alphaII?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ProviderGroupFilterInput>>;
  appSenderCode?: InputMaybe<StringOperationFilterInput>;
  backLink?: InputMaybe<StringOperationFilterInput>;
  batch277ca?: InputMaybe<StringOperationFilterInput>;
  batch277u?: InputMaybe<StringOperationFilterInput>;
  batchCSV?: InputMaybe<StringOperationFilterInput>;
  batchHumanReadable?: InputMaybe<StringOperationFilterInput>;
  batchMachineReadable?: InputMaybe<StringOperationFilterInput>;
  batchXml?: InputMaybe<StringOperationFilterInput>;
  billingIds?: InputMaybe<ListFilterInputTypeOfBillingIdsFilterInput>;
  billingMethod?: InputMaybe<StringOperationFilterInput>;
  certified?: InputMaybe<StringOperationFilterInput>;
  claimStatusDate?: InputMaybe<DateTimeOperationFilterInput>;
  claimStatusStatus?: InputMaybe<StringOperationFilterInput>;
  clientVersion?: InputMaybe<StringOperationFilterInput>;
  combineERA?: InputMaybe<StringOperationFilterInput>;
  contactEmail?: InputMaybe<StringOperationFilterInput>;
  contactFax?: InputMaybe<StringOperationFilterInput>;
  contactName?: InputMaybe<StringOperationFilterInput>;
  contactPhone?: InputMaybe<StringOperationFilterInput>;
  contactTitle?: InputMaybe<StringOperationFilterInput>;
  dateLastCertified?: InputMaybe<DateTimeOperationFilterInput>;
  dateLastClaim?: InputMaybe<DateTimeOperationFilterInput>;
  dateLastDbUpdate?: InputMaybe<DateTimeOperationFilterInput>;
  dateSetup?: InputMaybe<DateTimeOperationFilterInput>;
  dateTerminated?: InputMaybe<DateTimeOperationFilterInput>;
  ecsDate?: InputMaybe<DateTimeOperationFilterInput>;
  ecsStatus?: InputMaybe<StringOperationFilterInput>;
  eligibilityDate?: InputMaybe<DateTimeOperationFilterInput>;
  eligibilityStatus?: InputMaybe<StringOperationFilterInput>;
  eraDate?: InputMaybe<DateTimeOperationFilterInput>;
  eraFileSeqNum?: InputMaybe<IntOperationFilterInput>;
  eraStatus?: InputMaybe<StringOperationFilterInput>;
  feeSchedule?: InputMaybe<StringOperationFilterInput>;
  fees?: InputMaybe<FeeFilterInput>;
  ftpKey?: InputMaybe<StringOperationFilterInput>;
  genericProvider?: InputMaybe<StringOperationFilterInput>;
  glueEM?: InputMaybe<StringOperationFilterInput>;
  groupEnrollments?: InputMaybe<ListFilterInputTypeOfGroupEnrollmentFilterInput>;
  groupId?: InputMaybe<StringOperationFilterInput>;
  humanReadable271?: InputMaybe<StringOperationFilterInput>;
  inputGenerates999?: InputMaybe<StringOperationFilterInput>;
  instAppSenderCode?: InputMaybe<StringOperationFilterInput>;
  instNM109IdCode?: InputMaybe<StringOperationFilterInput>;
  instProcessorId?: InputMaybe<StringOperationFilterInput>;
  instSubmitterId?: InputMaybe<StringOperationFilterInput>;
  interchangeNum?: InputMaybe<IntOperationFilterInput>;
  isDev?: InputMaybe<BooleanOperationFilterInput>;
  lastUpdatedBy?: InputMaybe<StringOperationFilterInput>;
  lockBox?: InputMaybe<StringOperationFilterInput>;
  lockboxProcessorId?: InputMaybe<StringOperationFilterInput>;
  mailboxId?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  newStatements?: InputMaybe<StringOperationFilterInput>;
  nm109IdCode?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProviderGroupFilterInput>>;
  organizationType?: InputMaybe<StringOperationFilterInput>;
  partialRedirectInstitutional?: InputMaybe<StringOperationFilterInput>;
  partialRedirectProfessional?: InputMaybe<StringOperationFilterInput>;
  pmIdentifier?: InputMaybe<StringOperationFilterInput>;
  pms?: InputMaybe<StringOperationFilterInput>;
  pmsSoftware?: InputMaybe<StringOperationFilterInput>;
  processorId?: InputMaybe<StringOperationFilterInput>;
  providers?: InputMaybe<ListFilterInputTypeOfProviderFilterInput>;
  rcm?: InputMaybe<StringOperationFilterInput>;
  recordStatus?: InputMaybe<StringOperationFilterInput>;
  rejectPrintClaims?: InputMaybe<StringOperationFilterInput>;
  remit277ca?: InputMaybe<StringOperationFilterInput>;
  remit277u?: InputMaybe<StringOperationFilterInput>;
  remitCSVDaily?: InputMaybe<StringOperationFilterInput>;
  remitCsv?: InputMaybe<StringOperationFilterInput>;
  remitEraSummary?: InputMaybe<StringOperationFilterInput>;
  remitHumanReadable?: InputMaybe<StringOperationFilterInput>;
  remitMachineReadable?: InputMaybe<StringOperationFilterInput>;
  remitXml?: InputMaybe<StringOperationFilterInput>;
  reportNumber?: InputMaybe<IntOperationFilterInput>;
  statementDate?: InputMaybe<DateTimeOperationFilterInput>;
  statementMethod?: InputMaybe<StringOperationFilterInput>;
  statementStatus?: InputMaybe<StringOperationFilterInput>;
  submitterId?: InputMaybe<StringOperationFilterInput>;
  universalReport?: InputMaybe<StringOperationFilterInput>;
  usersClientsGrps?: InputMaybe<ListFilterInputTypeOfUsersClientsGrpsFilterInput>;
};

export type ProviderGroupSortInput = {
  account?: InputMaybe<AccountSortInput>;
  accountCredentialKey?: InputMaybe<SortEnumType>;
  accountNumber?: InputMaybe<SortEnumType>;
  achCredentialKey?: InputMaybe<SortEnumType>;
  addressCity?: InputMaybe<SortEnumType>;
  addressLine1?: InputMaybe<SortEnumType>;
  addressLine2?: InputMaybe<SortEnumType>;
  addressState?: InputMaybe<SortEnumType>;
  addressZipcode?: InputMaybe<SortEnumType>;
  allowACH?: InputMaybe<SortEnumType>;
  alphaII?: InputMaybe<SortEnumType>;
  appSenderCode?: InputMaybe<SortEnumType>;
  backLink?: InputMaybe<SortEnumType>;
  batch277ca?: InputMaybe<SortEnumType>;
  batch277u?: InputMaybe<SortEnumType>;
  batchCSV?: InputMaybe<SortEnumType>;
  batchHumanReadable?: InputMaybe<SortEnumType>;
  batchMachineReadable?: InputMaybe<SortEnumType>;
  batchXml?: InputMaybe<SortEnumType>;
  billingMethod?: InputMaybe<SortEnumType>;
  certified?: InputMaybe<SortEnumType>;
  claimStatusDate?: InputMaybe<SortEnumType>;
  claimStatusStatus?: InputMaybe<SortEnumType>;
  clientVersion?: InputMaybe<SortEnumType>;
  combineERA?: InputMaybe<SortEnumType>;
  contactEmail?: InputMaybe<SortEnumType>;
  contactFax?: InputMaybe<SortEnumType>;
  contactName?: InputMaybe<SortEnumType>;
  contactPhone?: InputMaybe<SortEnumType>;
  contactTitle?: InputMaybe<SortEnumType>;
  dateLastCertified?: InputMaybe<SortEnumType>;
  dateLastClaim?: InputMaybe<SortEnumType>;
  dateLastDbUpdate?: InputMaybe<SortEnumType>;
  dateSetup?: InputMaybe<SortEnumType>;
  dateTerminated?: InputMaybe<SortEnumType>;
  ecsDate?: InputMaybe<SortEnumType>;
  ecsStatus?: InputMaybe<SortEnumType>;
  eligibilityDate?: InputMaybe<SortEnumType>;
  eligibilityStatus?: InputMaybe<SortEnumType>;
  eraDate?: InputMaybe<SortEnumType>;
  eraFileSeqNum?: InputMaybe<SortEnumType>;
  eraStatus?: InputMaybe<SortEnumType>;
  feeSchedule?: InputMaybe<SortEnumType>;
  fees?: InputMaybe<FeeSortInput>;
  ftpKey?: InputMaybe<SortEnumType>;
  genericProvider?: InputMaybe<SortEnumType>;
  glueEM?: InputMaybe<SortEnumType>;
  groupId?: InputMaybe<SortEnumType>;
  humanReadable271?: InputMaybe<SortEnumType>;
  inputGenerates999?: InputMaybe<SortEnumType>;
  instAppSenderCode?: InputMaybe<SortEnumType>;
  instNM109IdCode?: InputMaybe<SortEnumType>;
  instProcessorId?: InputMaybe<SortEnumType>;
  instSubmitterId?: InputMaybe<SortEnumType>;
  interchangeNum?: InputMaybe<SortEnumType>;
  isDev?: InputMaybe<SortEnumType>;
  lastUpdatedBy?: InputMaybe<SortEnumType>;
  lockBox?: InputMaybe<SortEnumType>;
  lockboxProcessorId?: InputMaybe<SortEnumType>;
  mailboxId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  newStatements?: InputMaybe<SortEnumType>;
  nm109IdCode?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  organizationType?: InputMaybe<SortEnumType>;
  partialRedirectInstitutional?: InputMaybe<SortEnumType>;
  partialRedirectProfessional?: InputMaybe<SortEnumType>;
  pmIdentifier?: InputMaybe<SortEnumType>;
  pms?: InputMaybe<SortEnumType>;
  pmsSoftware?: InputMaybe<SortEnumType>;
  processorId?: InputMaybe<SortEnumType>;
  rcm?: InputMaybe<SortEnumType>;
  recordStatus?: InputMaybe<SortEnumType>;
  rejectPrintClaims?: InputMaybe<SortEnumType>;
  remit277ca?: InputMaybe<SortEnumType>;
  remit277u?: InputMaybe<SortEnumType>;
  remitCSVDaily?: InputMaybe<SortEnumType>;
  remitCsv?: InputMaybe<SortEnumType>;
  remitEraSummary?: InputMaybe<SortEnumType>;
  remitHumanReadable?: InputMaybe<SortEnumType>;
  remitMachineReadable?: InputMaybe<SortEnumType>;
  remitXml?: InputMaybe<SortEnumType>;
  reportNumber?: InputMaybe<SortEnumType>;
  statementDate?: InputMaybe<SortEnumType>;
  statementMethod?: InputMaybe<SortEnumType>;
  statementStatus?: InputMaybe<SortEnumType>;
  submitterId?: InputMaybe<SortEnumType>;
  universalReport?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProviderGroupsConnection = {
  __typename?: 'ProviderGroupsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProviderGroupsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ProviderGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProviderGroupsEdge = {
  __typename?: 'ProviderGroupsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProviderGroup>;
};

export type ProviderSortInput = {
  account?: InputMaybe<AccountSortInput>;
  accountNumber?: InputMaybe<SortEnumType>;
  addressCity?: InputMaybe<SortEnumType>;
  addressLine1?: InputMaybe<SortEnumType>;
  addressLine2?: InputMaybe<SortEnumType>;
  addressState?: InputMaybe<SortEnumType>;
  addressZipcode?: InputMaybe<SortEnumType>;
  application?: InputMaybe<ApplicationSortInput>;
  billingMethod?: InputMaybe<SortEnumType>;
  certified?: InputMaybe<SortEnumType>;
  claimRoutingMethod?: InputMaybe<SortEnumType>;
  claimStatusDate?: InputMaybe<SortEnumType>;
  claimStatusStatus?: InputMaybe<SortEnumType>;
  contactEmail?: InputMaybe<SortEnumType>;
  contactFax?: InputMaybe<SortEnumType>;
  contactName?: InputMaybe<SortEnumType>;
  contactPhone?: InputMaybe<SortEnumType>;
  contactTitle?: InputMaybe<SortEnumType>;
  dateLastCertified?: InputMaybe<SortEnumType>;
  dateLastClaim?: InputMaybe<SortEnumType>;
  dateLastDbUpdate?: InputMaybe<SortEnumType>;
  dateLastStatement?: InputMaybe<SortEnumType>;
  dateSetup?: InputMaybe<SortEnumType>;
  dateTerminate?: InputMaybe<SortEnumType>;
  degree?: InputMaybe<SortEnumType>;
  ecsDate?: InputMaybe<SortEnumType>;
  ecsStatus?: InputMaybe<SortEnumType>;
  eligibilityDate?: InputMaybe<SortEnumType>;
  eligibilityStatus?: InputMaybe<SortEnumType>;
  eraDate?: InputMaybe<SortEnumType>;
  eraStatus?: InputMaybe<SortEnumType>;
  feeSchedule?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  lastUpdatedBy?: InputMaybe<SortEnumType>;
  mailboxId?: InputMaybe<SortEnumType>;
  mi?: InputMaybe<SortEnumType>;
  neicId?: InputMaybe<SortEnumType>;
  neicSiteId?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  nsfBatchNumber?: InputMaybe<SortEnumType>;
  organizationName?: InputMaybe<SortEnumType>;
  organizationType?: InputMaybe<SortEnumType>;
  pcMemory?: InputMaybe<SortEnumType>;
  pms?: InputMaybe<SortEnumType>;
  pmsSoftware?: InputMaybe<SortEnumType>;
  providerGroup?: InputMaybe<ProviderGroupSortInput>;
  providerGroupId?: InputMaybe<SortEnumType>;
  recordStatus?: InputMaybe<SortEnumType>;
  statementDate?: InputMaybe<SortEnumType>;
  statementMethod?: InputMaybe<SortEnumType>;
  statementStatus?: InputMaybe<SortEnumType>;
  submitterNumber?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProvidersConnection = {
  __typename?: 'ProvidersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProvidersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Provider>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProvidersEdge = {
  __typename?: 'ProvidersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Provider>;
};

export type Qualifier = {
  __typename?: 'Qualifier';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type QualifierFilterInput = {
  and?: InputMaybe<Array<QualifierFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<QualifierFilterInput>>;
};

export type QualifierSortInput = {
  code?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type QualifiersConnection = {
  __typename?: 'QualifiersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<QualifiersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Qualifier>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type QualifiersEdge = {
  __typename?: 'QualifiersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Qualifier>;
};

export type Query = {
  __typename?: 'Query';
  /**
   * Get single account using the accounts account number.
   *
   *
   * **Returns:**
   * The found Account.
   */
  account?: Maybe<Account>;
  /** Get ALL Accounts. */
  accounts?: Maybe<AccountsConnection>;
  /** Get all claims, optionally filter. */
  activeClaims?: Maybe<ActiveClaimsConnection>;
  /**
   * Get single application using the code.
   *
   *
   * **Returns:**
   * Application.Application.
   */
  application?: Maybe<Application>;
  /**
   * Get all applications.
   *
   *
   * **Returns:**
   * List of Application.
   */
  applications?: Maybe<ApplicationsConnection>;
  /**
   * Get single BillingIds using the rowId.
   *
   *
   * **Returns:**
   * BillingIds
   */
  billingId?: Maybe<BillingIds>;
  /**
   * Get single billingidtype using the code.
   *
   *
   * **Returns:**
   * BillingIdType.BillingIdType.
   */
  billingIdType?: Maybe<BillingIdType>;
  /**
   * Get all billingidtypes.
   *
   *
   * **Returns:**
   * List of BillingIdType.
   */
  billingIdTypes?: Maybe<Array<Maybe<BillingIdType>>>;
  /**
   * Get all billingids.
   *
   *
   * **Returns:**
   * List of BillingIds.
   */
  billingIds?: Maybe<BillingIdsConnection>;
  claimErrors?: Maybe<ClaimErrorsConnection>;
  /** Get list of claim filing indicators. */
  claimFilingIndicators?: Maybe<ClaimFilingIndicatorsConnection>;
  claimInputClaim?: Maybe<ClaimFileText>;
  claimInputFile?: Maybe<ClaimFileResponse>;
  claimRemit?: Maybe<ClaimRemitConnection>;
  /**
   * Get single ClaimSibling using the id.
   *
   *
   * **Returns:**
   * ClaimsSibling.ClaimsSibling.
   */
  claimSiblingById?: Maybe<ClaimsSibling>;
  /** Get claim statistics, optionally filter. */
  claimStatistics?: Maybe<ClaimStatisticsConnection>;
  claimStatusDetails?: Maybe<ClaimResponse>;
  /**
   * Get list of ClaimStatusRouting's.
   *
   *
   * **Returns:**
   * List of ClaimStatusRouting.
   */
  claimStatusRoutings?: Maybe<ClaimStatusRoutingsConnection>;
  claimTransmitFile?: Maybe<ClaimFileResponse>;
  /** Get all claims, optionally filter. */
  claims?: Maybe<ClaimsConnection>;
  /** Get all claims, optionally filter. */
  claimsArchive?: Maybe<ClaimsArchiveConnection>;
  /** Get all claims, optionally filter. */
  claimsV1_1?: Maybe<ClaimsV1_1Connection>;
  /** Get list of communication types. */
  communicationTypes?: Maybe<CommunicationTypesConnection>;
  /** Get configuration record. */
  configuration?: Maybe<ConfigurationResponse>;
  /** Get a single conenction record. */
  connection?: Maybe<ConnectionResponse>;
  /** Get list of connections. */
  connections?: Maybe<ConnectionsConnection>;
  /**
   * **Returns:**
   * List of statements. IQueryable`1
   */
  currentStatement?: Maybe<CurrentStatementConnection>;
  /**
   * **Returns:**
   * List of statements. IQueryable`1
   */
  currentStatementLines?: Maybe<CurrentStatementLinesConnection>;
  /**
   * Get single DbAddressInfo using the DbAddressInfos DbAddressInfo number.
   *
   *
   * **Returns:**
   * The found DbAddressInfo.
   */
  dbAddressInfo?: Maybe<DbAddressInfo>;
  /**
   * Get all DbAddressInfos.
   *
   *
   * **Returns:**
   * List of IQueryable`1.
   */
  dbAddressInfos?: Maybe<DbAddressInfosConnection>;
  /**
   * Get single DbContactInfo using the DbContactInfos DbContactInfo number.
   *
   *
   * **Returns:**
   * The found DbContactInfo.
   */
  dbContactInfo?: Maybe<DbContactInfo>;
  /**
   * Get all DbContactInfos.
   *
   *
   * **Returns:**
   * List of IQueryable`1.
   */
  dbContactInfos?: Maybe<DbContactInfosConnection>;
  /** Get EligibilityRouting by ScId and GroupId */
  eligibilityRouting?: Maybe<EligibilityRouting>;
  /**
   * Get list of EligibilityRouting's.
   *
   *
   * **Returns:**
   * List of EligibilityRouting.
   */
  eligibilityRoutings?: Maybe<EligibilityRoutingsConnection>;
  /** Get single email vendor. */
  emailVendor?: Maybe<EmailVendor>;
  /** Get all email vendors, optionally filtering. */
  emailVendors?: Maybe<EmailVendorsConnection>;
  /** Get enrollment logs by sequence number. */
  enrollmentLogs?: Maybe<EnrollmentLogsConnection>;
  /**
   * Get single enrollmentstatus using the code.
   *
   *
   * **Returns:**
   * EnrollmentStatus.EnrollmentStatus.
   */
  enrollmentStatus?: Maybe<EnrollmentStatus>;
  /**
   * Get list of enrollmentstatus.
   *
   *
   * **Returns:**
   * List of EnrollmentStatus.
   */
  enrollmentStatuses?: Maybe<Array<Maybe<EnrollmentStatus>>>;
  /**
   * Get ERA Main files. Optionally filter.
   *
   *
   * **Returns:**
   * List of EraFilePaymentResponse
   */
  eraPayments?: Maybe<EraPaymentsConnection>;
  /**
   * Get single fee using the id.
   *
   *
   * **Returns:**
   * Fee.Fee.
   */
  fee?: Maybe<Fee>;
  /**
   * Get all fees.
   *
   *
   * **Returns:**
   * List of Fee.
   */
  fees?: Maybe<FeesConnection>;
  /** Get FormatType */
  formatType?: Maybe<FormatType>;
  /**
   * Get all FormatTypes
   *
   *
   * **Returns:**
   * FormatType
   */
  formatTypes?: Maybe<FormatTypesConnection>;
  groupEnrollment?: Maybe<GroupEnrollment>;
  groupEnrollments?: Maybe<GroupEnrollmentsConnection>;
  /** Get all insurance companyies. */
  insuranceCompanies?: Maybe<InsuranceCompaniesConnection>;
  /** Get insurance company by id. */
  insuranceCompany?: Maybe<InsuranceCompanyResponse>;
  /** Get user details for currently logged in user, using token information. */
  loggedInUser?: Maybe<UsersClients>;
  /** Get password configuration */
  passwordConfig?: Maybe<PasswordConfigResponse>;
  /**
   * Get password regex, built based on password configuration.
   *
   *
   * **Returns:**
   * Regex as string.
   */
  passwordConfigRegex?: Maybe<PasswordConfigRegex>;
  /**
   * Get single Patient using the Patients Patient number.
   *
   *
   * **Returns:**
   * The found Patient.
   */
  patient?: Maybe<Patient>;
  /**
   * Get single PatientStatements using the PatientStatementss PatientStatements number.
   *
   *
   * **Returns:**
   * The found PatientStatements.
   */
  patientStatements?: Maybe<PatientStatements>;
  /**
   * Get all PatientStatementss.
   *
   *
   * **Returns:**
   * List of IQueryable`1.
   */
  patientStatementss?: Maybe<PatientStatementssConnection>;
  /**
   * Get all Patients.
   *
   *
   * **Returns:**
   * List of IQueryable`1.
   */
  patients?: Maybe<PatientsConnection>;
  /** Get all payer routings, optionally filter. */
  payerRoutings?: Maybe<PayerRoutingsConnection>;
  /** Get all payers, optionally filter. */
  payers?: Maybe<PayersConnection>;
  /** Get the permisison identified by Id. */
  permission?: Maybe<Permissions>;
  /** Get list of permissions. */
  permissions?: Maybe<PermissionsConnection>;
  /**
   * Get list of PreferredRouting.
   *
   *
   * **Returns:**
   * List of PreferredRouting.
   */
  preferredRoutings?: Maybe<PreferredRoutingsConnection>;
  processor?: Maybe<Processor>;
  /** Get list of processors. */
  processors?: Maybe<ProcessorsConnection>;
  /** Get a single provider using the provider's id. */
  provider?: Maybe<Provider>;
  /** Get a single providergroup using the providergroup's id. */
  providerGroup?: Maybe<ProviderGroup>;
  /** Get all providergroups */
  providerGroups?: Maybe<ProviderGroupsConnection>;
  /** Get all providers */
  providers?: Maybe<ProvidersConnection>;
  /** Get list of qualifiers. */
  qualifiers?: Maybe<QualifiersConnection>;
  /** Get a single realtime processor using processor id. */
  realtimeProcessor?: Maybe<RealTimeProcessor>;
  /** Get all realtime processor, with optional filtering. */
  realtimeProcessors?: Maybe<RealtimeProcessorsConnection>;
  /**
   * Get all recurring payments.
   *
   *
   * **Returns:**
   * List of PaymentsRecurringPayment.
   */
  recurringPayments?: Maybe<RecurringPaymentsConnection>;
  /**
   * Get all states.
   *
   *
   * **Returns:**
   * List of states. IQueryable`1
   */
  states?: Maybe<StatesConnection>;
  /** Get count of claim status request and responses. */
  statisticsClaimSubmitCounts?: Maybe<StatisticsSearchResponse>;
  /** Get claim statistics. */
  statisticsClaims?: Maybe<StatisticsClaimsSearchResponse>;
  /** Get claims in error counts. */
  statisticsClaimsInErrorCounts?: Maybe<StatisticsClaimInErrorResponse>;
  /** Get missing claim responses statistics */
  statisticsEligibilityCounts?: Maybe<StatisticsSearchResponse>;
  /** Get Era statistics counts */
  statisticsEraCounts?: Maybe<StatisticsEraResponse>;
  /** Get missing claim responses statistics */
  statisticsMissingClaimResponses?: Maybe<StatisticsClaimsMissingResponseResponse>;
  /** Get RevSpring Statement and Collection counts */
  statisticsRevSpringCounts?: Maybe<StatisticsRevSpringResponse>;
  /**
   * Get all SubmitterIds.
   *
   *
   * **Returns:**
   * List of SubmitterIds.
   */
  submitterIds?: Maybe<SubmitterIdsConnection>;
  /**
   * Get single user using the id.
   *
   *
   * **Returns:**
   * UsersClients.UsersClients.
   */
  user?: Maybe<UsersClients>;
  /**
   * retuns a list of users and their groups
   * 1) returned user must be associated with the passed in accounts
   * 2) returned user must have same groups or subset of groups as the logged on user
   *     a)If logged on user is Secure Connect or Vender and has no groups
   *         then reuturn all
   *     b)If logged on user has groups then returned users must have same groups or subset of groups
   * 3) if user has any additional groups than the logged on user omit that user
   */
  userGroupsByAccount?: Maybe<Array<Maybe<UserWithGroups>>>;
  /**
   * Get all users.
   *
   *
   * **Returns:**
   * List of UsersClients.
   */
  users?: Maybe<UsersConnection>;
  /**
   * Get all users that belong to the list of groups.
   *
   *
   * **Returns:**
   * List of UsersClients
   */
  usersByGroup?: Maybe<UsersByGroupConnection>;
  /** Returns a list of users with same access as the current user */
  usersWithSameAccess?: Maybe<UsersWithSameAccessConnection>;
  /** Get list of zipcodes. */
  zipcodes?: Maybe<ZipcodesConnection>;
};

export type QueryAccountArgs = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  npi?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<AccountSortInput>>;
  where?: InputMaybe<AccountFilterInput>;
};

export type QueryActiveClaimsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ClaimsResponseSortInput>>;
  where?: InputMaybe<ClaimsResponseFilterInput>;
};

export type QueryApplicationArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};

export type QueryApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ApplicationSortInput>>;
  where?: InputMaybe<ApplicationFilterInput>;
};

export type QueryBillingIdArgs = {
  rowId: Scalars['Int']['input'];
};

export type QueryBillingIdTypeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};

export type QueryBillingIdTypesArgs = {
  order?: InputMaybe<Array<BillingIdTypeSortInput>>;
  where?: InputMaybe<BillingIdTypeFilterInput>;
};

export type QueryBillingIdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BillingIdsSortInput>>;
  where?: InputMaybe<BillingIdsFilterInput>;
};

export type QueryClaimErrorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  claimId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ClaimErrorResponseSortInput>>;
  where?: InputMaybe<ClaimErrorResponseFilterInput>;
};

export type QueryClaimFilingIndicatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ClaimFilingIndicatorSortInput>>;
  where?: InputMaybe<ClaimFilingIndicatorFilterInput>;
};

export type QueryClaimInputClaimArgs = {
  claimId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryClaimInputFileArgs = {
  claimId?: InputMaybe<Scalars['String']['input']>;
  x_GROUP_ID?: InputMaybe<Scalars['String']['input']>;
};

export type QueryClaimRemitArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  claimId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ClaimRemittanceResponseSortInput>>;
  where?: InputMaybe<ClaimRemittanceResponseFilterInput>;
};

export type QueryClaimSiblingByIdArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryClaimStatisticsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ClaimStatisticsSearchFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ClaimStatisticsResponseSortInput>>;
  where?: InputMaybe<ClaimStatisticsResponseFilterInput>;
};

export type QueryClaimStatusDetailsArgs = {
  claimId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryClaimStatusRoutingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ClaimStatusRoutingSortInput>>;
  where?: InputMaybe<ClaimStatusRoutingFilterInput>;
};

export type QueryClaimTransmitFileArgs = {
  claimId?: InputMaybe<Scalars['String']['input']>;
  x_GROUP_ID?: InputMaybe<Scalars['String']['input']>;
};

export type QueryClaimsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ClaimsResponseSortInput>>;
  where?: InputMaybe<ClaimsResponseFilterInput>;
};

export type QueryClaimsArchiveArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ClaimsResponseSortInput>>;
  where?: InputMaybe<ClaimsResponseFilterInput>;
};

export type QueryClaimsV1_1Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  claimFilter?: InputMaybe<GraphQlClaimSearchFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ClaimsResponseSortInput>>;
  where?: InputMaybe<ClaimsResponseFilterInput>;
};

export type QueryCommunicationTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CommunicationTypeSortInput>>;
  where?: InputMaybe<CommunicationTypeFilterInput>;
};

export type QueryConfigurationArgs = {
  isArchive?: Scalars['Boolean']['input'];
};

export type QueryConnectionArgs = {
  ftpKey?: InputMaybe<Scalars['String']['input']>;
};

export type QueryConnectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ConnectionSearchResponseSortInput>>;
  where?: InputMaybe<ConnectionSearchResponseFilterInput>;
};

export type QueryCurrentStatementArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PatientStatementsResponseSortInput>>;
  patientId: Scalars['Long']['input'];
  where?: InputMaybe<PatientStatementsResponseFilterInput>;
};

export type QueryCurrentStatementLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PatientStatementsSearchFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PatientStatementsResponseSortInput>>;
  where?: InputMaybe<PatientStatementsResponseFilterInput>;
};

export type QueryDbAddressInfoArgs = {
  dbAddressInfoNumber: Scalars['Long']['input'];
};

export type QueryDbAddressInfosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DbAddressInfoSortInput>>;
  where?: InputMaybe<DbAddressInfoFilterInput>;
};

export type QueryDbContactInfoArgs = {
  dbContactInfoNumber: Scalars['Long']['input'];
};

export type QueryDbContactInfosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DbContactInfoSortInput>>;
  where?: InputMaybe<DbContactInfoFilterInput>;
};

export type QueryEligibilityRoutingArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  scId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEligibilityRoutingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EligibilityRoutingSortInput>>;
  where?: InputMaybe<EligibilityRoutingFilterInput>;
};

export type QueryEmailVendorArgs = {
  id: Scalars['Int']['input'];
};

export type QueryEmailVendorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EmailVendorSortInput>>;
  where?: InputMaybe<EmailVendorFilterInput>;
};

export type QueryEnrollmentLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EnrollmentLogSortInput>>;
  seqNo: Scalars['Int']['input'];
  where?: InputMaybe<EnrollmentLogFilterInput>;
};

export type QueryEnrollmentStatusArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEnrollmentStatusesArgs = {
  order?: InputMaybe<Array<EnrollmentStatusSortInput>>;
  where?: InputMaybe<EnrollmentStatusFilterInput>;
};

export type QueryEraPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EraFilePaymentResponseSortInput>>;
  where?: InputMaybe<EraFilePaymentResponseFilterInput>;
};

export type QueryFeeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFeesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FeeSortInput>>;
  where?: InputMaybe<FeeFilterInput>;
};

export type QueryFormatTypeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFormatTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FormatTypeSortInput>>;
  where?: InputMaybe<FormatTypeFilterInput>;
};

export type QueryGroupEnrollmentArgs = {
  seqNo: Scalars['Int']['input'];
};

export type QueryGroupEnrollmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<GroupEnrollmentSortInput>>;
  where?: InputMaybe<GroupEnrollmentFilterInput>;
};

export type QueryInsuranceCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InsuranceCompanySearchResponseSortInput>>;
  where?: InputMaybe<InsuranceCompanySearchResponseFilterInput>;
};

export type QueryInsuranceCompanyArgs = {
  recId: Scalars['Int']['input'];
};

export type QueryPatientArgs = {
  patientNumber: Scalars['Long']['input'];
};

export type QueryPatientStatementsArgs = {
  patientStatementsNumber: Scalars['Long']['input'];
};

export type QueryPatientStatementssArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PatientStatementsSortInput>>;
  where?: InputMaybe<PatientStatementsFilterInput>;
};

export type QueryPatientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PatientSortInput>>;
  where?: InputMaybe<PatientFilterInput>;
};

export type QueryPayerRoutingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PayerRoutingSortInput>>;
  where?: InputMaybe<PayerRoutingFilterInput>;
};

export type QueryPayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PayerSortInput>>;
  where?: InputMaybe<PayerFilterInput>;
};

export type QueryPermissionArgs = {
  id: Scalars['Int']['input'];
};

export type QueryPermissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PermissionsSortInput>>;
  where?: InputMaybe<PermissionsFilterInput>;
};

export type QueryPreferredRoutingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PreferredRoutingSortInput>>;
  where?: InputMaybe<PreferredRoutingFilterInput>;
};

export type QueryProcessorArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryProcessorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProcessorSortInput>>;
  where?: InputMaybe<ProcessorFilterInput>;
};

export type QueryProviderArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryProviderGroupArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryProviderGroupsArgs = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProviderGroupSortInput>>;
  where?: InputMaybe<ProviderGroupFilterInput>;
};

export type QueryProvidersArgs = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProviderSortInput>>;
  where?: InputMaybe<ProviderFilterInput>;
};

export type QueryQualifiersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<QualifierSortInput>>;
  where?: InputMaybe<QualifierFilterInput>;
};

export type QueryRealtimeProcessorArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRealtimeProcessorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RealTimeProcessorSortInput>>;
  where?: InputMaybe<RealTimeProcessorFilterInput>;
};

export type QueryRecurringPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PaymentsRecurringPaymentSortInput>>;
  where?: InputMaybe<PaymentsRecurringPaymentFilterInput>;
};

export type QueryStatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<StatesSortInput>>;
  where?: InputMaybe<StatesFilterInput>;
};

export type QueryStatisticsClaimSubmitCountsArgs = {
  filter?: InputMaybe<StatisticsSearchFilterInput>;
};

export type QueryStatisticsClaimsArgs = {
  filter?: InputMaybe<StatisticsSearchFilterInput>;
};

export type QueryStatisticsClaimsInErrorCountsArgs = {
  filter?: InputMaybe<StatisticsRangeSearchFilterInput>;
};

export type QueryStatisticsEligibilityCountsArgs = {
  filter?: InputMaybe<StatisticsSearchFilterInput>;
};

export type QueryStatisticsEraCountsArgs = {
  filter?: InputMaybe<StatisticsBaseFilterInput>;
};

export type QueryStatisticsMissingClaimResponsesArgs = {
  filter?: InputMaybe<StatisticsMissingClaimResponseFilterInput>;
};

export type QueryStatisticsRevSpringCountsArgs = {
  filter?: InputMaybe<StatisticsRevSpringFilterInput>;
};

export type QuerySubmitterIdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SubmitterIdsSortInput>>;
  where?: InputMaybe<SubmitterIdsFilterInput>;
};

export type QueryUserArgs = {
  id: Scalars['Int']['input'];
};

export type QueryUserGroupsByAccountArgs = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UsersClientsSortInput>>;
  where?: InputMaybe<UsersClientsFilterInput>;
};

export type QueryUsersByGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserResponseSortInput>>;
};

export type QueryUsersWithSameAccessArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UsersClientsSortInput>>;
  where?: InputMaybe<UsersClientsFilterInput>;
};

export type QueryZipcodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ZipcodeSortInput>>;
  where?: InputMaybe<ZipcodeFilterInput>;
};

export type RealTimeProcessor = {
  __typename?: 'RealTimeProcessor';
  contactPhone?: Maybe<Scalars['String']['output']>;
  gs02?: Maybe<Scalars['String']['output']>;
  gs03?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isa01?: Maybe<Scalars['String']['output']>;
  isa02?: Maybe<Scalars['String']['output']>;
  isa03?: Maybe<Scalars['String']['output']>;
  isa04?: Maybe<Scalars['String']['output']>;
  isa05?: Maybe<Scalars['String']['output']>;
  isa06?: Maybe<Scalars['String']['output']>;
  isa07?: Maybe<Scalars['String']['output']>;
  isa08?: Maybe<Scalars['String']['output']>;
  isa11?: Maybe<Scalars['String']['output']>;
  isa12?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RealTimeProcessorFilterInput = {
  and?: InputMaybe<Array<RealTimeProcessorFilterInput>>;
  contactPhone?: InputMaybe<StringOperationFilterInput>;
  gs02?: InputMaybe<StringOperationFilterInput>;
  gs03?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isa01?: InputMaybe<StringOperationFilterInput>;
  isa02?: InputMaybe<StringOperationFilterInput>;
  isa03?: InputMaybe<StringOperationFilterInput>;
  isa04?: InputMaybe<StringOperationFilterInput>;
  isa05?: InputMaybe<StringOperationFilterInput>;
  isa06?: InputMaybe<StringOperationFilterInput>;
  isa07?: InputMaybe<StringOperationFilterInput>;
  isa08?: InputMaybe<StringOperationFilterInput>;
  isa11?: InputMaybe<StringOperationFilterInput>;
  isa12?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RealTimeProcessorFilterInput>>;
};

export type RealTimeProcessorSortInput = {
  contactPhone?: InputMaybe<SortEnumType>;
  gs02?: InputMaybe<SortEnumType>;
  gs03?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isa01?: InputMaybe<SortEnumType>;
  isa02?: InputMaybe<SortEnumType>;
  isa03?: InputMaybe<SortEnumType>;
  isa04?: InputMaybe<SortEnumType>;
  isa05?: InputMaybe<SortEnumType>;
  isa06?: InputMaybe<SortEnumType>;
  isa07?: InputMaybe<SortEnumType>;
  isa08?: InputMaybe<SortEnumType>;
  isa11?: InputMaybe<SortEnumType>;
  isa12?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type RealtimeProcessorsConnection = {
  __typename?: 'RealtimeProcessorsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RealtimeProcessorsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<RealTimeProcessor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RealtimeProcessorsEdge = {
  __typename?: 'RealtimeProcessorsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RealTimeProcessor>;
};

export type RecurringPaymentInput = {
  amount: Scalars['Decimal']['input'];
  patient_id: Scalars['Int']['input'];
  payment_plan: PaymentsRecurringPaymentPlan;
  /** The date that the user started the payment plan */
  startdate: Scalars['DateTime']['input'];
};

/** A connection to a list of items. */
export type RecurringPaymentsConnection = {
  __typename?: 'RecurringPaymentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RecurringPaymentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<PaymentsRecurringPayment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RecurringPaymentsEdge = {
  __typename?: 'RecurringPaymentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PaymentsRecurringPayment>;
};

export type RevSpingResponse = {
  __typename?: 'RevSpingResponse';
  count: Scalars['Int']['output'];
  date?: Maybe<Scalars['String']['output']>;
  mailboxId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RunCheckSaleAchResponse = {
  __typename?: 'RunCheckSaleACHResponse';
  balance_response?: Maybe<ThirdPartyBalanceResponse>;
  check?: Maybe<CheckSaleCheckResponse>;
  checkSaleId?: Maybe<Scalars['String']['output']>;
  consumer?: Maybe<ThirdPartyConsumerObject>;
  links?: Maybe<Array<Maybe<CheckSaleLinksResponse>>>;
  patientId?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<CheckSalePaymentResponse>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transaction?: Maybe<CheckSaleTransactionResponse>;
};

export type RunCheckSaleCanadaAchResponse = {
  __typename?: 'RunCheckSaleCanadaACHResponse';
  check?: Maybe<CheckSaleCheckCanadaResponse>;
  checkSaleId?: Maybe<Scalars['String']['output']>;
  links?: Maybe<CheckSaleLinksResponse>;
  payment?: Maybe<CheckSalePaymentResponse>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transaction?: Maybe<CheckSaleTransactionCanadaResponse>;
};

export type SaleResponse = {
  __typename?: 'SaleResponse';
  amount?: Maybe<Scalars['String']['output']>;
  careTrackerBalanceResponse?: Maybe<CareTrackerBalanceResponse>;
  careTrackerConsumer?: Maybe<CareTrackerConsumer>;
  currency_code?: Maybe<Scalars['String']['output']>;
  gratuity_amount?: Maybe<Scalars['String']['output']>;
  invoice_number?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  transactions?: Maybe<Array<Maybe<TransactionResponse>>>;
};

export type SecureConnectClaimStatusTypes =
  | 'ARCHIVED'
  | 'EDITS'
  | 'EDITS_FAILED'
  | 'MANUAL_REJECT';

export type SecureConnectClaimStatusTypesOperationFilterInput = {
  eq?: InputMaybe<SecureConnectClaimStatusTypes>;
  in?: InputMaybe<Array<SecureConnectClaimStatusTypes>>;
  neq?: InputMaybe<SecureConnectClaimStatusTypes>;
  nin?: InputMaybe<Array<SecureConnectClaimStatusTypes>>;
};

export type SortEnumType = 'ASC' | 'DESC';

export type States = {
  __typename?: 'States';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type StatesConnection = {
  __typename?: 'StatesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<States>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type StatesEdge = {
  __typename?: 'StatesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<States>;
};

export type StatesFilterInput = {
  and?: InputMaybe<Array<StatesFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StatesFilterInput>>;
};

export type StatesSortInput = {
  code?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
};

export type StatisticsBaseFilterInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  pms?: InputMaybe<Scalars['String']['input']>;
};

export type StatisticsClaimInErrorResponse = {
  __typename?: 'StatisticsClaimInErrorResponse';
  invalidPayerIds?: Maybe<Scalars['Int']['output']>;
  payerEdits?: Maybe<Scalars['Int']['output']>;
  rejected999s?: Maybe<Scalars['Int']['output']>;
  scClaimEdits?: Maybe<Scalars['Int']['output']>;
};

export type StatisticsClaimsMissingResponseResponse = {
  __typename?: 'StatisticsClaimsMissingResponseResponse';
  count: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type StatisticsClaimsSearchResponse = {
  __typename?: 'StatisticsClaimsSearchResponse';
  accepted: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  submitted: Scalars['Int']['output'];
  warnings: Scalars['Int']['output'];
};

export type StatisticsEraResponse = {
  __typename?: 'StatisticsEraResponse';
  receivedLastHour: Scalars['Int']['output'];
  receivedToday: Scalars['Int']['output'];
  receivedYesterday: Scalars['Int']['output'];
  undeliverable: Scalars['Int']['output'];
};

export type StatisticsMissingClaimResponseFilterInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  pms?: InputMaybe<Scalars['String']['input']>;
  submissionDate?: InputMaybe<Scalars['DateTime']['input']>;
  type: Scalars['String']['input'];
};

export type StatisticsRangeSearchFilterInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  pms?: InputMaybe<Scalars['String']['input']>;
  submissionDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDateTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StatisticsRevSpringFilterInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  balanced?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  pms?: InputMaybe<Scalars['String']['input']>;
  submissionDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDateTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StatisticsRevSpringResponse = {
  __typename?: 'StatisticsRevSpringResponse';
  collections?: Maybe<Array<Maybe<RevSpingResponse>>>;
  statements?: Maybe<Array<Maybe<RevSpingResponse>>>;
};

export type StatisticsSearchFilterInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  pms?: InputMaybe<Scalars['String']['input']>;
  submissionDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StatisticsSearchResponse = {
  __typename?: 'StatisticsSearchResponse';
  errors: Scalars['Int']['output'];
  requests: Scalars['Int']['output'];
  responses: Scalars['Int']['output'];
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitterIds = {
  __typename?: 'SubmitterIds';
  billingNpi: Scalars['String']['output'];
  dateSetup: Scalars['DateTime']['output'];
  processorId: Scalars['String']['output'];
  submitterId: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type SubmitterIdsConnection = {
  __typename?: 'SubmitterIdsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SubmitterIdsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<SubmitterIds>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SubmitterIdsEdge = {
  __typename?: 'SubmitterIdsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SubmitterIds>;
};

export type SubmitterIdsFilterInput = {
  and?: InputMaybe<Array<SubmitterIdsFilterInput>>;
  billingNpi?: InputMaybe<StringOperationFilterInput>;
  dateSetup?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<SubmitterIdsFilterInput>>;
  processorId?: InputMaybe<StringOperationFilterInput>;
  submitterId?: InputMaybe<StringOperationFilterInput>;
};

export type SubmitterIdsSortInput = {
  billingNpi?: InputMaybe<SortEnumType>;
  dateSetup?: InputMaybe<SortEnumType>;
  processorId?: InputMaybe<SortEnumType>;
  submitterId?: InputMaybe<SortEnumType>;
};

export type ThirdPartyBalanceResponse = {
  __typename?: 'ThirdPartyBalanceResponse';
  response?: Maybe<Ct_BalanceResponse>;
  tranId?: Maybe<Scalars['String']['output']>;
  transaction_id?: Maybe<Scalars['String']['output']>;
};

export type ThirdPartyBalanceResponseInput = {
  response?: InputMaybe<Ct_BalanceResponseInput>;
  tranId?: InputMaybe<Scalars['String']['input']>;
  transaction_id?: InputMaybe<Scalars['String']['input']>;
};

export type ThirdPartyConsumerObject = {
  __typename?: 'ThirdPartyConsumerObject';
  payload?: Maybe<Payload>;
};

export type ThirdPartyConsumerObjectInput = {
  payload?: InputMaybe<PayloadInput>;
};

export type ThirdPartyCookiesInput = {
  /** The issuer to use */
  issuer: Scalars['String']['input'];
  /** The user GUID */
  user: Scalars['String']['input'];
};

export type TransactionResponse = {
  __typename?: 'TransactionResponse';
  credit_attributes?: Maybe<CreditAttributesResponse>;
  debit_attributes?: Maybe<DebitAttributesResponse>;
  entry_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  reference_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_code?: Maybe<Scalars['String']['output']>;
  tender_type?: Maybe<Scalars['String']['output']>;
  transaction_datetime?: Maybe<Scalars['String']['output']>;
};

export type TwoFactorAuthenticationCodeInput = {
  /** The two factor authentication code */
  code: Scalars['String']['input'];
  /** The two factor authentication secret (used to verify initial setup) */
  secret?: InputMaybe<Scalars['String']['input']>;
};

export type TwoFactorAuthenticationInput = {
  /** The secret that the user will use to generate the 2FA code */
  secret: Scalars['String']['input'];
};

export type TwoFactorAuthenticationSecretResult = {
  __typename?: 'TwoFactorAuthenticationSecretResult';
  qrCode?: Maybe<Scalars['String']['output']>;
  secret?: Maybe<Scalars['String']['output']>;
};

export type UserResponse = {
  __typename?: 'UserResponse';
  accessLevel: AccessLevels;
  accounts?: Maybe<Array<Maybe<AccountCode>>>;
  active: Scalars['Boolean']['output'];
  applications?: Maybe<Array<Maybe<ApplicationCode>>>;
  cellPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: Scalars['Int']['output'];
  ext?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<GroupCode>>>;
  id: Scalars['Int']['output'];
  identityUserId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  passwordLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  passwordResetAllowed: Scalars['Boolean']['output'];
  permissions?: Maybe<Array<Maybe<PermissionCode>>>;
  phone?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Scalars['Int']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type UserResponseSortInput = {
  accessLevel?: InputMaybe<SortEnumType>;
  active?: InputMaybe<SortEnumType>;
  cellPhone?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  ext?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  groupId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  identityUserId?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  passwordLastUpdated?: InputMaybe<SortEnumType>;
  passwordResetAllowed?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  pin?: InputMaybe<SortEnumType>;
  role?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
};

export type UserWithGroups = {
  __typename?: 'UserWithGroups';
  firstName?: Maybe<Scalars['String']['output']>;
  groupIds?: Maybe<Array<Maybe<UsersClientsGrps>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type UsersByGroupConnection = {
  __typename?: 'UsersByGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UsersByGroupEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<UserResponse>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UsersByGroupEdge = {
  __typename?: 'UsersByGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserResponse>;
};

export type UsersClients = {
  __typename?: 'UsersClients';
  accessLevel: AccessLevels;
  /** This is the list of accounts associated to this user. */
  accounts?: Maybe<Array<Maybe<UsersClientsAccts>>>;
  active: Scalars['Boolean']['output'];
  /** This is the list of applications associated to this user. */
  applications?: Maybe<Array<Maybe<UsersClientsApps>>>;
  caseNumber?: Maybe<Scalars['String']['output']>;
  cellPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: Scalars['Int']['output'];
  ext?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  /** This is the list of groups associated to this user. */
  groups?: Maybe<Array<Maybe<UsersClientsGrps>>>;
  id: Scalars['Int']['output'];
  identityUserId?: Maybe<Scalars['String']['output']>;
  isUser: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  passwordLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  passwordResetAllowed: Scalars['Boolean']['output'];
  /** This is the list of permissions associated with the user. */
  permissions?: Maybe<Array<Maybe<UsersClientsPermissions>>>;
  phone?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

export type UsersClientsAccts = {
  __typename?: 'UsersClientsAccts';
  /** This is the Account object. */
  account?: Maybe<Account>;
  accountNumber: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  userClientId: Scalars['Int']['output'];
  usersClients?: Maybe<UsersClients>;
};

export type UsersClientsAcctsFilterInput = {
  account?: InputMaybe<AccountFilterInput>;
  accountNumber?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<UsersClientsAcctsFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<UsersClientsAcctsFilterInput>>;
  userClientId?: InputMaybe<IntOperationFilterInput>;
  usersClients?: InputMaybe<UsersClientsFilterInput>;
};

export type UsersClientsApps = {
  __typename?: 'UsersClientsApps';
  /** This is the Application object. */
  application?: Maybe<Application>;
  applicationId: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  userClientId: Scalars['Int']['output'];
  usersClients?: Maybe<UsersClients>;
};

export type UsersClientsAppsFilterInput = {
  and?: InputMaybe<Array<UsersClientsAppsFilterInput>>;
  application?: InputMaybe<ApplicationFilterInput>;
  applicationId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<UsersClientsAppsFilterInput>>;
  userClientId?: InputMaybe<IntOperationFilterInput>;
  usersClients?: InputMaybe<UsersClientsFilterInput>;
};

export type UsersClientsFilterInput = {
  accessLevel?: InputMaybe<AccessLevelsOperationFilterInput>;
  accounts?: InputMaybe<ListFilterInputTypeOfUsersClientsAcctsFilterInput>;
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<UsersClientsFilterInput>>;
  applications?: InputMaybe<ListFilterInputTypeOfUsersClientsAppsFilterInput>;
  caseNumber?: InputMaybe<StringOperationFilterInput>;
  cellPhone?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<IntOperationFilterInput>;
  ext?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  groupId?: InputMaybe<StringOperationFilterInput>;
  groups?: InputMaybe<ListFilterInputTypeOfUsersClientsGrpsFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  identityUserId?: InputMaybe<StringOperationFilterInput>;
  isUser?: InputMaybe<BooleanOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UsersClientsFilterInput>>;
  passwordLastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  passwordResetAllowed?: InputMaybe<BooleanOperationFilterInput>;
  permissions?: InputMaybe<ListFilterInputTypeOfUsersClientsPermissionsFilterInput>;
  phone?: InputMaybe<StringOperationFilterInput>;
  pin?: InputMaybe<StringOperationFilterInput>;
  role?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
};

export type UsersClientsGrps = {
  __typename?: 'UsersClientsGrps';
  /** This is the Group object. */
  group?: Maybe<ProviderGroup>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  userClientId: Scalars['Int']['output'];
  usersClients?: Maybe<UsersClients>;
};

export type UsersClientsGrpsFilterInput = {
  and?: InputMaybe<Array<UsersClientsGrpsFilterInput>>;
  group?: InputMaybe<ProviderGroupFilterInput>;
  groupId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<UsersClientsGrpsFilterInput>>;
  userClientId?: InputMaybe<IntOperationFilterInput>;
  usersClients?: InputMaybe<UsersClientsFilterInput>;
};

export type UsersClientsPermissions = {
  __typename?: 'UsersClientsPermissions';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  permission?: Maybe<Permissions>;
  permissionId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
  usersClients?: Maybe<UsersClients>;
};

export type UsersClientsPermissionsFilterInput = {
  and?: InputMaybe<Array<UsersClientsPermissionsFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UsersClientsPermissionsFilterInput>>;
  permission?: InputMaybe<PermissionsFilterInput>;
  permissionId?: InputMaybe<IntOperationFilterInput>;
  userId?: InputMaybe<IntOperationFilterInput>;
  usersClients?: InputMaybe<UsersClientsFilterInput>;
};

export type UsersClientsSortInput = {
  accessLevel?: InputMaybe<SortEnumType>;
  active?: InputMaybe<SortEnumType>;
  caseNumber?: InputMaybe<SortEnumType>;
  cellPhone?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  ext?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  groupId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  identityUserId?: InputMaybe<SortEnumType>;
  isUser?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  passwordLastUpdated?: InputMaybe<SortEnumType>;
  passwordResetAllowed?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  pin?: InputMaybe<SortEnumType>;
  role?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<UsersClients>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UsersClients>;
};

/** A connection to a list of items. */
export type UsersWithSameAccessConnection = {
  __typename?: 'UsersWithSameAccessConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UsersWithSameAccessEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<UsersClients>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UsersWithSameAccessEdge = {
  __typename?: 'UsersWithSameAccessEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UsersClients>;
};

export type Zipcode = {
  __typename?: 'Zipcode';
  active: Scalars['Boolean']['output'];
  city: Scalars['String']['output'];
  code: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  timezoneId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Scalars['Int']['output'];
};

export type ZipcodeFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ZipcodeFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ZipcodeFilterInput>>;
  state?: InputMaybe<StringOperationFilterInput>;
  timezoneId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
};

export type ZipcodeSortInput = {
  active?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  timezoneId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ZipcodesConnection = {
  __typename?: 'ZipcodesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ZipcodesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Zipcode>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ZipcodesEdge = {
  __typename?: 'ZipcodesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Zipcode>;
};

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;

export type LoginMutation = {
  __typename?: 'Mutation';
  login?:
    | {
        __typename?: 'LoginResult';
        cookie?: string | undefined;
        success: boolean;
      }
    | undefined;
};

export type LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutMutation = { __typename?: 'Mutation'; logout: boolean };

export type AddTwoFactorAuthenticationMutationVariables = Exact<{
  input: TwoFactorAuthenticationInput;
}>;

export type AddTwoFactorAuthenticationMutation = {
  __typename?: 'Mutation';
  addTwoFactorAuthentication: boolean;
};

export type CreateThirdPartyCookieMutationVariables = Exact<{
  input: ThirdPartyCookiesInput;
}>;

export type CreateThirdPartyCookieMutation = {
  __typename?: 'Mutation';
  createThirdPartyCookie?: string | undefined;
};

export type GetTwoFactorAuthenticationSecretMutationVariables = Exact<{
  [key: string]: never;
}>;

export type GetTwoFactorAuthenticationSecretMutation = {
  __typename?: 'Mutation';
  twoFactorAuthenticationSecret?:
    | {
        __typename?: 'TwoFactorAuthenticationSecretResult';
        secret?: string | undefined;
        qrCode?: string | undefined;
      }
    | undefined;
};

export type IsTwoFactorAuthenticationEnabledMutationVariables = Exact<{
  [key: string]: never;
}>;

export type IsTwoFactorAuthenticationEnabledMutation = {
  __typename?: 'Mutation';
  isTwoFactorAuthenticationEnabled: boolean;
};

export type RemoveTwoFactorAuthenticationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RemoveTwoFactorAuthenticationMutation = {
  __typename?: 'Mutation';
  removeTwoFactorAuthentication: boolean;
};

export type VerifyTwoFactorAuthenticationCodeMutationVariables = Exact<{
  input: TwoFactorAuthenticationCodeInput;
}>;

export type VerifyTwoFactorAuthenticationCodeMutation = {
  __typename?: 'Mutation';
  verifyTwoFactorAuthenticationCode: boolean;
};

export type GetProviderGroupsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  where?: InputMaybe<ProviderGroupFilterInput>;
  order?: InputMaybe<Array<ProviderGroupSortInput> | ProviderGroupSortInput>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetProviderGroupsQuery = {
  __typename?: 'Query';
  providerGroups?:
    | {
        __typename?: 'ProviderGroupsConnection';
        pageInfo: {
          __typename?: 'PageInfo';
          hasNextPage: boolean;
          endCursor?: string | undefined;
        };
        nodes?:
          | Array<
              | {
                  __typename?: 'ProviderGroup';
                  groupId: string;
                  name?: string | undefined;
                  eraFileSeqNum: number;
                  interchangeNum: number;
                  isDev: boolean;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export type GetUsersQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  where?: InputMaybe<UsersClientsFilterInput>;
  order?: InputMaybe<Array<UsersClientsSortInput> | UsersClientsSortInput>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetUsersQuery = {
  __typename?: 'Query';
  users?:
    | {
        __typename?: 'UsersConnection';
        pageInfo: {
          __typename?: 'PageInfo';
          hasPreviousPage: boolean;
          hasNextPage: boolean;
          endCursor?: string | undefined;
        };
        nodes?:
          | Array<
              | {
                  __typename?: 'UsersClients';
                  id: number;
                  userName: string;
                  firstName: string;
                  lastName?: string | undefined;
                  caseNumber?: string | undefined;
                  passwordResetAllowed: boolean;
                  passwordLastUpdated?: any | undefined;
                  active: boolean;
                  createdBy: number;
                  createdAt?: any | undefined;
                  updatedBy: number;
                  updatedAt?: any | undefined;
                  identityUserId?: string | undefined;
                  isUser: boolean;
                  role?: string | undefined;
                  groupId?: string | undefined;
                  accessLevel: AccessLevels;
                  phone?: string | undefined;
                  ext?: string | undefined;
                  pin?: string | undefined;
                  cellPhone?: string | undefined;
                  accounts?:
                    | Array<
                        | {
                            __typename?: 'UsersClientsAccts';
                            id: any;
                            userClientId: number;
                            accountNumber: string;
                            account?:
                              | {
                                  __typename?: 'Account';
                                  name: string;
                                  accountNumber: string;
                                  isActive: boolean;
                                  pms: string;
                                }
                              | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                  applications?:
                    | Array<
                        | {
                            __typename?: 'UsersClientsApps';
                            applicationId: string;
                            id: any;
                            userClientId: number;
                            application?:
                              | {
                                  __typename?: 'Application';
                                  code: string;
                                  description: string;
                                }
                              | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                  groups?:
                    | Array<
                        | {
                            __typename?: 'UsersClientsGrps';
                            id: any;
                            userClientId: number;
                            group?:
                              | {
                                  __typename?: 'ProviderGroup';
                                  groupId: string;
                                  name?: string | undefined;
                                  eraFileSeqNum: number;
                                  interchangeNum: number;
                                  isDev: boolean;
                                }
                              | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                  permissions?:
                    | Array<
                        | {
                            __typename?: 'UsersClientsPermissions';
                            permissionId: number;
                            name?: string | undefined;
                            id: number;
                            userId: number;
                          }
                        | undefined
                      >
                    | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export type GetUserQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type GetUserQuery = {
  __typename?: 'Query';
  user?:
    | {
        __typename?: 'UsersClients';
        id: number;
        userName: string;
        firstName: string;
        lastName?: string | undefined;
        caseNumber?: string | undefined;
        passwordResetAllowed: boolean;
        passwordLastUpdated?: any | undefined;
        active: boolean;
        createdBy: number;
        createdAt?: any | undefined;
        updatedBy: number;
        updatedAt?: any | undefined;
        identityUserId?: string | undefined;
        isUser: boolean;
        role?: string | undefined;
        groupId?: string | undefined;
        accessLevel: AccessLevels;
        phone?: string | undefined;
        ext?: string | undefined;
        pin?: string | undefined;
        cellPhone?: string | undefined;
        accounts?:
          | Array<
              | {
                  __typename?: 'UsersClientsAccts';
                  accountNumber: string;
                  account?:
                    | { __typename?: 'Account'; name: string }
                    | undefined;
                }
              | undefined
            >
          | undefined;
        applications?:
          | Array<
              | {
                  __typename?: 'UsersClientsApps';
                  application?:
                    | {
                        __typename?: 'Application';
                        code: string;
                        description: string;
                      }
                    | undefined;
                }
              | undefined
            >
          | undefined;
        groups?:
          | Array<
              | {
                  __typename?: 'UsersClientsGrps';
                  group?:
                    | {
                        __typename?: 'ProviderGroup';
                        groupId: string;
                        name?: string | undefined;
                      }
                    | undefined;
                }
              | undefined
            >
          | undefined;
        permissions?:
          | Array<
              | {
                  __typename?: 'UsersClientsPermissions';
                  permissionId: number;
                  name?: string | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export type GetLogginedUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetLogginedUserQuery = {
  __typename?: 'Query';
  loggedInUser?:
    | {
        __typename?: 'UsersClients';
        id: number;
        userName: string;
        firstName: string;
        lastName?: string | undefined;
        caseNumber?: string | undefined;
        passwordResetAllowed: boolean;
        passwordLastUpdated?: any | undefined;
        active: boolean;
        createdBy: number;
        createdAt?: any | undefined;
        updatedBy: number;
        updatedAt?: any | undefined;
        identityUserId?: string | undefined;
        isUser: boolean;
        role?: string | undefined;
        groupId?: string | undefined;
        accessLevel: AccessLevels;
        phone?: string | undefined;
        ext?: string | undefined;
        pin?: string | undefined;
        cellPhone?: string | undefined;
        accounts?:
          | Array<
              | {
                  __typename?: 'UsersClientsAccts';
                  accountNumber: string;
                  account?:
                    | { __typename?: 'Account'; name: string }
                    | undefined;
                }
              | undefined
            >
          | undefined;
        applications?:
          | Array<
              | {
                  __typename?: 'UsersClientsApps';
                  application?:
                    | {
                        __typename?: 'Application';
                        code: string;
                        description: string;
                      }
                    | undefined;
                }
              | undefined
            >
          | undefined;
        groups?:
          | Array<
              | {
                  __typename?: 'UsersClientsGrps';
                  id: any;
                  userClientId: number;
                  group?:
                    | {
                        __typename?: 'ProviderGroup';
                        groupId: string;
                        name?: string | undefined;
                      }
                    | undefined;
                }
              | undefined
            >
          | undefined;
        permissions?:
          | Array<
              | {
                  __typename?: 'UsersClientsPermissions';
                  permissionId: number;
                  name?: string | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export type GetUsersByGroupsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<
    | Array<InputMaybe<Scalars['String']['input']>>
    | InputMaybe<Scalars['String']['input']>
  >;
}>;

export type GetUsersByGroupsQuery = {
  __typename?: 'Query';
  usersByGroup?:
    | {
        __typename?: 'UsersByGroupConnection';
        pageInfo: {
          __typename?: 'PageInfo';
          hasNextPage: boolean;
          endCursor?: string | undefined;
        };
        nodes?:
          | Array<
              | {
                  __typename?: 'UserResponse';
                  id: number;
                  firstName?: string | undefined;
                  lastName?: string | undefined;
                  userName?: string | undefined;
                  accessLevel: AccessLevels;
                  applications?:
                    | Array<
                        | {
                            __typename?: 'ApplicationCode';
                            applicationId?: string | undefined;
                            name?: string | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                  accounts?:
                    | Array<
                        | {
                            __typename?: 'AccountCode';
                            account?: string | undefined;
                            name?: string | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                  groups?:
                    | Array<
                        | {
                            __typename?: 'GroupCode';
                            groupId?: string | undefined;
                            name?: string | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                  permissions?:
                    | Array<
                        | {
                            __typename?: 'PermissionCode';
                            id: number;
                            name?: string | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export const LoginDocument = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      cookie
      success
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class LoginGQL extends Apollo.Mutation<
  LoginMutation,
  LoginMutationVariables
> {
  document = LoginDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LogoutDocument = gql`
  mutation Logout {
    logout
  }
`;

@Injectable({
  providedIn: 'root',
})
export class LogoutGQL extends Apollo.Mutation<
  LogoutMutation,
  LogoutMutationVariables
> {
  document = LogoutDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AddTwoFactorAuthenticationDocument = gql`
  mutation AddTwoFactorAuthentication($input: TwoFactorAuthenticationInput!) {
    addTwoFactorAuthentication(input: $input)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class AddTwoFactorAuthenticationGQL extends Apollo.Mutation<
  AddTwoFactorAuthenticationMutation,
  AddTwoFactorAuthenticationMutationVariables
> {
  document = AddTwoFactorAuthenticationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateThirdPartyCookieDocument = gql`
  mutation CreateThirdPartyCookie($input: ThirdPartyCookiesInput!) {
    createThirdPartyCookie(input: $input)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateThirdPartyCookieGQL extends Apollo.Mutation<
  CreateThirdPartyCookieMutation,
  CreateThirdPartyCookieMutationVariables
> {
  document = CreateThirdPartyCookieDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTwoFactorAuthenticationSecretDocument = gql`
  mutation GetTwoFactorAuthenticationSecret {
    twoFactorAuthenticationSecret {
      secret
      qrCode
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTwoFactorAuthenticationSecretGQL extends Apollo.Mutation<
  GetTwoFactorAuthenticationSecretMutation,
  GetTwoFactorAuthenticationSecretMutationVariables
> {
  document = GetTwoFactorAuthenticationSecretDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const IsTwoFactorAuthenticationEnabledDocument = gql`
  mutation IsTwoFactorAuthenticationEnabled {
    isTwoFactorAuthenticationEnabled
  }
`;

@Injectable({
  providedIn: 'root',
})
export class IsTwoFactorAuthenticationEnabledGQL extends Apollo.Mutation<
  IsTwoFactorAuthenticationEnabledMutation,
  IsTwoFactorAuthenticationEnabledMutationVariables
> {
  document = IsTwoFactorAuthenticationEnabledDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveTwoFactorAuthenticationDocument = gql`
  mutation RemoveTwoFactorAuthentication {
    removeTwoFactorAuthentication
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveTwoFactorAuthenticationGQL extends Apollo.Mutation<
  RemoveTwoFactorAuthenticationMutation,
  RemoveTwoFactorAuthenticationMutationVariables
> {
  document = RemoveTwoFactorAuthenticationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VerifyTwoFactorAuthenticationCodeDocument = gql`
  mutation VerifyTwoFactorAuthenticationCode(
    $input: TwoFactorAuthenticationCodeInput!
  ) {
    verifyTwoFactorAuthenticationCode(input: $input)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class VerifyTwoFactorAuthenticationCodeGQL extends Apollo.Mutation<
  VerifyTwoFactorAuthenticationCodeMutation,
  VerifyTwoFactorAuthenticationCodeMutationVariables
> {
  document = VerifyTwoFactorAuthenticationCodeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProviderGroupsDocument = gql`
  query GetProviderGroups(
    $first: Int!
    $where: ProviderGroupFilterInput
    $order: [ProviderGroupSortInput!]
    $after: String
  ) {
    providerGroups(first: $first, where: $where, order: $order, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        groupId
        name
        eraFileSeqNum
        interchangeNum
        isDev
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetProviderGroupsGQL extends Apollo.Query<
  GetProviderGroupsQuery,
  GetProviderGroupsQueryVariables
> {
  document = GetProviderGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUsersDocument = gql`
  query GetUsers(
    $first: Int!
    $where: UsersClientsFilterInput
    $order: [UsersClientsSortInput!]
    $after: String
  ) {
    users(first: $first, where: $where, order: $order, after: $after) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        endCursor
      }
      nodes {
        id
        userName
        firstName
        lastName
        caseNumber
        passwordResetAllowed
        passwordLastUpdated
        active
        createdBy
        createdAt
        updatedBy
        updatedAt
        identityUserId
        isUser
        role
        groupId
        accessLevel
        phone
        ext
        pin
        cellPhone
        accounts {
          id
          userClientId
          account {
            name
            accountNumber
            isActive
            pms
          }
          accountNumber
        }
        applications {
          applicationId
          id
          userClientId
          application {
            code
            description
          }
        }
        groups {
          id
          userClientId
          group {
            groupId
            name
            eraFileSeqNum
            interchangeNum
            isDev
          }
        }
        permissions {
          permissionId
          name
          id
          userId
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUsersGQL extends Apollo.Query<
  GetUsersQuery,
  GetUsersQueryVariables
> {
  document = GetUsersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUserDocument = gql`
  query GetUser($id: Int!) {
    user(id: $id) {
      id
      userName
      firstName
      lastName
      caseNumber
      passwordResetAllowed
      passwordLastUpdated
      active
      createdBy
      createdAt
      updatedBy
      updatedAt
      identityUserId
      isUser
      role
      groupId
      accessLevel
      phone
      ext
      pin
      cellPhone
      accounts {
        account {
          name
        }
        accountNumber
      }
      applications {
        application {
          code
          description
        }
      }
      groups {
        group {
          groupId
          name
        }
      }
      permissions {
        permissionId
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserGQL extends Apollo.Query<
  GetUserQuery,
  GetUserQueryVariables
> {
  document = GetUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetLogginedUserDocument = gql`
  query GetLogginedUser {
    loggedInUser {
      id
      userName
      firstName
      lastName
      caseNumber
      passwordResetAllowed
      passwordLastUpdated
      active
      createdBy
      createdAt
      updatedBy
      updatedAt
      identityUserId
      isUser
      role
      groupId
      accessLevel
      phone
      ext
      pin
      cellPhone
      accounts {
        account {
          name
        }
        accountNumber
      }
      applications {
        application {
          code
          description
        }
      }
      groups {
        id
        userClientId
        group {
          groupId
          name
        }
      }
      permissions {
        permissionId
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetLogginedUserGQL extends Apollo.Query<
  GetLogginedUserQuery,
  GetLogginedUserQueryVariables
> {
  document = GetLogginedUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUsersByGroupsDocument = gql`
  query getUsersByGroups($first: Int!, $after: String, $groups: [String]) {
    usersByGroup(first: $first, after: $after, groups: $groups) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        firstName
        lastName
        userName
        accessLevel
        applications {
          applicationId
          name
        }
        accounts {
          account
          name
        }
        groups {
          groupId
          name
        }
        permissions {
          id
          name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUsersByGroupsGQL extends Apollo.Query<
  GetUsersByGroupsQuery,
  GetUsersByGroupsQueryVariables
> {
  document = GetUsersByGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
